// /* eslint-disable react-hooks/rules-of-hooks */
// import { React, useEffect, useState } from "react";
// import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
// import upgrade from "../../../Assets/Icons/up-range.svg";
// import downgrade from "../../../Assets/Icons/down-range.svg";
// import {
//   RightLayoutContainer,
//   PageTitleComp,
//   DetailFields,
//   ResultWrap,
//   TableLayoutData,
//   PipeDesign,
//   SolutionContainer,
//   ContentMiddle,
// } from "../../styledElements";
// import {
//   Button,
//   PageHeader,
//   Tabs,
//   Row,
//   Col,
//   Table,
//   Tooltip,
//   Radio,
//   Skeleton,
//   Collapse,
// } from "antd";
// import { Styled, RadioButtonStyle } from "../../pageStyled";
// import AlertContainer from "../../../Components/AlertBoxes/alertBox";
// import alertBlue from "../../../Assets/Icons/alertBlue.svg";
// import Iconmoon from "../../../Components/IconsFiles/icon";
// import {
//   approveRejectJobCard,
//   cancelJobCard,
//   createNewSolutionMultistage,
//   getAlgorithmCompletionStatusMultiStage,
//   getFailedGroups,
//   getIntermediateList,
//   getJobCardCylinders,
//   getJobCardsById,
//   getJobCardsByIdMultistage,
//   getJobCardsDetailsMultistage,
// } from "../../../Services/deckleMatchServices";
// import {
//   editQtyToBePlannedForReviewOrder,
//   getOrdersList,
//   getPosData,
// } from "../../../Services/orderServices";
// import moment from "moment";
// import { TableList, JobCardColorStatus } from "../../pageStyled";
// import { HaberForm } from "../../styledElements";
// import JobCardCylinderContainer from "../../../Components/JobCardCylinders/JobCardCylinderContainer";
// import warning from "../../../Assets/Icons/warning.png";
// import warningjob from "../../../Assets/Icons/warningjob.svg";
// import { ModalPopup } from "../../../Components/Modal/modal";
// import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
// import JobCardRejectDrawer from "./JobCardRejectDrawer/JobCardRejectDrawer";
// import alertGreen from "../../../Assets/Icons/alertGreen.svg";
// import alertRed from "../../../Assets/Icons/alertRed.svg";
// import { getStocksDetailsByIds } from "../../../Services/productServices";
// import ViewDeckleOrder from "../DeckleOrderDrawer/viewDeckleOrder";
// import {
//   CoversionFactorCMToUnits,
//   CoversionFactorUnitsToCM,
//   lengthUnit,
//   weightUnit,
// } from "../../../Utils/Constant/MeasurementUnitList";
// import { getUnitData } from "../../../Services/measurementService";
// import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
// import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
// import styled from "styled-components";
// import CollapsePanel from "antd/lib/collapse/CollapsePanel";
// import JobCardCylinderContainerMultistage from "../../../Components/JobCardCylinders/JobCardCylinderContainerMultistage";
// import SheetJobCardCylinderContainerMultistage from "../../../Components/JobCardCylinders/SheetJobCardCylinderContainerMultistage";
// import {
//   getJumboReelDetailsByIdForMultiStage,
//   getProductionJobCardsById,
//   changeMultiStageProductionJobCardState,
//   markCompleteRewinding,
//   markCompleteCutting,
//   getProductionJobCardsByIdMultistage,
//   changeProductionJobCardState,
//   replanJobcard,
// } from "../../../Services/productionPlanningServices";
// import PrintIcon from "../../../Assets/Icons/printer2.svg";
// import ParentReelJobCardDrawer from "../../ProductionPlanning/ProductionJobCards/JobcardDrawers/parentReelJobCardDrawer";
// import { toHandlePOName } from "../../../Utils/helper/helper";
// import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";
// import CreateNewSolutionMultistage from "../DeckleResults/createNewSolutionMultistage";
// import LottieAnimation from "../../../Lottie";
// import JobcardPrepare from "../../../Components/IconsFiles/preparing_job_card";
// const Panes = Tabs.TabPane;
// const machineType = ["rewinding", "cutting"];
// const gridViewData = [
//   {
//     label: <Iconmoon icon="grid-chart" size={20} color="#EA655B" />,
//     value: "grid",
//   },
//   { label: <Iconmoon icon="table" size={20} color="#EA655B" />, value: "list" },
// ];

// const CardShimmerStyle = styled.div`
//   .ant-card-body {
//     position: relative;
//     z-index: 0;
//     overflow: hidden;
//     height: 100%;
//     padding: 0px;
//   }
//   .ant-skeleton-element .ant-skeleton-button {
//     min-width: 0px;
//     width: 100%;
//     border-radius: 3px;
//   }
//   .ant-skeleton-element .ant-skeleton-input {
//     min-width: 0px;
//     width: 100%;
//     border-radius: 3px;
//   }
//   .ant-skeleton-element {
//     width: 100%;
//   }
//   .ant-skeleton-element .ant-skeleton-image {
//     min-width: 0px;
//     width: 100%;
//   }
// `;

// const JobcardDetailsMultistage = (props) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   let [searchParams, setSearchParams] = useSearchParams();
//   const [ordersFullFilledList, setOrdersFullFilledList] = useState([]);
//   const [ordersUnFullFilledList, setOrdersUnFullFilledList] = useState([]);
//   // const [posList, setPosList] = useState([]);
//   // console.log(location.state)
//   const [jobId, setJobId] = useState(
//     location.state ? location.state.id : searchParams.get("id")
//   );
//   const [jobCard, setJobCard] = useState();
//   const [processType, setProcessType] = useState(
//     location.state ? location.state.processType : ""
//   );
//   const [jobcardType, setJobCardType] = useState(
//     location.state ? location.state.jobcardType : ""
//   );
//   const [jobcardCode, setJobcardcode] = useState();
//   const [acceptedSolution, setAcceptedSolution] = useState({
//     name: null,
//     key: null,
//     solution: null,
//   });
//   // const [cylinderData, setCylinderData] = useState();
//   //List view state
//   // const [gridView, setGridView] = useState(true);
//   // const [cylinderColumnHead, setCylinderColumnHead] = useState([]);
//   // const [loadingColumnHead, setLoadingColumnHead] = useState(true);
//   const [solutionId, setSolutionId] = useState("1");
//   //List view state ends here
//   const [isVisibleApproveModal, setIsVisibleApproveModal] = useState(false);
//   const [visibleRejectDrawer, setVisibleRejectDrawer] = useState(false);
//   const [visibleMarkCompletedModal, setVisibleMarkCompletedModal] =
//     useState(false);
//   const [visibleCancelProduction, setVisibleCancelProduction] = useState(false);
//   const [visibleStartProduction, setVisibleStartProduction] = useState(false);
//   const [actionResponse, setActionResponse] = useState({});
//   const [reFetch, setReFetch] = useState(true);
//   const [toaster, setToaster] = useState(false);
//   const [viewOrder, setViewOrder] = useState(false);
//   const [orderDetailsList, setOrderDetailsList] = useState();
//   const [selectedOrderNo, setSelectedOrderNo] = useState();
//   const [selectedOrder, setSelectedOrder] = useState();

//   const [intermediateData, setIntermediateData] = useState([]);
//   const [isMapJumboLoading, setIsMapJumboLoading] = useState(false);
//   const [isMapCuttingLoading, setIsMapCuttingLoading] = useState(false);
//   const [jumboReelData, setJumboReelData] = useState();
//   const [cuttingJumboReelData, setCuttingJumboReelData] = useState();
//   const [isParentReelCancelled, setIsParentReelCancelled] = useState(false);
//   const [totalFulfilledOrders, setTotalFulfilledOrders] = useState(0);
//   const [totalUnfulfilledOrders, setTotalUnfulfilledOrders] = useState(0);
//   const [isFetchingData, setIsFetchingData] = useState(false);
//   const [isFetchingDataForCylinder, setIsFetchingDataForCylinder] =
//     useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isSheetView, setIsSheetView] = useState(true);
//   const [isJobcardView, setIsJobcardView] = useState(true);
//   const [isTabularView, setIsTabularView] = useState(false);
//   const [cylinderViewData, setCylinderViewData] = useState('order');
//   const [pageSize, setPageSize] = useState(10);
//   const [isApproveLoading, setIsApproveLoading] = useState(false);
//   const [isRejectLoading, setIsRejectLoading] = useState(false);
//   const [jobCardDetailsListForPrint, setJobCardDetailsListForPrint] =
//     useState();
//   const [isPrintDisabled, setIsPrintDisabled] = useState(false);
//   const [userDetails, setUserDetails] = useState(
//     JSON.parse(localStorage.getItem("user-details"))
//   );
//   const [settingsData, setSettingsData] = useState(
//     JSON.parse(localStorage.getItem("setting-data"))
//   );
//   const [activeTab, setActiveTab] = useState("1");
//   const [sizeFulfillmentDetailsList, setSizeFulfillmentDetailsList] =
//     useState();
//   const [unitData, setUnitData] = useState();
//   const [selectedParentReel, setSelectedParentReel] = useState(
//     location?.state?.parentReelId ? location?.state?.parentReelId : ""
//   );
//   const [isProduced, setIsProduced] = useState(false);
//   const [viewParentReelJobCardDrawer, setViewParentReelJobCardDrawer] =
//     useState(false);
//   const [sizeExpanded, setSizeExpanded] = useState(false);
//   const columnBlacklist =
//     settingsData?.settings?.orders_page?.tables?.jobcard_orders || [];
//   const format = settingsData?.settings?.product_spec?.format || "";
//   // const [sizeExpanded, setSizeExpanded] = useState(false);
//   // const [sizeExpanded, setSizeExpanded] = useState(false);
//   // const [sizeExpanded, setSizeExpanded] = useState(false);
//   const [orderManagementSettings, setOrderManagementSettings] = useState();
//   const [deckleManagementSettings, setDeckleManagementSettings] = useState();
//   const [jobCardDetailsList, setJobCardDetailsList] = useState([]);
//   const [createNewSolutionClicked, setCreateNewSolutionClicked] =
//     useState(false);
//   const [formValuesForStock, setFormValuesForStock] = useState({});
//   const [jobIndex, setJobIndex] = useState(0);
//   const [
//     createNewSolutionFormValuesForSizes,
//     setCreateNewSolutionFormValuesForSizes,
//   ] = useState();
//   const [optimizePartition, setOptimizePartition] = useState(false);
//   const [minimizeOverfulfillment, setMinimizeOverfulfillment] = useState(false);
//   const [isReplanClicked, setIsReplanClicked] = useState(false);
//   const [stockSizes, setStockSizes] = useState([]);
//   const [ordersIdList, setOrderIdList] = useState([]);
//   // const [solutionId, setSolutionId] = useState("1");
// const [dynamicStock, setDynamicStock] = useState([]);
//   const printJobCardDetails = () => {
//     navigate("../job-card-details/viewer/", {
//       state: {
//         jobId: jobId,
//         jobcardCode: getJCCode(jobCard.jobcard_code),
//         solution: acceptedSolution.key,
//         orderDetailsList: jobCardDetailsListForPrint,
//         type: "multiStage",
//       },
//     });
//   };

//   const getJCCode = (str) => {
//     if (str) {
//       let splittedString = str?.split("~");
//       let mergeString;
//       mergeString = splittedString?.join("");
//       return mergeString;
//     }
//   };

//   const handleViewChange = (e) => {
//     // setGridView(e.target.value);
//     if (e.target.value === "both") {
//       setIsJobcardView(true);
//       setIsSheetView(true);
//     } else if (e.target.value === "reel") {
//       setIsJobcardView(true);
//       setIsSheetView(false);
//     } else {
//       setIsJobcardView(false);
//       setIsSheetView(true);
//     }
//     // console.log("view check", e.target.value);
//   };

//   useEffect(() => {}, [isTabularView]);
//   const handleViewChangeGrid = (e) => {
//     setIsTabularView(e.target.value === "list");
//   };
//    const handleCylinderViewChange = (e) => {
//     if (e.target.value === "production") {
//       setCylinderViewData('production');
//     } else {
//       setCylinderViewData('order');
//     }
//   }
//   const filterViewData = [
//     {
//       label: (
//         <Tooltip
//           placement="bottomRight"
//           title={"View rewinding and sheeting plan"}
//           className="edit-tooltip"
//         >
//           <span
//             style={{
//               transform: "translateY(-5px)",
//               color: isJobcardView && isSheetView && "#ea655b",
//               fontFamily: "var(--sf-pro-display) !important",
//             }}
//           >
//             All
//           </span>
//           {/* <Iconmoon icon="sheet" size={20} color="#EA655B" /> */}
//         </Tooltip>
//       ),
//       value: "both",
//     },

//     {
//       label: (
//         <Tooltip
//           placement="bottomRight"
//           title={"View rewinding plan"}
//           className="edit-tooltip"
//         >
//           <Iconmoon icon="tissue-role" size={18} color="#EA655B" />
//         </Tooltip>
//       ),
//       value: "reel",
//     },
//     {
//       label: (
//         <Tooltip
//           placement="bottomRight"
//           title={"View sheeting plan"}
//           className="sheet"
//         >
//           <Iconmoon icon="sheet" size={20} color="#EA655B !important" />
//         </Tooltip>
//       ),
//       value: "sheet",
//     },
//   ];
//   const gridViewData = [
//     {
//       label: (
//         <Tooltip
//           placement="bottomRight"
//           title={"View in grid mode"}
//           className="edit-tooltip"
//         >
//           <Iconmoon icon="grid-chart" size={20} color="#EA655B" />
//         </Tooltip>
//       ),
//       value: "grid",
//     },
//     {
//       label: (
//         <Tooltip
//           placement="bottomRight"
//           title={"View in tabular mode"}
//           className="edit-tooltip"
//         >
//           <Iconmoon icon="table" size={20} color="#EA655B" />
//         </Tooltip>
//       ),
//       value: "list",
//     },
//   ];
//   const cylinderMode = [
//   {
//     label: (
//       <Tooltip
//         placement="bottomRight"
//         title={"View in order mode"}
//         className="edit-tooltip"
//       >
//         <Iconmoon icon="order-entry-icon" size={20} color="#EA655B" />

//       </Tooltip>
//     ),
//     value: "order",
//   },
//   {
//     label: (
//       <Tooltip
//         placement="bottomRight"
//         title={"View in production mode"}
//         className="edit-tooltip"
//       >
//         <Iconmoon icon="production-icon" size={20} color="#EA655B" />
//       </Tooltip>
//     ),
//     value: "production",
//   },

// ];

//   const tabChange = (key) => setActiveTab(key);
//   const approveJobCard = (jobId) => {
//     setIsApproveLoading(true);
//     approveRejectJobCard({ id: jobId, state: "approved" })
//       .then((response) => {
//         setActionResponse({ error: response.error, msg: response.msg });
//         setReFetch(true);
//       })
//       .catch((error) => {
//         setActionResponse({
//           error: error.response.data.error,
//           msg: error.response.data.msg,
//         });
//         console.log(error);
//       })
//       .finally(() => {
//         setIsApproveLoading(false);
//       });
//   };
//   const onPaginationChange = (page, pageSize, isUnfulfilled) => {
//     // console.log(page, pageSize);
//     setCurrentPage(page);
//     setPageSize(pageSize);
//     // isUnfulfilled && setIsUnfulfilledTab(true);
//   };

//   function onChange(pagination, filters, sorter, extra) {
//     // console.log("params", pagination, filters, sorter, extra);
//     if (pagination) onPaginationChange(pagination.current, pagination.pageSize);
//   }

//   useEffect(() => {
//     setPageSize(10);
//     setCurrentPage(1);
//   }, [activeTab]);
//   const showToaster = () => {
//     setToaster(true);
//     setTimeout(() => setToaster(false), 3000);
//   };

//   const approveModalShow = () => {
//     setIsVisibleApproveModal(true);
//   };

//   const approveModalClose = () => {
//     setIsVisibleApproveModal(false);
//   };

//   const approveModalConfirm = (value) => {
//     approveJobCard(value);
//     setIsVisibleApproveModal(false);
//     setReFetch(true);
//     showToaster();
//   };

//   // const showStartProductionModal = () => {
//   //   setVisibleStartProduction(true);
//   // };

//   // const closeStartProductionModal = () => {
//   //   setVisibleStartProduction(false);
//   // };

//   // const startProductionModalConfirm = (value) => {
//   //   startProduction(value);
//   //   setVisibleStartProduction(false);
//   //   setReFetch(true);
//   //   showToaster();
//   // };

//   // const showCancelProductionModal = () => {
//   //   setVisibleCancelProduction(true);
//   // };

//   // const closeCancelProductionModal = () => {
//   //   setVisibleCancelProduction(false);
//   // };

//   // const cancelProductionModalConfirm = (value) => {
//   //   cancelProduction(value);
//   //   setVisibleCancelProduction(false);
//   //   setReFetch(true);
//   //   showToaster();
//   // };

//   // const showMarkCompletedModal = () => {
//   //   setVisibleMarkCompletedModal(true);
//   // };

//   // const closeMarkCompletedModal = () => {
//   //   setVisibleMarkCompletedModal(false);
//   // };

//   // const markCompletedModalConfirm = (value) => {
//   //   markAsCompleted(value);
//   //   setVisibleMarkCompletedModal(false);
//   //   setReFetch(true);
//   //   showToaster();
//   // };

//   const showRejectDrawer = () => {
//     setVisibleRejectDrawer(true);
//   };

//   const routeChange = (record) => {
//     console.log(jobId, record.parentReel);
//     navigate("../job-card-details-multistage/print-parent-reel/pdf", {
//       state: {
//         jobId: jobId,
//         parentReel: record.parentReel,
//         machine_type: record.machine_type ? record.machine_type : "rewinder",
//       },
//     });
//   };

//   const closeRejectDrawer = () => {
//     setVisibleRejectDrawer(false);
//   };

//   const showViewDrawer = (value, record) => {
//     setSelectedOrderNo(value);
//     setSelectedOrder(record);
//     setViewOrder(true);
//   };

//   const closeViewDrawer = () => {
//     setViewOrder(false);
//   };

//   const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item.slice(1);

//   //A switch case function to return states of a job card.
//   const jobcardState = (state) => {
//     switch (state) {
//       // case "pending":
//       //   return "Pending for approval";
//       // case "approved":
//       //   return "Approved";
//       // case "rejected":
//       //   return "Rejected";
//       // case "in_production":
//       //   return "In Production";
//       // case "complete":
//       //   return "Complete";
//       case "pending":
//         return "Pending for approval";
//       case "approved":
//         return "Approved";
//       case "rejected":
//         return "Rejected";
//       case "in_production":
//         return "In Production";
//       case "cancel":
//         return "Production Cancelled";
//       case "complete":
//         return "Complete";
//       case "hold":
//         return "On Hold";
//       case "produced":
//         return "Produced";
//       case "active":
//         return "Active";
//       case "under_review":
//         return "Under Review";
//       case "cancelled":
//         return "Cancelled";
//       default:
//         return;
//     }
//   };
//   //api-call to get the details of a specific jobcard
//   const getJobCardDetailsById = async () => {
//     try {
//       const response = await getJobCardsByIdMultistage(jobId);
//       if (response?.jobcard_code) {
//         let splittedString = response?.jobcard_code?.split("~");
//         setJobcardcode(splittedString?.join(""));
//       }
//       setJobCard(response);
//       setJobCardType(response.type);
//       setProcessType(response.process_type);
//       const selectedState =
//         response.state === "complete" ||
//         response.state === "in_production" ||
//         response.state === "hold" ||
//         response.state === "cancel";
//       if (response?.jobcard.solution_1.status === "accept") {
//         // console.log("acc1", acceptedSolution);
//         setAcceptedSolution({
//           name: "Solution 1",
//           key: 1,
//           solution: response.jobcard.solution_1,
//         });
//         // console.log(response.jobcard.solution_1.data)
//         // console.log(response.state)
//         setIsParentReelCancelled(
//           response.jobcard.solution_1.data.parent_reel_cancelled &&
//             selectedState
//         );
//         setSizeFulfillmentDetails(response.jobcard.solution_1.data);
//       } else if (response?.jobcard.solution_2.status === "accept") {
//         // console.log("acc2", acceptedSolution);
//         setAcceptedSolution({
//           name: "Solution 2",
//           key: 2,
//           solution: response.jobcard.solution_2,
//         });
//         setIsParentReelCancelled(
//           response.jobcard.solution_2.data.parent_reel_cancelled &&
//             selectedState
//         );
//         setSizeFulfillmentDetails(response.jobcard.solution_2.data);
//       }
//     } catch (error) {
//       console.log("Error in accepting solution", error.response);
//     }
//   };

//   const setSizeFulfillmentDetails = (data) => {
//     const sizes = data.sizes;
//     let diameterFulfilmentArray = [];
//     data.orders?.map((order) => {
//       diameterFulfilmentArray.push(order.diameter_fulfillment);
//     });
//     let sizeFulfillmentList = sizes.map((size, index) => {
//       return {
//         key: index + 1,
//         type: "Order",
//         size: `${size.size} ${
//           size.lateral_size ? "X " + size.lateral_size : ""
//         } ${" "} ${
//           size.units && size.units.size
//             ? lengthUnit[size.units.size]?.displayName
//             : "CM"
//         }`,
//         grain: size?.grain && size?.grain !== "None" && size?.grain!=='null' && size?.grain!==null ? size?.grain : "-",
//         plannedReels: size.fulfilled + size.unfulfilled,
//         plannedWeight:
//           (size.fulfilled_weight + size.unfulfilled_weight).toFixed(3) +
//           " " +
//           (size?.units && size?.units?.fulfilled_weight
//             ? capitalize(weightUnit[size.units.fulfilled_weight]?.displayName)
//             : "T"),
//         fulflilledReels: size.fulfilled,
//         fulflilledWeight:
//           size.fulfilled_weight.toFixed(3) +
//           " " +
//           (size?.units && size?.units?.fulfilled_weight
//             ? capitalize(weightUnit[size.units.fulfilled_weight]?.displayName)
//             : "T"),
//         unFulflilledReels: size.unfulfilled,
//         unFulflilledWeight:
//           size.unfulfilled_weight.toFixed(3) +
//           " " +
//           (size?.units && size?.units?.unfulfilled_weight
//             ? capitalize(weightUnit[size.units.unfulfilled_weight]?.displayName)
//             : "T"),
//         reelSpecification: size?.diameter_fulfillment.map((diaItem) => {
//           const reelOd = diaItem.reel_od;
//           const coreId = diaItem.core_id;
//           const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
//           const fulfilledValue = diaItem.fulfilled;
//           const fulfilledWeightUnit = size?.units?.fulfilled_weight
//             ? capitalize(
//                 size.units?.fulfilled_weight
//                   ? capitalize(
//                       weightUnit[size.units.unfulfilled_weight]?.displayName
//                     )
//                   : "t"
//               )
//             : "";
//           return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue} ${
//             size?.grain && size?.grain !== "None" ? "S" : "R"
//           })\n`;
//         }),
//       };
//     });

//     setSizeFulfillmentDetailsList(sizeFulfillmentList);
//   };
//   const getIntermediateListItems = (
//     ordersList,
//     jobcard,
//     solution,
//     isNewSolution
//   ) => {
//     // console.log(jobIndex, jobCardDetailsList[jobIndex]);
//     getIntermediateList(ordersList, jobcard, solution).then((response) => {
//       // console.log(response);
//       if (!response) return;
//       // const intermediateDataTemp = response?.map((item, index) => {
//       //   const reelSpecifications = item.reel_specification?.map((spec) => {
//       //     const outerDiameters = Array.isArray(spec?.reel_od)
//       //       ? spec.reel_od.join(", ")
//       //       : spec.reel_od;
//       //     return `${outerDiameters} / ${
//       //       spec?.core_id
//       //     } (${spec?.fulfilled_weight?.toFixed(3)} ${capitalize(weightUnit[
//       //       spec?.units?.fulfilled_weight
//       //     ]?.displayName)}, ${spec.fulfilled}R)`;
//       //   });

//       //   return {
//       //     key: index,
//       //     srno: index + 1,
//       //     reel_size: `${item.reel_size} ${lengthUnit[
//       //       item.units.reel_size
//       //     ]?.displayName}`,
//       //     order_size: item.length
//       //       ? `${item.width} ${lengthUnit[
//       //           item.units.width
//       //         ]?.displayName} x ${item.length} ${lengthUnit[
//       //           item.units.length
//       //         ]?.displayName}`
//       //       : `${item.width} ${lengthUnit[
//       //           item.units.width
//       //         ]?.displayName}`,
//       //     grain: item.grain,
//       //     quantity: `${item.quantity?.toFixed(3)} ${capitalize(weightUnit[
//       //       item.units.quantity
//       //     ]?.displayName)}`,
//       //     reelSpecification: reelSpecifications?.join("\n"),
//       //   };
//       // });
//       const tempIntermediateData =
//         acceptedSolution?.solution?.data?.intermediate_reels?.map(
//           (item, index) => {
//             const reelSpecifications = item.diameter_fulfillment?.map(
//               (spec) => {
//                 const outerDiameters = Array.isArray(spec?.reel_od)
//                   ? spec.reel_od.join(", ")
//                   : spec.reel_od +
//                     " " +
//                     (item.units?.reel_od
//                       ? lengthUnit[item.units?.reel_od].displayName
//                       : "cm");
//                 return `${outerDiameters} / ${spec?.core_id} ${
//                   item?.units?.core_id
//                     ? lengthUnit[item?.units?.core_id]?.displayName
//                     : "cm"
//                 } (${spec?.fulfilled_weight?.toFixed(3)} ${
//                   item?.units?.fulfilled_weight
//                     ? capitalize(
//                         weightUnit[item?.units?.fulfilled_weight]?.displayName
//                       )
//                     : "T"
//                 }, ${spec.fulfilled_reels}R)`;
//               }
//             );
//             const cancelledQuantity = item?.cancelled_diameter_fulfillment
//               ? item?.cancelled_diameter_fulfillment
//                   ?.filter((spec) => spec.fulfilled_weight > 0)
//                   ?.map((spec) => {
//                     const outerDiameters = Array.isArray(spec?.reel_od)
//                       ? spec.reel_od.join(", ")
//                       : spec.reel_od +
//                         " " +
//                         (item.units?.reel_od
//                           ? lengthUnit[item.units?.reel_od].displayName
//                           : "cm");
//                     return `${outerDiameters} / ${spec?.core_id} ${
//                       item?.units?.core_id
//                         ? lengthUnit[item?.units?.core_id]?.displayName
//                         : "cm"
//                     } (${spec?.fulfilled_weight?.toFixed(3)} ${
//                       item?.units?.fulfilled_weight
//                         ? capitalize(
//                             weightUnit[item?.units?.fulfilled_weight]
//                               ?.displayName
//                           )
//                         : "T"
//                     }, ${spec.fulfilled_reels}R)`;
//                   })
//               : ["-"];
//             const cuttingPattern =
//               "(" +
//               item.cutting_pattern.partitions
//                 .map((item) => item.size)
//                 .join("+") +
//               ") x " +
//               item.cutting_pattern.ir_length +
//               " " +
//               (item.units?.ir_width ? item.units?.ir_width : "cm");
//             return {
//               key: index,
//               srno: index + 1,
//               reel_size: `${item.size} ${
//                 item.units?.size
//                   ? lengthUnit[item.units?.size]?.displayName
//                   : "cm"
//               }`,
//               cuttingPattern: cuttingPattern,
//               quantity: `${item.fulfilled_weight?.toFixed(3)} ${
//                 item.units?.fulfilled_weight
//                   ? capitalize(
//                       weightUnit[item.units?.fulfilled_weight]?.displayName
//                     )
//                   : "T"
//               }`,
//               reelSpecification: reelSpecifications?.join("\n"),
//               cancelledQty: cancelledQuantity?.join("\n"),
//             };
//           }
//         );
//       setIntermediateData(tempIntermediateData);

//       //setIntermediateData(intermediateDataTemp);
//     });
//   };
//   const toggleFetchingData = (isFetching) => {
//     console.log(isFetching);
//     setIsFetchingDataForCylinder(isFetching);
//   };
//   useEffect(() => {
//     console.log(isFetchingDataForCylinder);
//   }, [isFetchingDataForCylinder]);
//   useEffect(() => {
//     if (!acceptedSolution) return;
//     const ordersList = acceptedSolution?.solution?.data?.orders
//       ?.filter((order) => {
//         return order.item_type == "order";
//       })
//       .map((item) => item.order_id);
//     ordersList &&
//       getIntermediateListItems(
//         ordersList,
//         jobId,
//         acceptedSolution?.key === 1 ? "solution_1" : "solution_2"
//       );
//   }, [acceptedSolution]);

//   useEffect(() => {
//     if (acceptedSolution.solution !== null) fetchOrdersForPrint();
//   }, [acceptedSolution]);
//   const fetchOrders = async () => {
//     setIsFetchingData(true);
//     let orderList = [];
//     const ordersList = acceptedSolution.solution.data.orders
//       ?.filter((order) => {
//         return order.item_type == "order";
//       })
//       .map((item) => item.order_id);
//     const fulfilledOrdersList = acceptedSolution.solution.data.orders
//       ?.filter((order) => {
//         return order.item_type == "order" && order.fulfilled_weight > 0;
//       })
//       ?.map((item) => item.order_id);

//     const unfulfilledOrdersList = acceptedSolution.solution.data.orders
//       ?.filter((order) => {
//         return order.item_type == "order" && order.unfulfilled_weight > 0;
//       })
//       ?.map((item) => item.order_id);

//     setTotalFulfilledOrders(fulfilledOrdersList.length);
//     setTotalUnfulfilledOrders(unfulfilledOrdersList.length);
//     // console.log(tota)
//     // if()
//     const startIndex = (currentPage - 1) * pageSize;
//     const endIndex = startIndex + pageSize;

//     ordersList &&
//       (await getOrdersList([
//         // ...fulfilledOrdersList.slice(startIndex, endIndex),
//         // ...unfulfilledOrdersList.slice(startIndex, endIndex),
//         ...fulfilledOrdersList,
//         ...unfulfilledOrdersList
//       ])
//         .then((response) => {
//           orderList = response.data.map((item, index) => {
//             const orderData = acceptedSolution.solution.data.orders.filter(
//               (order) => parseFloat(order.order_id) === item.number
//             )[0];

//             // console.log(orderData);
//             let unitValue = orderData.units ? orderData.units : {};
//             unitValue["fulfilled_weight"] = unitValue?.fulfilled_weight
//               ? unitValue?.fulfilled_weight
//               : unitData.units_management.weight.default;
//             return {
//               key: index + 1,
//               pono: `${item.po}`,
//               category: item?.category,
//               sono: item?.so,
//               orderno: `${item.number}`,
//               overfulfillmentPercentage: `${(((orderData.fulfilled_weight/orderData.requirement)-1)* 100).toFixed(2)}%`,
//               type: "Order",
//               grain: item?.grain,
//               length: item?.length,
//               width: item?.width,
//               matchedGrain: orderData?.grain,
//               isReel: orderData.type === "reel",
//               productspec: item?.product_spec,
//               customercode: item.customer,
//               customername: item.customer_name,
//               customer_alias: item.customer_alias,
//               size: `${item.width}${
//                 item.length ? ` x ${item.length}` : ""
//               } ${" "} ${
//                 item?.units && item?.units?.width
//                   ? lengthUnit[item.units.width]?.displayName
//                   : "CM"
//               }`,
//               productInfo: item.product_info,
//               plannedReels: orderData.requirement,
//               plannedreel: orderData.requirement,
//               plannedWeight:
//                 orderData.requirement?.toFixed(3) +
//                 " " +
//                 (orderData?.units && orderData.units.requirement
//                   ? capitalize(
//                       weightUnit[orderData.units.requirement]?.displayName
//                     )
//                   : "T"),
//               fulflilledReels: orderData.fulfilled,
//               fulflilledWeight:
//                 orderData.fulfilled_weight.toFixed(3) +
//                 " " +
//                 (orderData?.units && orderData.units.fulfilled_weight
//                   ? capitalize(
//                       weightUnit[orderData.units.fulfilled_weight]?.displayName
//                     )
//                   : "T"),
//               unFulflilledReels: orderData.unfulfilled,
//               unFulflilledWeight:
//                 orderData.unfulfilled_weight.toFixed(3) +
//                 " " +
//                 (orderData?.units && orderData.units.unfulfilled_weight
//                   ? capitalize(
//                       weightUnit[orderData.units.unfulfilled_weight]
//                         ?.displayName
//                     )
//                   : "T"),
//               priority: jobCard.jobcard.group.orders.filter(
//                 (order) => order.order_id === item.number
//               )[0].forced,
//               deliverydate:
//                 item.category === "so"
//                   ? "-"
//                   : moment(item.delivery_date).format("DD MMM YYYY"),
//               remarks: item.remarks,
//               reel_od: item.reel_od,
//               core_id: item.core_id,
//               consignee_name: item.consignee_name,
//               consignee_code: item.consignee_code,
//               reelSpecification: orderData?.diameter_fulfillment?.map(
//                 (diaItem) => {
//                   const reelOd = diaItem.reel_od;
//                   const coreId = diaItem.core_id;
//                   const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
//                   const fulfilledValue = diaItem.fulfilled;
//                   const fulfilledWeightUnit = capitalize(
//                     orderData.units?.fulfilled_weight
//                       ? capitalize(
//                           weightUnit[orderData.units?.fulfilled_weight]
//                             .displayName
//                         )
//                       : "T"
//                   );
//                   return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R) \n`;
//                 }
//               ),
//               diameter_fulfillment: orderData?.diameter_fulfillment?.map(
//                 (diaItem, index) => {
//                   return {
//                     reel_od: diaItem.reel_od,
//                     core_id: diaItem.core_id,
//                     fulfilled_weight:
//                       diaItem.fulfilled_weight -
//                       orderData?.cancelled_diameter_fulfillment[index]
//                         ?.fulfilled_weight,
//                     fulfilled:
//                       diaItem.fulfilled -
//                       orderData?.cancelled_diameter_fulfillment[index]
//                         ?.fulfilled,
//                     fulfilledWeightUnit: orderData.units?.fulfilled_weight
//                       ? orderData.units?.fulfilled_weight
//                       : unitData.units_management.weight.default,
//                   };
//                 }
//               ),
//               cancelled_diameter_fulfillment:
//                 orderData?.cancelled_diameter_fulfillment,
//               fulfilled_quantity:
//                 orderData.fulfilled_weight - orderData.cancelled_weight,
//               units: unitValue,
//               cancelledQty: orderData?.cancelled_diameter_fulfillment
//                 ?.filter((dia) => dia.fulfilled_weight > 0)
//                 ?.map((diaItem) => {
//                   const reelOd = diaItem.reel_od;
//                   const coreId = diaItem.core_id;
//                   const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
//                   const fulfilledValue = diaItem.fulfilled;
//                   const fulfilledWeightUnit = capitalize(
//                     orderData.units?.fulfilled_weight
//                       ? capitalize(
//                           weightUnit[orderData.units?.fulfilled_weight]
//                             .displayName
//                         )
//                       : "T"
//                   );
//                   return fulfilledWeight && fulfilledValue
//                     ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue} ${
//                         orderData.type !== "reel" ? "S" : "R"
//                       })\n`
//                     : "-";
//                 }),
//             };
//           });

//           const stockSizesList = acceptedSolution.solution.data.orders
//             ?.filter((order) => {
//               return order.item_type == "stock" || order.item_type==='product_stock_size';
//             })
//             .map((item) => item.order_id);

//             const dynamicStock = acceptedSolution.solution.data.orders
//             ?.filter((order) => {
//               return (
//                 (order.item_type == "stock" || order.item_type==='product_stock_size') &&
//                 (order.creation_type === "dynamic" ||
//                   order.creation_type === "required")
//               );
//             })
//             .map((item) => {
//               return {
//                 allowedQuantity: item?.requirement,
//                 isSelected: true,
//                 ...(item.creation_type === "dynamic" && { isNew: true }),
//                 ...(item.creation_type === "required" && {
//                   isRequired: true,
//                   weight_lb: item.requirement_lb,
//                   weight_ub: item.requirement_ub,
//                   priority_stock: item.priority_stock,
//                     }),
//                      length: item.lateral_size,
//                   width: item.size,
//                   isGrainChanged: item.rotated,
//                   type: item.type,
//                   grain: item.grain,
//                   availableUnit: item.units.requirement ,
//                   stockSizeId: item.id,
//                   stockSize:
//                     item.type === "reel"
//                       ? +item.size + ' ' + lengthUnit[item.units.size].displayName.toUpperCase()
//                       : +item.size + ' ' + lengthUnit[item.units.size].displayName.toUpperCase() + " * " + +item.lateral_size + ' ' + lengthUnit[item.units.lateral_size].displayName.toUpperCase(),

//                 isEdit: false,
//                 units: {
//                   ...item.units,
//                   quantity: item?.units?.fulfilled_weight,
//                   width: item?.units?.size,
//                   length: item?.units?.lateral_size,
//                   weight_lb: item?.units?.requirement_lb,
//                   weight_ub: item?.units?.requirement_ub,
//                 },
//               };
//             });
//             setDynamicStock(dynamicStock);
//           if (stockSizesList.length > 0) {
//             getStocksDetailsByIds({ stocks: stockSizesList })
//               .then((response) => {
//                 let sizesList = response.data.map((item, index) => {
//                   const orderData =
//                     acceptedSolution.solution.data.orders.filter(
//                       (order) => order.order_id === item.id
//                     )[0];
//                   //console.log(orderData);
//                   let unitValue = orderData.units ? orderData.units : {};
//                   unitValue["fulfilled_weight"] = unitValue?.fulfilled_weight
//                     ? unitValue?.fulfilled_weight
//                     : unitData.units_management.weight.default;

//                   return {
//                     key: index + 1,
//                     pono: "-",
//                     overfulfillmentPercentage: `${(((orderData.fulfilled_weight/orderData.requirement)-1)* 100).toFixed(2)}%`,
//                     orderno: `${item.id}`,
//                     type: "Stock",
//                     grain: item?.grain,
//                     length: item?.length,
//                     width: item?.width,
//                     customercode: "-",
//                     customername: "-",
//                     customer_alias: "-",
//                     size: `${item.width}${
//                       item.length ? ` x ${item.length}` : ""
//                     } ${" "} ${
//                       item.units && item.units?.width
//                         ? lengthUnit[item.units.width]?.displayName
//                         : "CM"
//                     }`,
//                     productInfo: item.product_info,
//                     productspec: item?.product_spec,
//                     orderWeight: `${item?.weight} ${item?.units?.weight?.toUpperCase()}`,
//                     plannedReels: "-",
//                     plannedreel: orderData.requirement,
//                     plannedWeight: "-",
//                     fulflilledReels: orderData.fulfilled,
//                     fulflilledWeight:
//                       orderData.fulfilled_weight.toFixed(3) +
//                       " " +
//                       (orderData?.units && orderData.units.fulfilled_weight
//                         ? capitalize(
//                             weightUnit[orderData.units.fulfilled_weight]
//                               ?.displayName
//                           )
//                         : "T"),
//                     unFulflilledReels: "-",
//                     unFulflilledWeight: "-",
//                     priority: false,
//                     deliverydate: "-",
//                     remarks: "",
//                     reel_od: item.reel_od,
//                     core_id: item.core_id,
//                     consignee_name: "-",
//                     consignee_code: "-",
//                     consignee: item.consignee_name,
//                     reelSpecification: orderData?.diameter_fulfillment?.map(
//                       (diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[orderData.units?.fulfilled_weight]
//                             ?.displayName
//                         );
//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
//                       }
//                     ),
//                     diameter_fulfillment: orderData?.diameter_fulfillment?.map(
//                       (diaItem, index) => {
//                         return {
//                           reel_od: diaItem.reel_od,
//                           core_id: diaItem.core_id,
//                           fulfilled_weight:
//                             diaItem.fulfilled_weight -
//                             orderData?.cancelled_diameter_fulfillment[index]
//                               ?.fulfilled_weight,
//                           fulfilled:
//                             diaItem.fulfilled -
//                             orderData?.cancelled_diameter_fulfillment[index]
//                               ?.fulfilled,
//                           fulfilledWeightUnit: orderData.units?.fulfilled_weight
//                             ? orderData.units?.fulfilled_weight
//                             : unitData.units_management.weight.default,
//                         };
//                       }
//                     ),
//                     cancelled_diameter_fulfillment:
//                       orderData?.cancelled_diameter_fulfillment,
//                     fulfilled_quantity:
//                       orderData.fulfilled_weight - orderData.cancelled_weight,
//                     units: unitValue,
//                     cancelledQty: orderData?.cancelled_diameter_fulfillment
//                       ?.filter((dia) => dia.fulfilled_weight > 0)
//                       ?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           orderData.units?.fulfilled_weight
//                             ? capitalize(
//                                 weightUnit[orderData.units?.fulfilled_weight]
//                                   .displayName
//                               )
//                             : "T"
//                         );
//                         return fulfilledWeight && fulfilledValue
//                           ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue} ${
//                               orderData.type !== "reel" ? "S" : "R"
//                             })\n`
//                           : "-";
//                       }),
//                     isReel: item?.type === "reel",
//                   };
//                 });

//                 setOrderDetailsList([...orderList, ...sizesList]);
//               })
//               .catch((error) => console.log(error));
//           } else {
//             setOrderDetailsList(orderList);
//           }
//         })
//         .catch((error) => console.log(error))
//         .finally(() => {
//           setIsFetchingData(false);
//         }));
//   };
//   function calculateDeckleSize(job, isCylinder, sheet) {
//     const machine = sheet
//       ? job?.jobcard?.group?.machines[1]
//       : job?.jobcard?.group?.machines[0];

//     if (machine) {
//       const deckleSizeUB = machine.deckle_size_ub || 0;
//       const leftEdgeTrim = machine.left_edge_trim || 0;
//       const rightEdgeTrim = machine.right_edge_trim || 0;

//       const lengthUnitDisplayName =
//         lengthUnit[machine.units?.deckle_size_ub]?.displayName || "";

//       const totalValue =
//         deckleSizeUB +
//         (leftEdgeTrim + rightEdgeTrim) *
//           CoversionFactorUnitsToCM[machine.units?.right_edge_trim] *
//           CoversionFactorCMToUnits[machine.units?.deckle_size_ub];

//       const deckleSizeLB = machine.deckle_size_lb || 0;

//       let formattedTotalValue;
//       if (Number.isInteger(totalValue)) {
//         formattedTotalValue = totalValue.toFixed(0);
//       } else {
//         formattedTotalValue = totalValue.toFixed(3);
//       }
//       let formattedLB = Number.isInteger(deckleSizeLB)
//         ? deckleSizeLB
//         : deckleSizeLB?.toFixed(3);
//       return isCylinder
//         ? `${formattedLB} - ${formattedTotalValue} ${lengthUnitDisplayName}`
//         : `${formattedTotalValue} - ${formattedLB} ${lengthUnitDisplayName}`;
//     }

//     return "";
//   }

//   const fetchOrdersForPrint = async () => {
//     setIsPrintDisabled(true);
//     let orderList = [];
//     const ordersList = acceptedSolution.solution.data.orders
//       ?.filter((order) => {
//         return order.item_type == "order";
//       })
//       .map((item) => item.order_id);
//     setOrderIdList(ordersList);

//     ordersList &&
//       (await getOrdersList(ordersList)
//         .then((response) => {
//           orderList = response.data.map((item, index) => {
//             const orderData = acceptedSolution.solution.data.orders.filter(
//               (order) => parseFloat(order.order_id) === item.number
//             )[0];

//             // console.log(orderData);
//             let unitValue = orderData.units ? orderData.units : {};
//             unitValue["fulfilled_weight"] = unitValue?.fulfilled_weight
//               ? unitValue?.fulfilled_weight
//               : unitData.units_management.weight.default;
//             return {
//               key: index + 1,
//               orderType: item.type,
//               grain: item.grain,
//               length: item.length,
//               width: item.width,
//               pono: `${item.po}`,
//               category: item?.category,
//               sono: item?.so,
//               orderno: `${item.number}`,
//               type: "Order",
//               overfulfillmentPercentage: `${(((orderData.fulfilled_weight/orderData.requirement)-1)* 100).toFixed(2)}%`,
//               productspec: item?.product_spec,
//               customercode: item.customer,
//               customername: item.customer_name,
//               customer_alias: item.customer_alias,
//               size: `${item.width}${
//                 item.length ? ` x ${item.length}` : ""
//               } ${" "} ${
//                 item?.units && item?.units?.width
//                   ? lengthUnit[item.units.width]?.displayName
//                   : "CM"
//               }`,
//               matchedGrain: orderData?.grain,
//               isReel: orderData.type === "reel",
//               productInfo: item.product_info,
//               orderWeight: `${item?.weight?.toFixed(3)} ${item?.units?.weight?.toUpperCase()}`,
//               plannedReels: orderData.requirement,
//               plannedreel: orderData.requirement,
//               plannedWeight:
//                 orderData.requirement?.toFixed(3) +
//                 " " +
//                 (orderData?.units && orderData.units.requirement
//                   ? capitalize(
//                       weightUnit[orderData.units.requirement]?.displayName
//                     )
//                   : "T"),
//               fulflilledReels: orderData.fulfilled,
//               fulflilledWeight:
//                 orderData.fulfilled_weight.toFixed(3) +
//                 " " +
//                 (orderData?.units && orderData.units.fulfilled_weight
//                   ? capitalize(
//                       weightUnit[orderData.units.fulfilled_weight]?.displayName
//                     )
//                   : "T"),
//               unFulflilledReels: orderData.unfulfilled,
//               unFulflilledWeight:
//                 orderData.unfulfilled_weight.toFixed(3) +
//                 " " +
//                 (orderData?.units && orderData.units.unfulfilled_weight
//                   ? capitalize(
//                       weightUnit[orderData.units.unfulfilled_weight]
//                         ?.displayName
//                     )
//                   : "T"),
//               priority: jobCard.jobcard.group.orders.filter(
//                 (order) => order.order_id === item.number
//               )[0].forced,
//               deliverydate:
//                 item.category === "so"
//                   ? "-"
//                   : moment(item.delivery_date).format("DD MMM YYYY"),
//               remarks: item.remarks,
//               reel_od: item.reel_od,
//               core_id: item.core_id,
//               consignee_name: item.consignee_name,
//               consignee_code: item.consignee_code,
//               reelSpecification: orderData?.diameter_fulfillment?.map(
//                 (diaItem) => {
//                   const reelOd = diaItem.reel_od;
//                   const coreId = diaItem.core_id;
//                   const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
//                   const fulfilledValue = diaItem.fulfilled;
//                   const fulfilledWeightUnit = capitalize(
//                     orderData.units?.fulfilled_weight
//                       ? capitalize(
//                           weightUnit[orderData.units?.fulfilled_weight]
//                             .displayName
//                         )
//                       : "T"
//                   );
//                   return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R) \n`;
//                 }
//               ),
//               diameter_fulfillment: orderData?.diameter_fulfillment?.map(
//                 (diaItem, index) => {
//                   return {
//                     reel_od: diaItem.reel_od,
//                     core_id: diaItem.core_id,
//                     fulfilled_weight:
//                       diaItem.fulfilled_weight -
//                       orderData?.cancelled_diameter_fulfillment[index]
//                         ?.fulfilled_weight,
//                     fulfilled:
//                       diaItem.fulfilled -
//                       orderData?.cancelled_diameter_fulfillment[index]
//                         ?.fulfilled,
//                     fulfilledWeightUnit: orderData.units?.fulfilled_weight
//                       ? orderData.units?.fulfilled_weight
//                       : unitData.units_management.weight.default,
//                   };
//                 }
//               ),
//               cancelled_diameter_fulfillment:
//                 orderData?.cancelled_diameter_fulfillment,
//               fulfilled_quantity:
//                 orderData.fulfilled_weight - orderData.cancelled_weight,
//               units: unitValue,
//               cancelledQty: orderData?.cancelled_diameter_fulfillment
//                 ?.filter((dia) => dia.fulfilled_weight > 0)
//                 ?.map((diaItem) => {
//                   const reelOd = diaItem.reel_od;
//                   const coreId = diaItem.core_id;
//                   const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
//                   const fulfilledValue = diaItem.fulfilled;
//                   const fulfilledWeightUnit = capitalize(
//                     orderData.units?.fulfilled_weight
//                       ? capitalize(
//                           weightUnit[orderData.units?.fulfilled_weight]
//                             .displayName
//                         )
//                       : "T"
//                   );
//                   return fulfilledWeight && fulfilledValue
//                     ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue} ${
//                         orderData.type !== "reel" ? "S" : "R"
//                       })\n`
//                     : "-";
//                 }),
//             };
//           });

//           const stockSizesList = acceptedSolution.solution.data.orders
//             ?.filter((order) => {
//               return order.item_type == "stock" || order.item_type == "product_stock_size";
//             })
//             .map((item) => item.order_id);
//           if (stockSizesList.length > 0) {
//             getStocksDetailsByIds({ stocks: stockSizesList })
//               .then((response) => {
//                 let sizesList = response.data.map((item, index) => {
//                   const orderData =
//                     acceptedSolution.solution.data.orders.filter(
//                       (order) => order.order_id === item.id
//                     )[0];
//                   //console.log(orderData);
//                   let unitValue = orderData.units ? orderData.units : {};
//                   unitValue["fulfilled_weight"] = unitValue?.fulfilled_weight
//                     ? unitValue?.fulfilled_weight
//                     : unitData.units_management.weight.default;

//                   return {
//                     key: index + 1,
//                     pono: "-",
//                     orderno: `${item.id}`,
//                     type: "Stock",
//                     grain: item.grain,
//                     length: item.length,
//                     width: item.width,
//                     orderType: item.type,
//                     customercode: "-",
//                     customername: "-",
//                     customer_alias: "-",
//                     size: `${item.width}${
//                       item.length ? ` x ${item.length}` : ""
//                     } ${" "} ${
//                       item.units && item.units?.width
//                         ? lengthUnit[item.units.width]?.displayName
//                         : "CM"
//                     }`,
//                     productInfo: item.product_info,
//                     productspec: item?.product_spec,
//                     plannedReels: "-",
//                     plannedreel: orderData.requirement,
//                     plannedWeight: "-",
//                     fulflilledReels: orderData.fulfilled,
//                     fulflilledWeight:
//                       orderData.fulfilled_weight.toFixed(3) +
//                       " " +
//                       (orderData?.units && orderData.units.fulfilled_weight
//                         ? capitalize(
//                             weightUnit[orderData.units.fulfilled_weight]
//                               ?.displayName
//                           )
//                         : "T"),
//                     unFulflilledReels: "-",
//                     unFulflilledWeight: "-",
//                     priority: false,
//                     deliverydate: "-",
//                     remarks: "",
//                     reel_od: item.reel_od,
//                     core_id: item.core_id,
//                     consignee_name: "-",
//                     consignee_code: "-",
//                     consignee: item.consignee_name,
//                     reelSpecification: orderData?.diameter_fulfillment?.map(
//                       (diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           weightUnit[orderData.units?.fulfilled_weight]
//                             ?.displayName
//                         );
//                         return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
//                       }
//                     ),
//                     diameter_fulfillment: orderData?.diameter_fulfillment?.map(
//                       (diaItem, index) => {
//                         return {
//                           reel_od: diaItem.reel_od,
//                           core_id: diaItem.core_id,
//                           fulfilled_weight:
//                             diaItem.fulfilled_weight -
//                             orderData?.cancelled_diameter_fulfillment[index]
//                               ?.fulfilled_weight,
//                           fulfilled:
//                             diaItem.fulfilled -
//                             orderData?.cancelled_diameter_fulfillment[index]
//                               ?.fulfilled,
//                           fulfilledWeightUnit: orderData.units?.fulfilled_weight
//                             ? orderData.units?.fulfilled_weight
//                             : unitData.units_management.weight.default,
//                         };
//                       }
//                     ),
//                     cancelled_diameter_fulfillment:
//                       orderData?.cancelled_diameter_fulfillment,
//                     fulfilled_quantity:
//                       orderData.fulfilled_weight - orderData.cancelled_weight,
//                     units: unitValue,
//                     cancelledQty: orderData?.cancelled_diameter_fulfillment
//                       ?.filter((dia) => dia.fulfilled_weight > 0)
//                       ?.map((diaItem) => {
//                         const reelOd = diaItem.reel_od;
//                         const coreId = diaItem.core_id;
//                         const fulfilledWeight =
//                           diaItem.fulfilled_weight?.toFixed(3);
//                         const fulfilledValue = diaItem.fulfilled;
//                         const fulfilledWeightUnit = capitalize(
//                           orderData.units?.fulfilled_weight
//                             ? weightUnit[orderData.units?.fulfilled_weight]
//                                 .displayName
//                             : "T"
//                         );
//                         return fulfilledWeight && fulfilledValue
//                           ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue} ${
//                               orderData.type !== "reel" ? "S" : "R"
//                             })\n`
//                           : "-";
//                       }),
//                     isReel: item?.type === "reel",
//                   };
//                 });

//                 setJobCardDetailsListForPrint([...orderList, ...sizesList]);
//               })
//               .catch((error) => console.log(error));
//           } else {
//             setJobCardDetailsListForPrint(orderList);
//           }
//         })
//         .catch((error) => console.log(error))
//         .finally(() => {
//           setIsPrintDisabled(false);
//         }));
//   };

//   const showParentReelJobCard = (id, isProduced) => {
//     setSelectedParentReel(id);
//     setViewParentReelJobCardDrawer(true);
//     setIsProduced(isProduced);
//   };

//   const onCloseParentReelCancel = (id) => {
//     setViewParentReelJobCardDrawer(false);
//     // showCancelProduction(id);
//   };
//   const closeParentReelJobCard = () => {
//     setSelectedParentReel();
//     setViewParentReelJobCardDrawer(false);
//     setIsProduced(false);
//   };

//   useEffect(async () => {
//     try {
//       const unitData = await getUnitData();
//       if (!unitData.error) {
//         setUnitData(unitData.data);
//       }
//     } catch (err) {
//       console.log(err);
//     }
//     if (location.state) setSearchParams({ id: location.state.id });
//   }, []);

//   useEffect(() => {
//     if (reFetch) {
//       getJobCardDetailsById();
//       setReFetch(false);
//     }
//   }, [reFetch]);

//   useEffect(() => {
//     if (acceptedSolution.solution) fetchOrders();
//   }, [acceptedSolution, pageSize, currentPage]);
//   useEffect(async () => {
//     const orderMangSettings = await getWorkflowSettings("order_management");
//     setOrderManagementSettings(orderMangSettings.data);
//     const deckleMangSettings = await getWorkflowSettings("deckle_management");
//     setDeckleManagementSettings(deckleMangSettings?.data);
//   }, []);
//   useEffect(() => {
//     if (!orderManagementSettings) return;
//     if (orderManagementSettings.fetch_balance_quantity.value) return;
//     if (
//       jobCard?.state === "in_production" ||
//       jobCard?.state === "complete" ||
//       jobCard?.state === "hold"
//     ) {
//       for (let i = 0; i < machineType.length; i++) {
//         if (machineType[i] == "rewinding") {
//           setIsMapJumboLoading(true);
//           getJumboReelDetailsByIdForMultiStage(jobId, "rewinding")
//             .then((response) => {
//               // let isCancelDisabled = false;
//               // let holdProductionCounter = 0;
//               if (response.data.data && response.data.data.length == 0) {
//                 // isCancelDisabled = true;
//                 // setDisableCancel(true);
//                 setJumboReelData([]);
//               } else {
//                 setJumboReelData(
//                   response.data.data?.map((item) => {
//                     // if (item.status === "produced") setProducedParentReelBool(true);

//                     // if (item.status === "mapped" || item.status === "produced" || item.status === "rejected") {
//                     //   setDisableCancel(true);
//                     //   isCancelDisabled = true;
//                     // }

//                     const reelOdValue = item.reel_od
//                       ? `${item.reel_od} ${
//                           jobCard.jobcard.group.grouping_params.units &&
//                           jobCard.jobcard.group.grouping_params.units.reel_od
//                             ? lengthUnit[
//                                 jobCard.jobcard.group.grouping_params.units
//                                   .reel_od
//                               ]?.displayName.toUpperCase()
//                             : "CM"
//                         }`
//                       : "0";
//                     const coreIdValue = item.core_id
//                       ? `${item.core_id} ${
//                           jobCard.jobcard.group.grouping_params.units &&
//                           jobCard.jobcard.group.grouping_params.units.core_id
//                             ? lengthUnit[
//                                 jobCard.jobcard.group.grouping_params.units
//                                   .core_id
//                               ]?.displayName.toUpperCase()
//                             : "CM"
//                         }`
//                       : "0";

//                     // if (item.status !== 'cancel' && item.status !== 'produced') holdProductionCounter++;

//                     return {
//                       leftTrim:
//                         item.left_edge_trim +
//                         " " +
//                         (item.units.left_edge_trim
//                           ? lengthUnit[
//                               item.units.left_edge_trim
//                             ]?.displayName?.toUpperCase()
//                           : ""),
//                       rightTrim:
//                         item.right_edge_trim +
//                         " " +
//                         (item.units.right_edge_trim
//                           ? lengthUnit[
//                               item.units.right_edge_trim
//                             ]?.displayName?.toUpperCase()
//                           : ""),
//                       deckleWidth: item.deckle_width,
//                       priority: item.priority,
//                       parentReel: item.parent_reel.id,
//                       combinations: item.combinations,
//                       d_com_width:
//                         item.d_com_width +
//                         " " +
//                         (item.units.d_com_width
//                           ? lengthUnit[
//                               item.units.d_com_width
//                             ]?.displayName?.toUpperCase()
//                           : ""),
//                       trimLoss: item.trim_loss,
//                       netTrimLoss: item.net_trim_loss,
//                       deliverydate: item.earliest_delivery_date,
//                       mappedJumboRoll: item?.mapped_jumbo_reels,
//                       status:
//                         item.status === "open"
//                           ? "Not Mapped"
//                           : item.status === "cancel"
//                           ? "Cancelled"
//                           : capitalize(item.status),
//                       core_id: item.core_id,
//                       reel_od: item.reel_od,
//                       machine_type: item.machine_type,
//                       units: item.units,
//                       diaValue: `${reelOdValue} / ${coreIdValue}`,
//                       combination_no: item.combination_no,
//                       number_of_reels: item.no_of_reels,
//                       reel_length: item.reel_length,
//                       reels: item.reels,
//                       rewinder_id: item.rewinder_id,
//                     };
//                   })
//                 );
//               }
//               // if (!holdProductionCounter) setDisableHoldProduction(true);
//               // if (!isCancelDisabled) setDisableCancel(false);
//             })
//             .catch((error) => {
//               if (
//                 error?.response?.data?.msg ===
//                 "only in production jobcards are required"
//               ) {
//                 setReFetch(true);
//                 setActiveTab("1");
//               }
//             })
//             .finally(() => setIsMapJumboLoading(false));
//         } else {
//           setIsMapCuttingLoading(true);
//           getJumboReelDetailsByIdForMultiStage(jobId, "cutting")
//             .then((response) => {
//               // let isCuttingCancelDisabled = false;
//               // let holdProductionCounter = 0;
//               if (response.data.data && response.data.data.length == 0) {
//                 // isCuttingCancelDisabled = true;
//                 // setCuttingDisableCancel(true);
//                 setCuttingJumboReelData([]);
//               } else {
//                 setCuttingJumboReelData(
//                   response.data.data?.map((item) => {
//                     // if (item.status === "produced") setCuttingProducedParentReelBool(true);

//                     // if (item.status === "mapped" || item.status === "produced") {
//                     //   // setCuttingDisableCancel(true);
//                     //   isCuttingCancelDisabled = true;
//                     // }

//                     const reelOdValue = item.reel_od
//                       ? `${item.reel_od} ${
//                           jobCard.jobcard.group.grouping_params.units &&
//                           jobCard.jobcard.group.grouping_params.units.reel_od
//                             ? lengthUnit[
//                                 jobCard.jobcard.group.grouping_params.units
//                                   .reel_od
//                               ]?.displayName.toUpperCase()
//                             : "CM"
//                         }`
//                       : "0";
//                     const coreIdValue = item.core_id
//                       ? `${item.core_id} ${
//                           jobCard.jobcard.group.grouping_params.units &&
//                           jobCard.jobcard.group.grouping_params.units.core_id
//                             ? lengthUnit[
//                                 jobCard.jobcard.group.grouping_params.units
//                                   .core_id
//                               ]?.displayName.toUpperCase()
//                             : "CM"
//                         }`
//                       : "0";

//                     // if (item.status !== 'cancel' && item.status !== 'produced') holdProductionCounter++;

//                     return {
//                       leftTrim:
//                         item.left_edge_trim +
//                         " " +
//                         (item.units.left_edge_trim
//                           ? lengthUnit[
//                               item.units.left_edge_trim
//                             ]?.displayName?.toUpperCase()
//                           : ""),
//                       rightTrim:
//                         item.right_edge_trim +
//                         " " +
//                         (item.units.right_edge_trim
//                           ? lengthUnit[
//                               item.units.right_edge_trim
//                             ]?.displayName?.toUpperCase()
//                           : ""),
//                       combinations: item.combinations,
//                       d_com_width:
//                         item.d_com_width +
//                         " " +
//                         (item.units.d_com_width
//                           ? lengthUnit[
//                               item.units.d_com_width
//                             ]?.displayName?.toUpperCase()
//                           : ""),
//                       trimLoss: item.trim_loss,
//                       netTrimLoss: item.net_trim_loss,
//                       deliverydate: item.earliest_delivery_date,
//                       status:
//                         item.status === "open"
//                           ? "Not Mapped"
//                           : item.status === "cancel"
//                           ? "Cancelled"
//                           : capitalize(item.status),
//                       core_id: item.core_id,
//                       reel_od: item.reel_od,
//                       units: item.units,
//                       diaValue: `${reelOdValue} / ${coreIdValue}`,
//                       combination_no: item.combination_no,
//                       number_of_reels: item.no_of_reels,
//                       cutter_id: item.cutter_id,
//                       reel_no: item.cutting_pattern.id,
//                       parent_reel_size:
//                         item.cutting_pattern_size +
//                         " " +
//                         (item.units.reel_size
//                           ? lengthUnit[
//                               item.units.reel_size
//                             ]?.displayName?.toUpperCase()
//                           : ""),
//                       quantity:
//                         item?.cutting_pattern?.weight?.toFixed(3) +
//                         " " +
//                         (item?.cutting_pattern?.units?.weight
//                           ? capitalize(
//                               weightUnit[item?.cutting_pattern?.units?.weight]
//                                 ?.displayName
//                             )
//                           : ""),
//                       cutting_pattern: item.cutting_pattern,
//                       cutter_type: item.cutter_type,
//                       length: item.length,
//                       left_length: item.left_length,
//                       right_length: item.right_length,
//                       priority: item.priority,
//                       machine_type: item.machine_type,
//                     };
//                   })
//                 );
//               }
//               // if (!holdProductionCounter) setDisableCuttingHoldProduction(true);
//               // if (!isCuttingCancelDisabled) setCuttingDisableCancel(false);
//             })
//             .catch((error) => {
//               if (
//                 error?.response?.data?.msg ===
//                 "only in production jobcards are required"
//               ) {
//                 setReFetch(true);
//                 setActiveTab("1");
//               }
//             })
//             .finally(() => setIsMapCuttingLoading(false));
//         }
//       }
//     }
//   }, [jobCard]);

//   // Column heads
//   // const columnsHead = [
//   //   {
//   //     title: "Po/So.No",
//   //     dataIndex: "pono",
//   //     width: "8%",
//   //     fixed: "left",
//   //     align: "center",
//   //     render: (text, record) => {
//   //       const value =
//   //         record.category === "po"
//   //           ? toHandlePOName(record.pono)
//   //           : record.category === "so"
//   //           ? toHandlePOName(record.sono)
//   //           : toHandlePOName(record.pono);

//   //       return (
//   //         <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" }}>
//   //           {value
//   //             ?.match(/.{1,15}/g)
//   //             ?.map((chunk, index) => (
//   //               <span key={index}>
//   //                 {chunk}
//   //                 <br />
//   //               </span>
//   //             ))}
//   //         </span>
//   //       );
//   //     }

//   //   },
//   //   {
//   //     title: "Order No/Stock No",
//   //     dataIndex: "orderno",
//   //     width: "9%",
//   //     fixed: "left",
//   //   },
//   //   {
//   //     title: "Type",
//   //     dataIndex: "type",
//   //     width: "6%",
//   //     fixed: "left",
//   //   },
//   //   {
//   //     title: "Customer",
//   //     dataIndex: "customer_alias",
//   //     width: "9%",
//   //     align: "left",
//   //     render: (text, record) => (
//   //       <div className="actionBtn2">
//   //         <Styled>
//   //           <Tooltip
//   //             placement="bottomRight"
//   //             title={`${record.customercode}-${record.customername}`}
//   //             className="edit-tooltip"
//   //             getPopupContainer={(triggerNode) => triggerNode}
//   //           >
//   //             {record?.customer_alias||'-'}
//   //           </Tooltip>
//   //         </Styled>
//   //       </div>
//   //     ),
//   //   },
//   //   {
//   //     title: "Consignee",
//   //     dataIndex: "consignee_name",
//   //     width: "10%",
//   //     render: (text, record) => (
//   //       record?.consignee_name||'-'
//   //     )
//   //   },
//   //   {
//   //     title: (
//   //       <div>
//   //         Product Spec
//   //         <Styled style={{ display: "inline-flex" }}>
//   //           <Tooltip
//   //             placement="bottomRight"
//   //             title={
//   //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
//   //             }
//   //             className="edit-tooltip"
//   //             getPopupContainer={(triggerNode) => triggerNode}
//   //           >
//   //             <span className="infoIcon"></span>
//   //           </Tooltip>
//   //         </Styled>
//   //       </div>
//   //     ),
//   //     dataIndex: "productspec",
//   //     width: "14%",
//   //   },
//   //   {
//   //     title: "Size(WxL)",
//   //     dataIndex: "size",
//   //     width: "9%",
//   //   },
//   //   // {
//   //   //   title: "Planned Reels",
//   //   //   dataIndex: "plannedReels",
//   //   //   width: "8%",
//   //   //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
//   //   // },
//   //   {
//   //     title: "Matched Grain",
//   //     dataIndex: "matchedGrain",
//   //     width: "10%",
//   //     render: (text, record) => (!record.isReel ? <div>{text}</div> : "-"),
//   //   },
//   //   {
//   //     title: "Planned Quantity",
//   //     dataIndex: "plannedWeight",
//   //     width: "10%",
//   //   },
//   //   // {
//   //   //   title: "Fulfilled Reels",
//   //   //   dataIndex: "fulflilledReels",
//   //   //   width: "8%",
//   //   //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
//   //   // },
//   //   {
//   //     title: "Fulfilled Quanitity",
//   //     dataIndex: "fulflilledWeight",
//   //     width: "10%",
//   //   },
//   //   // {
//   //   //   title: "Type",
//   //   //   dataIndex: "type",
//   //   //   width: "5%",
//   //   // },
//   //   {
//   //     title: "REEL SPECIFICATION",
//   //     dataIndex: "reelSpecification",
//   //     width: "22%",
//   //     render: (text, record) =>
//   //       record.isReel ? (
//   //         <div
//   //           dangerouslySetInnerHTML={{
//   //             __html: String(text).replace(/\n/g, "<br />"),
//   //           }}
//   //         />
//   //       ) : (
//   //         "-"
//   //       ),
//   //   },
//   //   {
//   //     title: "Del Date",
//   //     dataIndex: "deliverydate",
//   //     width: "10%",
//   //   },

//   //   {
//   //     title: "Cancelled Quantity",
//   //     dataIndex: "cancelledQty",
//   //     width: "22%",
//   //     render: (text) =>
//   //       isParentReelCancelled ? (
//   //         <div
//   //           dangerouslySetInnerHTML={{
//   //             __html: String(text).replace(/\n/g, "<br />"),
//   //           }}
//   //         />
//   //       ) : (
//   //         "-"
//   //       ),
//   //   },
//   //   {
//   //     title: "Remarks",
//   //     dataIndex: "remarks",
//   //     width: "8%",
//   //     render: (text, record) =>
//   //       record.type === "Order" && (
//   //         <div className="actionBtn">
//   //           <Styled>
//   //             <Tooltip
//   //               placement="bottomRight"
//   //               title={record.remarks}
//   //               className="edit-tooltip"
//   //               getPopupContainer={(triggerNode) => triggerNode}
//   //             >
//   //               <Button style={{ cursor: "default" }}>
//   //                 <Iconmoon icon="message" size={16} color="#EA655B" />
//   //               </Button>
//   //             </Tooltip>
//   //           </Styled>
//   //         </div>
//   //       ),
//   //     align: "center",
//   //   },
//   //   {
//   //     title: "Actions",
//   //     dataIndex: "action",
//   //     width: "8%",
//   //     render: (text, record) =>
//   //       record.type === "Order" && (
//   //         <div className="actionBtn">
//   //           <Styled>
//   //             <Tooltip
//   //               placement="bottomRight"
//   //               title={"View details of this order"}
//   //               className="edit-tooltip"
//   //               getPopupContainer={(triggerNode) => triggerNode}
//   //             >
//   //               <Button onClick={() => showViewDrawer(record.orderno,record)}>
//   //                 <Iconmoon icon="file-view" size={16} color="#A19F9D" />
//   //               </Button>
//   //             </Tooltip>
//   //           </Styled>
//   //         </div>
//   //       ),
//   //     align: "center",
//   //   },
//   // ];

//   const intermediateColumnsHead = [
//     {
//       title: "Sr.No",
//       dataIndex: "srno",
//       width: 6,
//       fixed: "left",
//       align: "center",
//     },
//     {
//       title: "Reel Size",
//       dataIndex: "reel_size",
//       width: 8,
//       // fixed: "left",
//       align: "center",
//     },
//     {
//       title: "Cutting Pattern",
//       dataIndex: "cuttingPattern",
//       width: 10,
//       align: "center",
//     },
//     // {
//     //   title: "",
//     //   dataIndex: "grain",
//     //   width: 8,
//     //   align: "center",
//     // },
//     {
//       title: "Quantity",
//       dataIndex: "quantity",
//       width: 8,
//       align: "center",
//     },
//     {
//       title: "REEL SPECIFICATION",
//       dataIndex: "reelSpecification",
//       width: 16,
//       align: "center",
//       render: (text) => (
//         <div
//           dangerouslySetInnerHTML={{
//             __html: String(text).replace(/\n/g, "<br />"),
//           }}
//         />
//       ),
//     },
//     {
//       title: "Cancelled Quantity",
//       dataIndex: "cancelledQty",
//       width: 16,
//       align: "center",
//       render: (text) =>
//         isParentReelCancelled ? (
//           <div
//             dangerouslySetInnerHTML={{
//               __html: String(text).replace(/\n/g, "<br />"),
//             }}
//           />
//         ) : (
//           "-"
//         ),
//     },
//   ];

//   // const unfulfilledColumnsHead = [
//   //   {
//   //     title: "Po/So.No",
//   //     dataIndex: "pono",
//   //     width: "7%",
//   //     fixed: "left",
//   //     align: "center",
//   //     render: (text, record) => {
//   //       const value =
//   //         record.category === "po"
//   //           ? toHandlePOName(record.pono)
//   //           : record.category === "so"
//   //           ? toHandlePOName(record.sono)
//   //           : toHandlePOName(record.pono);

//   //       return (
//   //         <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" }}>
//   //           {value
//   //             ?.match(/.{1,15}/g)
//   //             ?.map((chunk, index) => (
//   //               <span key={index}>
//   //                 {chunk}
//   //                 <br />
//   //               </span>
//   //             ))}
//   //         </span>
//   //       );
//   //     }

//   //   },
//   //   {
//   //     title: "Order No/Stock No",
//   //     dataIndex: "orderno",
//   //     width: "7%",
//   //     fixed: "left",
//   //   },
//   //   {
//   //     title: "Type",
//   //     dataIndex: "type",
//   //     width: "7%",
//   //     fixed: "left",
//   //   },
//   //   {
//   //     title: "Customer",
//   //     dataIndex: "customer_alias",
//   //     width: "10%",
//   //     align: "left",
//   //     render: (text, record) => (
//   //       <div className="actionBtn2">
//   //         <Styled>
//   //           <Tooltip
//   //             placement="bottomRight"
//   //             title={`${record.customercode}-${record.customername}`}
//   //             className="edit-tooltip"
//   //             getPopupContainer={(triggerNode) => triggerNode}
//   //           >
//   //             {record?.customer_alias||'-'}
//   //           </Tooltip>
//   //         </Styled>
//   //       </div>
//   //     ),
//   //   },
//   //   {
//   //     title: "Consignee",
//   //     dataIndex: "consignee_name",
//   //     width: "10%",
//   //     render: (text, record) => (
//   //       record?.consignee_name||'-'
//   //     )
//   //   },
//   //   {
//   //     title: (
//   //       <div>
//   //         Product Spec
//   //         <Styled style={{ display: "inline-flex" }}>
//   //           <Tooltip
//   //             placement="bottomRight"
//   //             title={
//   //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
//   //             }
//   //             className="edit-tooltip"
//   //             getPopupContainer={(triggerNode) => triggerNode}
//   //           >
//   //             <span className="infoIcon"></span>
//   //           </Tooltip>
//   //         </Styled>
//   //       </div>
//   //     ),
//   //     dataIndex: "productspec",
//   //     width: "14%",
//   //   },
//   //   {
//   //     title: "Size(WxL)",
//   //     dataIndex: "size",
//   //     width: "9%",
//   //   },
//   //   // {
//   //   //   title: "Planned Reels",
//   //   //   dataIndex: "plannedReels",
//   //   //   width: "8%",
//   //   //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
//   //   // },
//   //   {
//   //     title: "Matched Grain",
//   //     dataIndex: "matchedGrain",
//   //     width: "8%",
//   //     render: (text, record) => `${!record.isReel ? text : "-"}`,
//   //   },
//   //   {
//   //     title: "Planned Quantity",
//   //     dataIndex: "plannedWeight",
//   //     width: "10%",
//   //   },
//   //   // {
//   //   //   title: "Unfulfilled Reels",
//   //   //   dataIndex: "unFulflilledReels",
//   //   //   width: "8%",
//   //   //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
//   //   // },
//   //   {
//   //     title: "Unfulfilled Quantity",
//   //     dataIndex: "unFulflilledWeight",
//   //     width: "10%",
//   //   },
//   //   // {
//   //   //   title: "Type",
//   //   //   dataIndex: "type",
//   //   //   width: "5%",
//   //   // },
//   //   {
//   //     title: "Del Date",
//   //     dataIndex: "deliverydate",
//   //     width: "10%",
//   //   },
//   //   {
//   //     title: "Remarks",
//   //     dataIndex: "remarks",
//   //     width: "8%",
//   //     render: (text, record) => (
//   //       <div className="actionBtn">
//   //         <Styled>
//   //           <Tooltip
//   //             placement="bottomRight"
//   //             title={record.remarks}
//   //             className="edit-tooltip"
//   //             getPopupContainer={(triggerNode) => triggerNode}
//   //           >
//   //             <Button style={{ cursor: "default" }}>
//   //               <Iconmoon icon="message" size={16} color="#EA655B" />
//   //             </Button>
//   //           </Tooltip>
//   //         </Styled>
//   //       </div>
//   //     ),
//   //     align: "center",
//   //   },
//   //   {
//   //     title: "Actions",
//   //     dataIndex: "action",
//   //     width: "7%",
//   //     render: (text, record) => (
//   //       <div className="actionBtn">
//   //         <Styled>
//   //           <Tooltip
//   //             placement="bottomRight"
//   //             title={"View details of this order"}
//   //             className="edit-tooltip"
//   //             getPopupContainer={(triggerNode) => triggerNode}
//   //           >
//   //             <Button onClick={() => showViewDrawer(record.orderno,record)}>
//   //               <Iconmoon icon="file-view" size={16} color="#A19F9D" />
//   //             </Button>
//   //           </Tooltip>
//   //         </Styled>
//   //       </div>
//   //     ),
//   //     align: "center",
//   //   },
//   // ];

//   const sizeFulfillmentColumnsHead = [
//     {
//       title: "Sr.No",
//       dataIndex: "key",
//       width: "7%",
//       fixed: "left",
//       align: "center",
//     },
//     // {
//     //   title: "Type",
//     //   dataIndex: "type",
//     //   width: "7%",
//     //   fixed: "left",
//     // },
//     {
//       title: "Size(WxL)",
//       dataIndex: "size",
//       width: "9%",
//     },
//     {
//       title: "Matched Grain",
//       dataIndex: "grain",
//       width: "10%",
//       // render: (record, text) => (
//       //   record.type == 'Sheet' ?
//       // )
//     },
//     {
//       title: "Planned Quantity",
//       dataIndex: "plannedWeight",
//       width: "10%",
//     },
//     {
//       title: "Fulfilled Quantity",
//       dataIndex: "fulflilledWeight",
//       width: "10%",
//     },
//     {
//       title: "UnFulfilled/(Overfulfilled) Quantity",
//       dataIndex: "unFulflilledWeight",
//       width: "10%",
//       render: (text, record) => {
//         const parsedValue = parseFloat(text?.split(" ")[0]);
//         const positiveValue = Math.abs(parsedValue);
//         return parsedValue < 0 ? (
//           <div>
//             ({positiveValue} {text?.split(" ")[1]})
//           </div>
//         ) : (
//           text
//         );
//       },
//     },
//     {
//       title: "REEL SPECIFICATION",
//       dataIndex: "reelSpecification",
//       width: "20%",
//       render: (text) => (
//         <div
//           dangerouslySetInnerHTML={{
//             __html: String(text).replace(/\n/g, "<br />"),
//           }}
//         />
//       ),
//     },
//     // {
//     //   title: "Planned Reels",
//     //   dataIndex: "plannedReels",
//     //   width: "8%",
//     //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
//     // },
//     // {
//     //   title: "Fulfilled Reels",
//     //   dataIndex: "fulflilledReels",
//     //   width: "8%",
//     //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
//     // },
//     // {
//     //   title: "Unfulfilled Reels",
//     //   dataIndex: "unFulflilledReels",
//     //   width: "8%",
//     //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
//     // },
//   ];

//   const mapRewindingColumnsHead = [
//     {
//       title: "Com No",
//       dataIndex: "combination_no",
//       width: 5,
//       fixed: "left",
//       align: "center",
//     },
//     {
//       title: "Combination",
//       dataIndex: "combinations",
//       width: 10,
//       // sorter: {
//       //   compare: (a, b) => {},
//       // },
//       render: (text, record) => (
//         <div className="combination-rl">
//           {record.machine_type !== "cutter" ? (
//             <h4>
//               {text?.map(
//                 (item, index, array) =>
//                   `${item.width} ${index + 1 !== array.length ? "+" : ""}`
//               )}{" "}
//               {record?.combinations[0]?.units?.width
//                 ? lengthUnit[
//                     record?.combinations[0]?.units?.width
//                   ]?.displayName?.toUpperCase()
//                 : ""}
//               {record.priority && <span dataset="Priority">Priority</span>}
//             </h4>
//           ) : (
//             <h4>
//               {`(`}
//               {text?.map(
//                 (item, index) =>
//                   `${item.width} ${index + 1 !== text.length ? "+" : ""}`
//               )}{" "}
//               {`) X ${text[0].length}`}{" "}
//               {record?.combinations[0]?.units?.width
//                 ? lengthUnit[
//                     record?.combinations[0]?.units?.width
//                   ]?.displayName?.toUpperCase()
//                 : ""}
//               {record.priority && <span dataset="Priority">Priority</span>}
//             </h4>
//           )}

//           {record.core_id &&
//           record.reel_od &&
//           record.machine_type !== "cutter" ? (
//             <p>Parent Reel: {record.parentReel}</p>
//           ) : (
//             <p>Parent Set: {record.parentReel}</p>
//           )}
//         </div>
//       ),
//     },
//     {
//       title: "D.Com Width",
//       dataIndex: "d_com_width",
//       width: 5,
//       align: "center",
//     },
//     {
//       title: "Reel OD/ Core OD",
//       dataIndex: "diaValue",
//       width: 5,
//       align: "center",
//     },
//     {
//       title: "Left Edge Trim",
//       dataIndex: "leftTrim",
//       width: 5,
//       align: "center",
//     },
//     {
//       title: "Right Edge Trim",
//       dataIndex: "rightTrim",
//       width: 5,
//       align: "center",
//     },
//     {
//       title: "Trim",
//       dataIndex: "trimLoss",
//       width: 5,
//       align: "center",
//       render: (text, record) =>
//         `${text.toFixed(3)} ${" "} ${
//           record?.units && record?.units?.trim_loss
//             ? lengthUnit[record.units.trim_loss]?.displayName?.toUpperCase()
//             : "CM"
//         }`,
//     },
//     {
//       title: (
//         <div>
//           Net Trim
//           <Styled style={{ display: "inline-flex" }}>
//             <Tooltip
//               placement="bottomRight"
//               title={"Net trim loss including the edge trim"}
//               className="edit-tooltip"
//               getPopupContainer={(triggerNode) => triggerNode}
//             >
//               <span className="infoIcon"></span>
//             </Tooltip>
//           </Styled>
//         </div>
//       ),
//       dataIndex: "netTrimLoss",
//       width: 5,
//       align: "center",
//       render: (text, record) =>
//         `${text.toFixed(3)} ${" "} ${
//           record?.units && record?.units?.net_trim_loss
//             ? lengthUnit[record.units.net_trim_loss]?.displayName?.toUpperCase()
//             : "CM"
//         }`,
//     },
//     {
//       title: (
//         <div>
//           Earliest Delivery <br /> Date
//         </div>
//       ),
//       dataIndex: "deliverydate",
//       width: 10,
//       align: "center",
//       sorter: {
//         compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
//       },
//       render: (text) => moment(text).format("DD MMM YYYY"),
//     },
//     {
//       title: "Mapped Jumbo Roll",
//       dataIndex: "mappedJumboRoll",
//       width: 10,
//       align: "center",
//       render: (text) => {
//         return text.length === 0
//           ? "-"
//           : text?.map(
//               (item, index, array) =>
//                 `${item.number}${index + 1 != array.length ? ", " : ""}`
//             );
//       },
//     },
//     {
//       title: "Production status",
//       dataIndex: "status",
//       width: 10,
//       render: (text, record) => (
//         <div className="statusVal" dataval={record.status}>
//           <Styled>
//             <Tooltip
//               placement="bottomRight"
//               title={
//                 record.reel_od && record.core_id
//                   ? text === "Produced"
//                     ? "The production of this parent reel is completed"
//                     : text === "Mapped"
//                     ? "This parent reel is mapped to jumbo roll for rewinding"
//                     : text === "Not Mapped"
//                     ? "This parent reel is not mapped to jumbo roll yet"
//                     : text === "Cancelled"
//                     ? "The production of this parent reel is cancelled"
//                     : null
//                   : text === "Produced"
//                   ? " The production of this parent set is completed"
//                   : text === "Mapped"
//                   ? "The parent set has been mapped to a jumbo roll"
//                   : text === "Not Mapped"
//                   ? "The parent set is not mapped to a jumbo roll yet"
//                   : text === "Cancelled"
//                   ? "The production of this parent set is cancelled"
//                   : text === "Rejected"
//                   ? "The production of this parent set is rejected "
//                   : null
//               }
//               className="edit-tooltip"
//               getPopupContainer={(triggerNode) => triggerNode}
//             >
//               {text}
//             </Tooltip>
//           </Styled>
//         </div>
//       ),
//       align: "center",
//     },
//     {
//       title: "ACTIONS",
//       dataIndex: "action",
//       width: "13%",
//       align: "center",
//       render: (text, record) => (
//         <div
//           className="actionBtn"
//           style={{ display: "flex", justifyContent: "end" }}
//         >
//           {record.status == "Mapped" &&
//             jobCard.state !== "hold" &&
//             jobCard.state !== "complete" && (
//               <Styled>
//                 <Tooltip
//                   placement="bottomRight"
//                   title={"Print details of the parent reel"}
//                   className="edit-tooltip"
//                   getPopupContainer={(triggerNode) => triggerNode}
//                 >
//                   <Button onClick={() => routeChange(record)}>
//                     <img style={{ width: "20px" }} src={PrintIcon} />
//                   </Button>
//                 </Tooltip>
//               </Styled>
//             )}
//           <Styled>
//             <Tooltip
//               placement="bottomRight"
//               title={"View parent reel details"}
//               className="edit-tooltip"
//               getPopupContainer={(triggerNode) => triggerNode}
//             >
//               <Button
//                 onClick={() =>
//                   showParentReelJobCard(
//                     record.parentReel,
//                     record.status === "Produced" || record.status === "Rejected"
//                   )
//                 }
//               >
//                 <Iconmoon icon="file-view" size={16} color="#605E5C" />
//               </Button>
//             </Tooltip>
//           </Styled>
//         </div>
//       ),
//     },
//   ];

//   const mapCuttingColumnsHead = [
//     {
//       title: "Com No.",
//       dataIndex: "combination_no",
//       width: 5,
//       fixed: "left",
//       align: "center",
//     },
//     {
//       title: "Combination",
//       dataIndex: "combinations",
//       width: 10,
//       fixed: "left",
//       align: "center",
//       render: (text, record) => {
//         let leftPartitionData = "( ";
//         let rightPartitionData = "( ";
//         if (processType == "duplex") {
//           text?.forEach((order, index) => {
//             if (order.position === "left")
//               leftPartitionData = leftPartitionData + order.width + " + ";
//             else rightPartitionData = rightPartitionData + order.width + " + ";
//           });

//           let leftData = text.filter((order) => order.position === "left");
//           let rightData = text.filter((order) => order.position === "right");

//           if (leftData.length && rightData.length) {
//             leftPartitionData = leftPartitionData.substring(
//               0,
//               leftPartitionData.length - 2
//             );
//             leftPartitionData =
//               leftPartitionData + ") x " + record.left_length + " + ";
//             rightPartitionData = rightPartitionData.substring(
//               0,
//               rightPartitionData.length - 2
//             );
//             rightPartitionData =
//               rightPartitionData + ") x " + record.right_length;
//           }

//           if (!leftData.length) {
//             leftPartitionData = "";
//             rightPartitionData = rightPartitionData.substring(
//               0,
//               rightPartitionData.length - 2
//             );
//             rightPartitionData =
//               rightPartitionData + ") x " + record.right_length;
//           }

//           if (!rightData.length) {
//             rightPartitionData = "";
//             leftPartitionData = leftPartitionData.substring(
//               0,
//               leftPartitionData.length - 2
//             );
//             leftPartitionData = leftPartitionData + ") x " + record.left_length;
//           }
//         }
//         let partitionData = leftPartitionData + rightPartitionData;

//         return (
//           <div className="combination-rl">
//             {processType != "duplex" ? (
//               <h4>
//                 {`(`}
//                 {text?.map(
//                   (item, index) =>
//                     `${item.width} ${index + 1 !== text.length ? "+" : ""}`
//                 )}{" "}
//                 {`) X ${record.length}`}{" "}
//                 {record?.combinations[0]?.units?.width
//                   ? lengthUnit[
//                       record?.combinations[0]?.units?.width
//                     ]?.displayName?.toUpperCase()
//                   : ""}
//                 {record.priority && <span dataset="Priority">Priority</span>}
//               </h4>
//             ) : (
//               <h4>
//                 {`${partitionData}${" "}
//                       ${
//                         record?.combinations[0]?.units?.width
//                           ? lengthUnit[
//                               record?.combinations[0]?.units?.width
//                             ]?.displayName?.toUpperCase()
//                           : ""
//                       }`}
//                 {record.priority && <span dataset="Priority">Priority</span>}
//               </h4>
//             )}
//           </div>
//         );
//       },
//     },
//     {
//       title: "D.Com Width",
//       dataIndex: "d_com_width",
//       width: 5,
//       align: "center",
//     },
//     {
//       title: "Quantity",
//       dataIndex: "quantity",
//       width: 7,
//       align: "center",
//     },
//     {
//       title: "Left Edge Trim",
//       dataIndex: "leftTrim",
//       width: 5,
//       align: "center",
//     },
//     {
//       title: "Right Edge Trim",
//       dataIndex: "rightTrim",
//       width: 5,
//       align: "center",
//     },
//     {
//       title: "Trim",
//       dataIndex: "trimLoss",
//       width: 5,
//       align: "center",
//       render: (text, record) =>
//         `${text.toFixed(3)} ${" "} ${
//           record?.units && record?.units?.trim_loss
//             ? lengthUnit[record.units.trim_loss]?.displayName?.toUpperCase()
//             : "CM"
//         }`,
//     },
//     {
//       title: (
//         <div>
//           Net Trim
//           <Styled style={{ display: "inline-flex" }}>
//             <Tooltip
//               placement="bottomRight"
//               title={"Net trim loss including the edge trim"}
//               className="edit-tooltip"
//               getPopupContainer={(triggerNode) => triggerNode}
//             >
//               <span className="infoIcon"></span>
//             </Tooltip>
//           </Styled>
//         </div>
//       ),
//       dataIndex: "netTrimLoss",
//       width: 5,
//       align: "center",
//       render: (text, record) =>
//         `${text.toFixed(3)} ${" "} ${
//           record?.units && record?.units?.net_trim_loss
//             ? lengthUnit[record.units.net_trim_loss]?.displayName?.toUpperCase()
//             : "CM"
//         }`,
//     },
//     {
//       title: "Parent Reel Size",
//       dataIndex: "parent_reel_size",
//       width: 6,
//       align: "center",
//     },
//     {
//       title: "No. of Reels",
//       dataIndex: "number_of_reels",
//       width: 5,
//       align: "center",
//     },
//     {
//       title: "Reel OD/ Core OD",
//       dataIndex: "diaValue",
//       width: 5,
//       align: "center",
//     },
//     {
//       title: "Reel No.",
//       dataIndex: "reel_no",
//       width: 5,
//       align: "center",
//     },
//     {
//       title: (
//         <div>
//           Earliest Delivery <br /> Date
//         </div>
//       ),
//       dataIndex: "deliverydate",
//       width: 10,
//       align: "center",
//       sorter: {
//         compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
//       },
//       render: (text) => moment(text).format("DD MMM YYYY"),
//     },
//     {
//       title: "Production status",
//       dataIndex: "status",
//       width: 8,
//       render: (text, record) => (
//         <div className="statusVal" dataval={record.status}>
//           <Styled>
//             <Tooltip
//               placement="bottomRight"
//               title={
//                 record.reel_od && record.core_id
//                   ? text === "Produced"
//                     ? "The production of this parent reel is completed"
//                     : text === "Mapped"
//                     ? "This parent reel is mapped to jumbo roll for rewinding"
//                     : text === "Not Mapped"
//                     ? "This parent reel is not mapped to jumbo roll yet"
//                     : text === "Cancelled"
//                     ? "The production of this parent reel is cancelled"
//                     : null
//                   : text === "Produced"
//                   ? " The production of this parent set is completed"
//                   : text === "Mapped"
//                   ? "The parent set has been mapped to a jumbo roll"
//                   : text === "Not Mapped"
//                   ? "The parent set is not mapped to a jumbo roll yet"
//                   : text === "Cancelled"
//                   ? "The production of this parent set is cancelled"
//                   : text === "Rejected"
//                   ? "The production of this parent set is rejected "
//                   : null
//               }
//               className="edit-tooltip"
//               getPopupContainer={(triggerNode) => triggerNode}
//             >
//               {text}
//             </Tooltip>
//           </Styled>
//         </div>
//       ),
//       align: "center",
//     },
//     {
//       title: "ACTIONS",
//       dataIndex: "action",
//       width: 12,
//       align: "center",
//       render: (text, record) => (
//         <div
//           className="actionBtn"
//           // style={{ display: "flex", justifyContent: "end" }}
//         >
//           <Styled>
//             <Tooltip
//               placement="bottomRight"
//               title={"View parent reel details"}
//               className="edit-tooltip"
//               getPopupContainer={(triggerNode) => triggerNode}
//             >
//               <Button
//                 onClick={() =>
//                   showParentReelJobCard(
//                     record.reel_no,
//                     record.status === "Produced" || record.status === "Rejected"
//                   )
//                 }
//               >
//                 <Iconmoon icon="file-view" size={16} color="#605E5C" />
//               </Button>
//             </Tooltip>
//           </Styled>
//         </div>
//       ),
//     },
//   ];

//   const fullColumnsHead = [
//     {
//       title: "Po/So.No",
//       dataIndex: "pono",
//       width: "8%",
//       fixed: "left",
//       align: "center",
//       render: (text, record) => {
//         const value =
//           record.category === "po"
//             ? toHandlePOName(record.pono)
//             : record.category === "so"
//             ? toHandlePOName(record.sono)
//             : toHandlePOName(record.pono);

//         return (
//           <span
//             style={{
//               whiteSpace: "normal",
//               wordBreak: "break-word",
//               lineHeight: "1.4",
//             }}
//           >
//             {value?.match(/.{1,15}/g)?.map((chunk, index) => (
//               <span key={index}>
//                 {chunk}
//                 <br />
//               </span>
//             ))}
//           </span>
//         );
//       },
//     },
//     {
//       title: "Order No/Stock No",
//       dataIndex: "orderno",
//       width: "9%",
//       fixed: "left",
//     },
//     {
//       title: "Type",
//       dataIndex: "type",
//       width: "6%",
//       fixed: "left",
//     },
//     {
//       title: "Customer",
//       dataIndex: "customer_alias",
//       width: "9%",
//       align: "left",
//       render: (text, record) => (
//         <div className="actionBtn2">
//           <Styled>
//             <Tooltip
//               placement="bottomRight"
//               title={`${record.customercode}-${record.customername}`}
//               className="edit-tooltip"
//               getPopupContainer={(triggerNode) => triggerNode}
//             >
//               {record?.customer_alias || "-"}
//             </Tooltip>
//           </Styled>
//         </div>
//       ),
//     },
//     {
//       title: "Consignee",
//       dataIndex: "consignee_name",
//       width: "10%",
//       render: (text, record) => record?.consignee_name || "-",
//     },
//     {
//       title: (
//         <div>
//           Product Spec
//           <Styled style={{ display: "inline-flex" }}>
//             <Tooltip
//               placement="bottomRight"
//               title={`The product specification is in the ${format}`}
//               className="edit-tooltip"
//               getPopupContainer={(triggerNode) => triggerNode}
//             >
//               <span className="infoIcon"></span>
//             </Tooltip>
//           </Styled>
//         </div>
//       ),
//       dataIndex: "productspec",
//       width: "14%",
//     },
//     {
//       title: "Size(WxL)",
//       dataIndex: "size",
//       width: "9%",
//     },
//     // {
//     //   title: "Planned Reels",
//     //   dataIndex: "plannedReels",
//     //   width: "8%",
//     //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
//     // },
//     {
//       title: "Matched Grain",
//       dataIndex: "matchedGrain",
//       width: "10%",
//       render: (text, record) => (!record.isReel ? <div>{text}</div> : "-"),
//     },
//     {
//       title: "Planned Quantity",
//       dataIndex: "plannedWeight",
//       width: "10%",
//     },
//     // {
//     //   title: "Fulfilled Reels",
//     //   dataIndex: "fulflilledReels",
//     //   width: "8%",
//     //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
//     // },
//     {
//       title: "Fulfilled Quanitity",
//       dataIndex: "fulflilledWeight",
//       width: "10%",
//     },
//     // {
//     //   title: "Type",
//     //   dataIndex: "type",
//     //   width: "5%",
//     // },
//     {
//       title: "REEL SPECIFICATION",
//       dataIndex: "reelSpecification",
//       width: "22%",
//       render: (text, record) =>
//         record.isReel ? (
//           <div
//             dangerouslySetInnerHTML={{
//               __html: String(text).replace(/\n/g, "<br />"),
//             }}
//           />
//         ) : (
//           "-"
//         ),
//     },
//     {
//       title: "Del Date",
//       dataIndex: "deliverydate",
//       width: "10%",
//     },

//     {
//       title: "Cancelled Quantity",
//       dataIndex: "cancelledQty",
//       width: "22%",
//       render: (text) =>
//         isParentReelCancelled ? (
//           <div
//             dangerouslySetInnerHTML={{
//               __html: String(text).replace(/\n/g, "<br />"),
//             }}
//           />
//         ) : (
//           "-"
//         ),
//     },
//     {
//       title: "Remarks",
//       dataIndex: "remarks",
//       width: "8%",
//       render: (text, record) =>
//         record.type === "Order" && (
//           <div className="actionBtn">
//             <Styled>
//               <Tooltip
//                 placement="bottomRight"
//                 title={record.remarks}
//                 className="edit-tooltip"
//                 getPopupContainer={(triggerNode) => triggerNode}
//               >
//                 <Button style={{ cursor: "default" }}>
//                   <Iconmoon icon="message" size={16} color="#EA655B" />
//                 </Button>
//               </Tooltip>
//             </Styled>
//           </div>
//         ),
//       align: "center",
//     },
//     {
//       title: "Actions",
//       dataIndex: "action",
//       width: "8%",
//       render: (text, record) =>
//         record.type === "Order" && (
//           <div className="actionBtn">
//             <Styled>
//               <Tooltip
//                 placement="bottomRight"
//                 title={"View details of this order"}
//                 className="edit-tooltip"
//                 getPopupContainer={(triggerNode) => triggerNode}
//               >
//                 <Button onClick={() => showViewDrawer(record.orderno, record)}>
//                   <Iconmoon icon="file-view" size={16} color="#A19F9D" />
//                 </Button>
//               </Tooltip>
//             </Styled>
//           </div>
//         ),
//       align: "center",
//     },
//   ];

//   const fullUnfulfilledColumnsHead = [
//     {
//       title: "Po/So.No",
//       dataIndex: "pono",
//       width: "7%",
//       fixed: "left",
//       align: "center",
//       render: (text, record) => {
//         const value =
//           record.category === "po"
//             ? toHandlePOName(record.pono)
//             : record.category === "so"
//             ? toHandlePOName(record.sono)
//             : toHandlePOName(record.pono);

//         return (
//           <span
//             style={{
//               whiteSpace: "normal",
//               wordBreak: "break-word",
//               lineHeight: "1.4",
//             }}
//           >
//             {value?.match(/.{1,15}/g)?.map((chunk, index) => (
//               <span key={index}>
//                 {chunk}
//                 <br />
//               </span>
//             ))}
//           </span>
//         );
//       },
//     },
//     {
//       title: "Order No/Stock No",
//       dataIndex: "orderno",
//       width: "7%",
//       fixed: "left",
//     },
//     {
//       title: "Type",
//       dataIndex: "type",
//       width: "7%",
//       fixed: "left",
//     },
//     {
//       title: "Customer",
//       dataIndex: "customer_alias",
//       width: "10%",
//       align: "left",
//       render: (text, record) => (
//         <div className="actionBtn2">
//           <Styled>
//             <Tooltip
//               placement="bottomRight"
//               title={`${record.customercode}-${record.customername}`}
//               className="edit-tooltip"
//               getPopupContainer={(triggerNode) => triggerNode}
//             >
//               {record?.customer_alias || "-"}
//             </Tooltip>
//           </Styled>
//         </div>
//       ),
//     },
//     {
//       title: "Consignee",
//       dataIndex: "consignee_name",
//       width: "10%",
//       render: (text, record) => record?.consignee_name || "-",
//     },
//     {
//       title: (
//         <div>
//           Product Spec
//           <Styled style={{ display: "inline-flex" }}>
//             <Tooltip
//               placement="bottomRight"
//               title={`The product specification is in the ${format}`}
//               className="edit-tooltip"
//               getPopupContainer={(triggerNode) => triggerNode}
//             >
//               <span className="infoIcon"></span>
//             </Tooltip>
//           </Styled>
//         </div>
//       ),
//       dataIndex: "productspec",
//       width: "14%",
//     },
//     {
//       title: "Size(WxL)",
//       dataIndex: "size",
//       width: "9%",
//     },
//     // {
//     //   title: "Planned Reels",
//     //   dataIndex: "plannedReels",
//     //   width: "8%",
//     //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
//     // },
//     {
//       title: "Matched Grain",
//       dataIndex: "matchedGrain",
//       width: "8%",
//       render: (text, record) => `${!record.isReel ? text : "-"}`,
//     },
//     {
//       title: "Planned Quantity",
//       dataIndex: "plannedWeight",
//       width: "10%",
//     },
//     // {
//     //   title: "Unfulfilled Reels",
//     //   dataIndex: "unFulflilledReels",
//     //   width: "8%",
//     //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
//     // },
//     {
//       title: "Unfulfilled Quantity",
//       dataIndex: "unFulflilledWeight",
//       width: "10%",
//     },
//     // {
//     //   title: "Type",
//     //   dataIndex: "type",
//     //   width: "5%",
//     // },
//     {
//       title: "Del Date",
//       dataIndex: "deliverydate",
//       width: "10%",
//     },
//     {
//       title: "Remarks",
//       dataIndex: "remarks",
//       width: "8%",
//       render: (text, record) => (
//         <div className="actionBtn">
//           <Styled>
//             <Tooltip
//               placement="bottomRight"
//               title={record.remarks}
//               className="edit-tooltip"
//               getPopupContainer={(triggerNode) => triggerNode}
//             >
//               <Button style={{ cursor: "default" }}>
//                 <Iconmoon icon="message" size={16} color="#EA655B" />
//               </Button>
//             </Tooltip>
//           </Styled>
//         </div>
//       ),
//       align: "center",
//     },
//     {
//       title: "Actions",
//       dataIndex: "action",
//       width: "7%",
//       render: (text, record) => (
//         <div className="actionBtn">
//           <Styled>
//             <Tooltip
//               placement="bottomRight"
//               title={"View details of this order"}
//               className="edit-tooltip"
//               getPopupContainer={(triggerNode) => triggerNode}
//             >
//               <Button onClick={() => showViewDrawer(record.orderno, record)}>
//                 <Iconmoon icon="file-view" size={16} color="#A19F9D" />
//               </Button>
//             </Tooltip>
//           </Styled>
//         </div>
//       ),
//       align: "center",
//     },
//   ];
//   const orderFulfillmentColumnsHead = [
//     {
//       title: "Po/So.No",
//       dataIndex: "pono",
//       width: "8%",
//       fixed: "left",
//       align: "center",
//       render: (text, record) => {
//         const value =
//           record.category === "po"
//             ? toHandlePOName(record.pono)
//             : record.category === "so"
//             ? toHandlePOName(record.sono)
//             : toHandlePOName(record.pono);

//         return (
//           <span
//             style={{
//               whiteSpace: "normal",
//               wordBreak: "break-word",
//               lineHeight: "1.4",
//             }}
//           >
//             {value?.match(/.{1,15}/g)?.map((chunk, index) => (
//               <span key={index}>
//                 {chunk}
//                 <br />
//               </span>
//             ))}
//           </span>
//         );
//       },
//     },
//     {
//       title: "Order No/Stock No",
//       dataIndex: "orderno",
//       width: "10%",
//       fixed: "left",
//     },
//     {
//       title: (
//         <div>
//           Product Spec
//           <Styled style={{ display: "inline-flex" }}>
//             <Tooltip
//               placement="bottomRight"
//               title={`The product specification is in the ${format}`}
//               className="edit-tooltip"
//               getPopupContainer={(triggerNode) => triggerNode}
//             >
//               <span className="infoIcon"></span>
//             </Tooltip>
//           </Styled>
//         </div>
//       ),
//       dataIndex: "productspec",
//       width: "14%",
//     },
//     {
//       title: "Size(WxL)",
//       dataIndex: "size",
//       width: "9%",
//     },
//     {
//       title: "Planned Quantity",
//       dataIndex: "plannedWeight",
//       width: "10%",
//     },
//     {
//       title: "Fulfilled Quanitity",
//       dataIndex: "fulflilledWeight",
//       width: "10%",
//     },
//     {
//       title: "Overfulfilment %",
//       dataIndex: "overfulfillmentPercentage",
//       width: "10%",
//     },
//     {
//       title: "REEL SPECIFICATION",
//       dataIndex: "reelSpecification",
//       width: "22%",
//       render: (text) => (
//         <div
//           dangerouslySetInnerHTML={{
//             __html: String(text).replace(/\n/g, "<br />"),
//           }}
//         />
//       ),
//     },
//     {
//       title: "Remarks",
//       dataIndex: "remarks",
//       width: "10%",
//       render: (text, record) =>
//         record.type === "Order" && (
//           <div className="actionBtn">
//             <Styled>
//               <Tooltip
//                 placement="bottomRight"
//                 title={record.remarks}
//                 className="edit-tooltip"
//                 getPopupContainer={(triggerNode) => triggerNode}
//               >
//                 <Button style={{ cursor: "default" }}>
//                   <Iconmoon icon="message" size={16} color="#EA655B" />
//                 </Button>
//               </Tooltip>
//             </Styled>
//           </div>
//         ),
//       align: "center",
//     },
//     {
//       title: "Actions",
//       dataIndex: "action",
//       width: "10%",
//       render: (text, record) =>
//         record.type === "Order" && (
//           <div className="actionBtn">
//             <Styled>
//               <Tooltip
//                 placement="bottomRight"
//                 title={"View details of this order"}
//                 className="edit-tooltip"
//                 getPopupContainer={(triggerNode) => triggerNode}
//               >
//                 <Button onClick={() => showViewDrawer(record.orderno, record)}>
//                   <Iconmoon icon="file-view" size={16} color="#A19F9D" />
//                 </Button>
//               </Tooltip>
//             </Styled>
//           </div>
//         ),
//       align: "center",
//     },
//   ]; 

//   const filteredColumns1 = fullColumnsHead.filter(
//     (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
//   );
//   const filteredColumns2 = fullUnfulfilledColumnsHead.filter(
//     (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
//   );

//   const columnsHead = filteredColumns1;
//   const unfulfilledColumnsHead = filteredColumns2;
//   const handleDropdownClick = async (record, key) => {
//     try {
//       switch (key) {
//         case "sendForReview": // sendForReview
//           const response1 = await changeProductionJobCardState({
//             id: jobId,
//             state: "under_review",
//           });
//           // setUnderReviewJobCards([...underReviewJobcards, record]);
//           // setGridView(true);
//           setReFetch(true);
//           showToaster();

//           break;

//         case "markCancelled": // markCancelled
//           const response2 = await changeProductionJobCardState({
//             id: jobId,
//             state: "cancel",
//           });
//           // setCancelledJobCards([...cancelledJobcards, record]);
//           // setGridView(true);
//           setReFetch(true);
//           showToaster();

//           break;

//         case "markCompleted": // markCompleted
//           const response3 = await changeProductionJobCardState({
//             id: jobId,
//             state: "complete",
//           });
//           // setCompleteCards([...completeCards, record]);
//           // setGridView(true);
//           setReFetch(true);
//           showToaster();
//           break;

//         case "replan":
//           const response4 = await replanJobcard(
//             {
//               jobcard: jobId,
//               // state: "complete",
//             },
//             "multistage"
//           );
//           // setIsReplanClicked(true);
//           setIsReplanClicked(true);
//           break;
//         default:
//           console.warn("Unknown dropdown key:", key);
//       }
//     } catch (error) {
//       console.error("Error handling dropdown click:", error);
//       setActionResponse({
//         error: error.response.data.error,
//         msg: error.response.data.msg,
//       });
//       showToaster();
//     }
//   };
//   const fetchJobcardDetails = (jobcardIds, parentJobCardId = 0, uuid = "") => {
//     let newsolcnt = false;
//     getJobCardsDetailsMultistage({ jobcards: jobcardIds })
//       .then((response) => {
//         if (!createNewSolutionClicked) {
//           const tempJobcardDetailsList = [...jobCardDetailsList];

//           response?.forEach((job) => {
//             if (
//               !tempJobcardDetailsList.some(
//                 (existingJob) => existingJob.id === job.id
//               )
//             ) {
//               tempJobcardDetailsList.push(job);
//             }
//           });
//           setJobCardDetailsList(tempJobcardDetailsList);
//           // setSyncFailedGroups(false);
//           // setRerendering(!rerendering);
//         } else {
//           newsolcnt = true;
//           let detailsList = jobCardDetailsList;
//           let filteredJobCardIndex = detailsList.findIndex(function (
//             jobCardDetails
//           ) {
//             return jobCardDetails.uuid == uuid;
//           });
//           if (filteredJobCardIndex != -1) {
//             detailsList[filteredJobCardIndex] = {
//               ...detailsList[filteredJobCardIndex],
//               newlyCreatedJobCardsDetails: response,
//             };
//             //set isSuccessful true when new sol for failedJC is created
//             if (detailsList[filteredJobCardIndex]?.isFailedJobcard) {
//               detailsList[filteredJobCardIndex] = {
//                 ...detailsList[filteredJobCardIndex],
//                 isSuccessful: true,
//               };
//             }
//           }
//           setJobCardDetailsList(detailsList);
//           setCreateNewSolutionClicked(false);
//           // setRerendering(!rerendering);
//           // setIsTabularView(false);
//         }
//         const rewinderMachine = response[0]?.jobcard?.group?.machines?.find(
//           (machine) => machine.machine_type === "rewinder"
//         );
//         const cutterMachine = response[0]?.jobcard?.group?.machines?.find(
//           (machine) => machine.machine_type === "cutter"
//         );
//         let stockMachineValue = { ...formValuesForStock?.[jobIndex] };
//         if (rewinderMachine) {
//           const {
//             deckle_size_lb,
//             deckle_size_ub,
//             left_edge_trim,
//             right_edge_trim,
//             original_cutters,
//             effective_deckle_length,
//             units,
//             machine_type,
//             machine_code,
//           } = rewinderMachine;

//           const rightEdgeTrimConversionFactor =
//             CoversionFactorUnitsToCM[units.right_edge_trim];
//           const deckleSizeUbConversionFactor =
//             CoversionFactorCMToUnits[units.deckle_size_ub];

//           const minDeckleLength = deckle_size_lb;
//           const maxDeckleLength =
//             deckle_size_ub +
//             (left_edge_trim + right_edge_trim) *
//               rightEdgeTrimConversionFactor *
//               deckleSizeUbConversionFactor;

//           stockMachineValue = {
//             ...stockMachineValue,
//             min_deckle_length: minDeckleLength,
//             max_deckle_length: maxDeckleLength,
//             maximum_cutters: original_cutters,
//             effective_deckle_length: effective_deckle_length,
//             left_edge_trim: left_edge_trim,
//             right_edge_trim: right_edge_trim,
//             units: units,
//           };
//         }
//         if (cutterMachine) {
//           const {
//             deckle_size_lb,
//             deckle_size_ub,
//             left_edge_trim,
//             right_edge_trim,
//             original_cutters,
//             effective_deckle_length,
//             max_chop_size,
//             min_chop_size,
//             maximum_reel_dia,
//             minimum_reel_dia,
//             allowed_trim,
//             units,
//             cutters,
//           } = cutterMachine;

//           const rightEdgeTrimConversionFactor =
//             CoversionFactorUnitsToCM[units.right_edge_trim];
//           const deckleSizeUbConversionFactor =
//             CoversionFactorCMToUnits[units.deckle_size_ub];

//           const minDeckleLength = deckle_size_lb;
//           const maxDeckleLength =
//             deckle_size_ub +
//             (left_edge_trim + right_edge_trim) *
//               rightEdgeTrimConversionFactor *
//               deckleSizeUbConversionFactor;

//           stockMachineValue = {
//             ...stockMachineValue,
//             min_deckle_length_cutter: minDeckleLength,
//             max_deckle_length_cutter: maxDeckleLength,
//             maximum_cutters_cutter: original_cutters,
//             effective_deckle_length_cutter: effective_deckle_length,
//             left_edge_trim_cutter: left_edge_trim,
//             right_edge_trim_cutter: right_edge_trim,
//             min_chop_cutter: min_chop_size,
//             max_chop_cutter: max_chop_size,
//             min_dia_cutter: minimum_reel_dia,
//             max_dia_cutter: maximum_reel_dia,
//             units_cutter: units,
//             max_trim_intermediate_cutter: allowed_trim,
//             cutters_cutter: cutters,
//           };
//         }
//         setFormValuesForStock({
//           ...formValuesForStock,
//           [jobIndex ? jobIndex : 0]: stockMachineValue,
//         });
//         // const orderIds = [];
//         // response.forEach((item) => {
//         //   item.jobcard?.group?.orders?.map((order) => {
//         //     orderIds.push(order.order_id);
//         //   });
//         // });
//         // setOrderIdList(orderIds);
//       })
//       .catch((error) => {
//         newsolcnt = true;
//         let detailsList = jobCardDetailsList;
//         let filteredJobCardIndex = detailsList.findIndex(function (
//           jobCardDetails
//         ) {
//           return jobCardDetails.uuid == uuid;
//         });

//         if (filteredJobCardIndex != -1) {
//           let jobcardData = [
//             {
//               created_at: detailsList[filteredJobCardIndex].created_at,
//               uuid: detailsList[filteredJobCardIndex].uuid,
//               id: detailsList[filteredJobCardIndex].id,
//               user_id: detailsList[filteredJobCardIndex].user_id,
//               updated_at: detailsList[filteredJobCardIndex].updated_at,
//               jobcard: {
//                 group: detailsList[filteredJobCardIndex].jobcard.group,
//                 solution_1: {
//                   data: {
//                     exception:
//                       "Job card could not be created for the input.Please check the input and try again",
//                   },
//                 },
//                 solution_2: {
//                   data: {
//                     exception:
//                       "Job card could not be created for the input.Please check the input and try again",
//                   },
//                 },
//               },
//             },
//           ];

//           detailsList[filteredJobCardIndex] = {
//             ...detailsList[filteredJobCardIndex],
//             newlyCreatedJobCardsDetails: jobcardData,
//           };
//           !detailsList[filteredJobCardIndex]?.isFailedJobcard &&
//             setJobCardDetailsList(detailsList);
//           setCreateNewSolutionClicked(false);
//           // setRerendering(!rerendering);
//         }
//       });
//   };
//   const getUpdatedOrders = async (group) => {
//     try {
//       const response = await getOrdersList(
//         group?.orders?.map((order) => (order.item_type !== "stock"&& order.item_type != "product_stock_size") && order.order_id)?.sort()
//       );
//       return response?.data?.filter((order) => order.cutter_reel_dia === true);
//     } catch (error) {
//       console.error("Error fetching orders list:", error);
//       throw error;
//     }
//   };
//   const createRequest = (
//     ordersList,
//     group,
//     machine,
//     isManualInput,
//     min,
//     max,
//     unit
//   ) => {
//     return ordersList?.map((order) => {
//       const isConstant = isManualInput
//         ? min === max
//         : machine.minimum_reel_dia === machine.maximum_reel_dia;
//       const reelOdValue = isManualInput
//         ? `${max} ${unit}`
//         : `${machine.minimum_reel_dia} ${machine.units}`;
//       const unitsValue = isManualInput ? unit : machine.units?.minimum_reel_dia;

//       return {
//         order_id: JSON.stringify(order.id),
//         planned_weight: order?.planned_weight,
//         reel_od: isConstant
//           ? [reelOdValue]
//           : {
//               minimum_reel_od: isManualInput ? min : machine.minimum_reel_dia,
//               maximum_reel_od: isManualInput ? max : machine.maximum_reel_dia,
//             },
//         group_id: group.group_id,
//         od_type: isConstant ? "constant" : "range",
//         cutter_reel_dia: true,
//         units: isConstant
//           ? {
//               planned_weight: order?.units?.planned_weight,
//             }
//           : {
//               planned_weight: order?.units?.planned_weight,
//               minimum_reel_od: unitsValue,
//               maximum_reel_od: unitsValue,
//             },
//       };
//     });
//   };

//   const handleCutterReelDiaChange = async (e, cutterMachine) => {
//     // if (showAimation[jobIndex]) return;

//     const isManualInput = Boolean(e);
//     const group =
//       jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails?.[0]?.jobcard
//         ?.group || jobCardDetailsList[jobIndex].jobcard?.group;
//     if (!group) return;

//     try {
//       const ordersList = await getUpdatedOrders(group);
//       if (!ordersList?.length) return;

//       let request;
//       if (!isManualInput) {
//         const machine = group?.machines?.find(
//           (machine) => machine.machine_type === "cutter"
//         );
//         if (!machine) return;

//         request = createRequest(ordersList, group, machine, false);
//       } else {
//         const min = parseFloat(e.min_dia_cutter);
//         const max = parseFloat(e.max_dia_cutter);
//         const unit = e.reel_dia_unit_cutter;

//         if (
//           min === cutterMachine.minimum_reel_dia &&
//           max === cutterMachine.maximum_reel_dia &&
//           unit === cutterMachine.units
//         )
//           return;

//         request = createRequest(
//           ordersList,
//           group,
//           cutterMachine,
//           true,
//           min,
//           max,
//           unit
//         );
//       }

//       if (!request?.length) return;

//       const response = await editQtyToBePlannedForReviewOrder(
//         request,
//         "new_solution"
//       );
//     } catch (error) {
//       console.log("Error in updating order:", error?.response?.data);
//     }
//   };
//   const onClickCreateSolution = async (e, jobCardId, uuid, jobIndex) => {
//     // setActiveTab('1');
//     // setCurrentSummaryTab('1');
//     setSizeExpanded(false);
//     setSizeExpanded(false);
//     setSizeExpanded(false);
//     setSizeExpanded(false);
//     // setShowAimation((prev) => {
//     //   return { ...prev, [jobIndex]: true };
//     // });
//     let sizes = [];
//     setCreateNewSolutionFormValuesForSizes(e);
//     if (e.selectedSizes.length > 0) {
//       e.selectedSizes.forEach((size) => {
//         let sizeObject = {
//           id: size.stockSizeId,
//           //size: size.stockSize,
//           allowed_quantity: parseFloat(size.allowedQuantity),
//           reels: size.reels,
//           planned_weight: parseFloat(size.plannedWeight),
//           type: size.type,
//           sheets: size.sheets,

//           ...((size.type === "sheet") && {lateral_size: size.length,
//             grain: size.grain,
//           }),
//           ...((size.type === "reel") && {
//             grain: null,
//           }),
//           size: size.width,
//           mixed_grain: false,
//           ...(size.creation_type === "required" && {
//             weight_lb: parseFloat(size.weight_lb),
//             weight_ub: parseFloat(size.weight_ub),

//             priority_stock: size.priority_stock,
//           }),
//           units: {
//             ...size.units,

//             lateral_size: size.units.length,
//             size: size.units.width ,
//           },         
//           creation_type: size.creation_type,
//         };
//         sizes.push(sizeObject);
//       });
//     }
//     let updatedFormValues = { ...formValuesForStock?.[jobIndex] };
//     updatedFormValues["max_deckle_length"] = e.maxDeckleLength
//       ? parseFloat(e.maxDeckleLength)
//       : updatedFormValues?.max_deckle_length;
//     updatedFormValues["min_deckle_length"] = e.minDeckleLength
//       ? parseFloat(e.minDeckleLength)
//       : updatedFormValues?.min_deckle_length;
//     updatedFormValues["left_edge_trim"] = e.minWidth
//       ? parseFloat(e.minWidth)
//       : updatedFormValues?.left_edge_trim;
//     updatedFormValues["right_edge_trim"] = e.maxWidth
//       ? parseFloat(e.maxWidth)
//       : updatedFormValues?.right_edge_trim;
//     updatedFormValues["maximum_cutters"] = e.cutters
//       ? parseFloat(e.cutters)
//       : updatedFormValues?.cutters;
//     updatedFormValues["effective_deckle_length"] = e.cutters
//       ? parseFloat(e.effectiveDeckleLength)
//       : "";
//     updatedFormValues["units"] = {
//       max_deckle_length: e.deckleLengthUnit,
//       min_deckle_length: e.deckleLengthUnit,
//       left_edge_trim: e.widthUnit,
//       right_edge_trim: e.widthUnit,
//       effective_deckle_length: e.deckleLengthUnit,
//       deckle_size_ub: e.deckleLengthUnit,
//       deckle_size_lb: e.deckleLengthUnit,
//     };
//     updatedFormValues["max_deckle_length_cutter"] = e.maxDeckleLengthCutter
//       ? parseFloat(e.maxDeckleLengthCutter)
//       : updatedFormValues?.max_deckle_length;
//     updatedFormValues["min_deckle_length_cutter"] = e.minDeckleLengthCutter
//       ? parseFloat(e.minDeckleLengthCutter)
//       : updatedFormValues?.min_deckle_length;
//     updatedFormValues["left_edge_trim_cutter"] = e.minWidthCutter
//       ? parseFloat(e.minWidthCutter)
//       : updatedFormValues?.left_edge_trim;
//     updatedFormValues["right_edge_trim_cutter"] = e.maxWidthCutter
//       ? parseFloat(e.maxWidthCutter)
//       : updatedFormValues?.right_edge_trim;
//     updatedFormValues["maximum_cutters_cutter"] = e.cuttersCutter
//       ? parseFloat(e.cuttersCutter)
//       : updatedFormValues?.cuttersCutter;
//     updatedFormValues["effective_deckle_length_cutter"] =
//       e.effectiveDeckleLengthCutter
//         ? parseFloat(e.effectiveDeckleLengthCutter)
//         : "";
//     updatedFormValues["min_dia_cutter"] = parseFloat(e.min_dia_cutter);
//     updatedFormValues["max_dia_cutter"] = parseFloat(e.max_dia_cutter);
//     updatedFormValues["min_chop_cutter"] = parseFloat(e.min_chop_cutter);
//     updatedFormValues["max_chop_cutter"] = parseFloat(e.max_chop_cutter);
//     updatedFormValues["max_trim_intermediate_cutter"] = parseFloat(
//       e.max_trim_intermediate_cutter
//     );
//     updatedFormValues["units_cutter"] = {
//       ...e.units_cutter,
//       max_deckle_length: e.deckleLengthUnitCutter,
//       min_deckle_length: e.deckleLengthUnitCutter,
//       left_edge_trim: e.widthUnitCutter,
//       right_edge_trim: e.widthUnitCutter,
//       effective_deckle_length: e.deckleLengthUnitCutter,
//       minimum_reel_dia: e.reel_dia_unit_cutter,
//       maximum_reel_dia: e.reel_dia_unit_cutter,
//       max_chop_size: e.chopUnit,
//       min_chop_cutter: e.chopUnit,
//       deckle_size_ub: e.deckleLengthUnitCutter,
//       deckle_size_lb: e.deckleLengthUnitCutter,
//       allowed_trim: e.max_trim_intermediate_unit_cutter,
//     };

//     setFormValuesForStock({
//       ...formValuesForStock,
//       [jobIndex]: updatedFormValues,
//     });
//     const rewinderMachine = jobCardDetailsList[
//       jobIndex
//     ].jobcard?.group?.machines?.find(
//       (machine) => machine.machine_type === "rewinder"
//     );
//     const cutterMachine = jobCardDetailsList[
//       jobIndex
//     ].jobcard?.group?.machines?.find(
//       (machine) => machine.machine_type === "cutter"
//     );

//     let request = {
//       [`${
//         jobCardDetailsList[jobIndex]?.isFailedJobcard
//           ? "failed_group"
//           : "jobcard"
//       }`]: jobCardDetailsList[jobIndex]?.isFailedJobcard
//         ? jobCardDetailsList[jobIndex]?.failedGroupId
//         : jobCardId,
//       run_type: "selected_sizes",
//       machine_selection_data: [
//         {
//           ...rewinderMachine,
//           maximum_deckle_size: e.maxDeckleLength
//             ? parseFloat(e.maxDeckleLength)
//             : updatedFormValues?.max_deckle_length,
//           minimum_deckle_size: e.minDeckleLength
//             ? parseFloat(e.minDeckleLength)
//             : updatedFormValues?.min_deckle_length,
//           left_edge_trim: e.minWidth
//             ? parseFloat(e.minWidth)
//             : updatedFormValues?.left_edge_trim,
//           right_edge_trim: e.maxWidth
//             ? parseFloat(e.maxWidth)
//             : updatedFormValues?.right_edge_trim,
//           maximum_cutters: e.cutters
//             ? parseFloat(e.cutters)
//             : updatedFormValues?.maximum_cutters,
//           effective_deckle_length: e.effectiveDeckleLength
//             ? parseFloat(e.effectiveDeckleLength)
//             : "",
//           units: {
//             maximum_deckle_size: e.deckleLengthUnit,
//             minimum_deckle_size: e.deckleLengthUnit,
//             left_edge_trim: e.widthUnit,
//             right_edge_trim: e.widthUnit,
//             effective_deckle_length: e.deckleLengthUnit,
//           },
//         },
//         {
//           ...cutterMachine,
//           maximum_deckle_size:
//             e.maxDeckleLengthCutter >= 0
//               ? parseFloat(e.maxDeckleLengthCutter)
//               : updatedFormValues?.max_deckle_length_cutter,
//           minimum_deckle_size:
//             e.minDeckleLengthCutter >= 0
//               ? parseFloat(e.minDeckleLengthCutter)
//               : updatedFormValues?.min_deckle_length_cutter,
//           left_edge_trim:
//             e.minWidthCutter >= 0
//               ? parseFloat(e.minWidthCutter)
//               : updatedFormValues?.left_edge_trim_cutter,
//           right_edge_trim:
//             e.maxWidthCutter >= 0
//               ? parseFloat(e.maxWidthCutter)
//               : updatedFormValues?.right_edge_trim_cutter,
//           maximum_cutters:
//             e.cuttersCutter >= 0
//               ? parseFloat(e.cuttersCutter)
//               : updatedFormValues?.maximum_cutters_cutter,
//           effective_deckle_length: e.effectiveDeckleLengthCutter
//             ? parseFloat(e.effectiveDeckleLengthCutter)
//             : "",
//           minimum_reel_dia: parseFloat(e.min_dia_cutter),
//           maximum_reel_dia: parseFloat(e.max_dia_cutter),
//           max_chop_size: parseFloat(e.max_chop_cutter),
//           min_chop_size: parseFloat(e.min_chop_cutter),
//           allowed_trim: parseFloat(e.max_trim_intermediate_cutter),
//           units: {
//             maximum_deckle_size: e.deckleLengthUnitCutter,
//             minimum_deckle_size: e.deckleLengthUnitCutter,
//             left_edge_trim: e.widthUnit_cutter,
//             right_edge_trim: e.widthUnit_cutter,
//             effective_deckle_length: e.deckleLengthUnitCutter,
//             minimum_reel_dia: e.reel_dia_unit_cutter,
//             maximum_reel_dia: e.reel_dia_unit_cutter,
//             max_chop_size: e.chopUnit,
//             min_chop_size: e.chopUnit,
//             allowed_trim: e.max_trim_intermediate_unit_cutter,
//           },
//         },
//       ],
//       sizes: sizes,
//       optimize_unique_partitions: optimizePartition,
//       minimize_overfulfillment: minimizeOverfulfillment,
//     };
//     await handleCutterReelDiaChange(e, cutterMachine);
//     try {
//       setCreateNewSolutionClicked(true);
//       let jobCard = await createNewSolutionMultistage(request);
//       //  if(showAimation[jobIndex]) setCurrentSolution("3");
//       // fetchJobcardDetails([jobCard.jobcard], jobCardId, uuid);
//       const data = {
//         done: true,
//         failed_groups: [],
//         jobcards: [jobCard?.jobcard],
//         total_groups: 1,
//       };
//       navigate("../deckle-match-result-multistage", {
//         state: {
//           jobCards: data,
//           parentJCid: jobCardId,
//           type: "replan",
//           jobcardType: jobcardType,
//           isDummyJC: jobCardDetailsList[jobIndex].is_dummy,
//         },
//       });

//       // setFailedNewSol((prev) => {
//       //   return { ...prev, [jobIndex]: false };
//       // });
//     } catch (error) {
//       let jobcardResp = [];
//       let response = [];

//       // console.log(error?.response?.data?.data?.group_id, error?.response?.data?.data, response);
//       if (error?.response?.data?.data?.group_id) {
//         response.push(error?.response?.data?.data);
//       } else {
//         let jobCard = await getAlgorithmCompletionStatusMultiStage();
//         response = await getFailedGroups({
//           failed_groups: jobCard.data.failed_groups,
//         });
//       }

//       // setFailedNewSol((prev) => {
//       //   return { ...prev, [jobIndex]: true };
//       // });

//       let detailsList = jobCardDetailsList;
//       let filteredJobCardIndex = detailsList.findIndex(function (
//         jobCardDetails
//       ) {
//         return jobCardDetails.uuid == uuid;
//       });

//       let data = {
//         orders: [],
//         partitions: [],
//         sizes: [],
//         summary: {},
//       };

//       let jobcardData = {};

//       if (!response.length) {
//         jobcardData = {
//           created_at: detailsList[filteredJobCardIndex].created_at,
//           uuid: detailsList[filteredJobCardIndex].uuid,
//           id: detailsList[filteredJobCardIndex].id,
//           user_id: detailsList[filteredJobCardIndex].user_id,
//           updated_at: detailsList[filteredJobCardIndex].updated_at,
//           jobcard: {
//             group: detailsList[filteredJobCardIndex].jobcard.group,
//             solution_1: {
//               data: {
//                 exception:
//                   "Job card could not be created for the input.Please check the input and try again",
//               },
//             },
//             solution_2: {
//               data: {
//                 exception:
//                   "Job card could not be created for the input.Please check the input and try again",
//               },
//             },
//           },
//         };
//       } else {
//         jobcardData = {
//           created_at: response[0].created_at,
//           uuid: response[0].uuid,
//           id: response[0].id,
//           user_id: response[0].user_id,
//           updated_at: response[0].updated_at,
//           jobcard: {
//             group: error?.response?.data?.data?.group_id
//               ? response[0]
//               : response[0].group,
//             solution_1: { data },
//             solution_2: { data },
//           },
//         };
//       }
//       jobcardResp.push(jobcardData);
//       //set isSucessful to false if the new solution for failedJC is failed
//       detailsList[filteredJobCardIndex] = {
//         ...detailsList[filteredJobCardIndex],
//         isSuccessful: false,
//         newlyCreatedJobCardsDetails: jobcardResp,
//       };
//       setJobCardDetailsList(detailsList);
//       // if(showAimation[jobIndex])
//       //   setCurrentSolution("3");
//       // setSolutionId("3");
//       // fetchOrders("current_solution", jobcardData.jobcard);
//     } finally {
//       setCreateNewSolutionClicked(false);
//       // setTimeout(()=>{setShowAimation((prev) => {
//       //   return { ...prev, [jobIndex]: false };
//       // });},4000)
//     }
//   };
//   const handleOptimizePartitionChange = (isChecked) => {
//     setOptimizePartition(isChecked);
//   };
//   const handleMinimizeOverfulfillmentChange = (isChecked) => {
//     setMinimizeOverfulfillment(isChecked);
//   };
//   useEffect(() => {
//     fetchJobcardDetails([jobId]);
//     // setJobCardDetailsList(jobcardIds);
//   }, [jobId]);
//   return jobCard && acceptedSolution.solution ? (
//     <RightLayoutContainer>
//       {/* {console.log("Jobcard", jobCard)} */}
//       {isReplanClicked ? (
//         createNewSolutionClicked ? (
//           <ContentMiddle>
//             <div className="imageAnimate">
//               <div className="imageCover">
//                 <LottieAnimation lotti={JobcardPrepare} />
//                 <p>
//                   Our algorithms are cooking a job card for you <br />
//                   please wait, it will take less than a minute
//                 </p>
//               </div>
//             </div>
//           </ContentMiddle>
//         ) : (
//           <CreateNewSolutionMultistage
//             jobId={jobCardDetailsList[0].id}
//             onClickCreateSolution={(e) =>
//               onClickCreateSolution(
//                 e,
//                 jobCardDetailsList[0].id,
//                 jobCardDetailsList[0].uuid,
//                 0
//               )
//             }
//             formValuesForStock={formValuesForStock?.[jobIndex]}
//             jobCardDetails={jobCardDetailsList[0]?.jobcard}
//             backButtonClicked={() => {
//               setCreateNewSolutionClicked(false);
//               handleCutterReelDiaChange();
//               setIsReplanClicked(false);
//               cancelJobCard();
//             }}
//             stockSizesArray={stockSizes}
//             setStockSizesArray={setStockSizes}
//             createNewSolutionFormValuesForSizes={
//               createNewSolutionFormValuesForSizes
//             }
//             unselectedOrders={
//               jobCardDetailsList[0]?.newlyCreatedJobCardsDetails
//                 ? jobCardDetailsList[0]?.newlyCreatedJobCardsDetails[0]?.jobcard
//                     ?.group?.unselected_orders
//                 : jobCardDetailsList[0]?.jobcard?.group?.unselected_orders
//             }
//             ordersIdList={ordersIdList}
//             optimizePartition={optimizePartition}
//             minimizeOverfulfillment={minimizeOverfulfillment}
//             onOptimizePartitionChange={handleOptimizePartitionChange}
//             onMinimizeOverfulfillmentChange={
//               handleMinimizeOverfulfillmentChange
//             }
//             machineData={location?.state?.body}
//             solutionId={solutionId}
//             completeJCDetails={jobCardDetailsList[jobIndex]}
//             replan={true}
//             dynamicStock={dynamicStock}
//             solutionType = {'replan'}
//           />
//         )
//       ) : (
//         <>
//           <PageTitleComp
//             className="marginRightAdg"
//             style={{ borderBottom: "0px" }}
//           >
//             <PageHeader
//               ghost={false}
//               onBack={() => navigate("../job-cards")}
//               // onBack={() => navigate(-2)}
//               title="Job Card Details"
//               extra={
//                 jobCard.state == "pending"
//                   ? [
//                       <Button
//                         key="1"
//                         className="themeBtn noBg"
//                         onClick={showRejectDrawer}
//                         disabled={!userDetails.roles.approve_jobcards.edit}
//                         loading={isRejectLoading}
//                       >
//                         {!isRejectLoading && (
//                           <Iconmoon
//                             icon="wrong-file"
//                             size={14}
//                             color="#EA4E2C"
//                           />
//                         )}
//                         Reject Job Card
//                       </Button>,
//                       <Button
//                         key="1"
//                         className="themeBtn"
//                         onClick={approveModalShow}
//                         disabled={!userDetails.roles.approve_jobcards.edit}
//                         loading={isApproveLoading}
//                       >
//                         {!isApproveLoading && (
//                           <Iconmoon
//                             icon="correct-file"
//                             size={14}
//                             color="#fff"
//                           />
//                         )}
//                         Approve Job Card
//                       </Button>,
//                     ]
//                   : jobCard.state == "approved"
//                   ? [
//                       // <Button
//                       //   key="1"
//                       //   className="themeBtn"
//                       //   onClick={showStartProductionModal}
//                       // >
//                       //   <Iconmoon icon="correct-file" size={14} color="#fff" />
//                       //   Start Production
//                       // </Button>,
//                     ]
//                   : jobCard.state === "in_production"
//                   ? [
//                       // <Button
//                       //   key="1"
//                       //   className="themeBtn noBg"
//                       //   onClick={showCancelProductionModal}
//                       // >
//                       //   <Iconmoon icon="wrong-file" size={14} color="#EA4E2C" />
//                       //   Cancel Production
//                       // </Button>,
//                       // <Button
//                       //   key="1"
//                       //   className="themeBtn"
//                       //   onClick={showMarkCompletedModal}
//                       // >
//                       //   <Iconmoon icon="correct-file" size={14} color="#fff" />
//                       //   Mark as Completed
//                       // </Button>,
//                     ]
//                   : jobCard.state === "active"
//                   ? [
//                       <Button
//                         key="1"
//                         className="themeBtn noBg"
//                         onClick={() =>
//                           handleDropdownClick(jobcardCode, "sendForReview")
//                         }
//                         disabled={!userDetails.roles.approve_jobcards.edit}
//                       >
//                         <Iconmoon icon="file-view" size={16} color="#EA4E2C" />
//                         Send for Review
//                       </Button>,

//                       <Button
//                         key="1"
//                         className="themeBtn noBg"
//                         onClick={() =>
//                           handleDropdownClick(jobcardCode, "markCancelled")
//                         }
//                         disabled={!userDetails.roles.approve_jobcards.edit}
//                       >
//                         <Iconmoon icon="wrong-file" size={14} color="#EA4E2C" />
//                         Mark Cancelled
//                       </Button>,
//                       <Button
//                         key="1"
//                         className="themeBtn"
//                         onClick={() =>
//                           handleDropdownClick(jobcardCode, "markCompleted")
//                         }
//                         disabled={!userDetails.roles.approve_jobcards.edit}
//                       >
//                         <Iconmoon icon="correct-file" size={14} color="#fff" />
//                         Mark Complete
//                       </Button>,
//                     ]
//                   : jobCard.state === "cancel"
//                   ? []
//                   : jobCard.state === "under_review"
//                   ? [
//                       <Button
//                         key="1"
//                         className="themeBtn noBg"
//                         onClick={() =>
//                           handleDropdownClick(jobcardCode, "markCompleted")
//                         }
//                         disabled={!userDetails.roles.approve_jobcards.edit}
//                       >
//                         <Iconmoon
//                           icon="correct-file"
//                           size={14}
//                           color="#EA4E2C"
//                         />
//                         Mark Complete
//                       </Button>,
//                       <Button
//                         key="1"
//                         className="themeBtn noBg"
//                         onClick={() =>
//                           handleDropdownClick(jobcardCode, "markCancelled")
//                         }
//                         disabled={!userDetails.roles.approve_jobcards.edit}
//                       >
//                         <Iconmoon icon="wrong-file" size={14} color="#EA4E2C" />
//                         Mark Cancelled
//                       </Button>,
//                       <Button
//                         key="1"
//                         className="themeBtn"
//                         onClick={() =>
//                           handleDropdownClick(jobcardCode, "replan")
//                         }
//                         disabled={!userDetails.roles.approve_jobcards.edit}
//                       >
//                         <Iconmoon icon="replan" size={16} color="#ffffff" />
//                         Re-Plan
//                       </Button>,
//                     ]
//                   : null
//               }
//             ></PageHeader>
//           </PageTitleComp>
//           <ResultWrap>
//             <DetailFields
//               className="jobCardView"
//               style={{ justifyContent: "flex-start" }}
//             >
//               <SolutionContainer>
//                 <PageTitleComp style={{ borderBottom: "0" }}>
//                   <PageHeader
//                     ghost={false}
//                     // title={`${jobcardCode}`}
//                     title={
//                       jobcardCode?.length > 15 ? (
//                         <Tooltip placement="bottomLeft" title={jobcardCode}>
//                           <h5>{jobcardCode?.slice(0, 16) + "..."}</h5>
//                         </Tooltip>
//                       ) : (
//                         <h5>{jobcardCode}</h5>
//                       )
//                     }
//                     className="jobCardList-Grid"
//                   ></PageHeader>

//                   <div
//                     className={`jobCardList ${"fullWidth"}`}
//                     style={{
//                       alignSelf: "center",
//                       display: "flex",
//                       marginTop:
//                         isParentReelCancelled &&
//                         activeTab != 6 &&
//                         activeTab != 7 &&
//                         activeTab != 1
//                           ? "20px"
//                           : "34px",
//                       // activeTab >= 2 ? "20px" : "34px",
//                       // alignContent:'top'
//                     }}
//                   >
//                     <JobCardColorStatus>
//                       <div
//                         className="statusVal"
//                         dataval={jobCard.state}
//                         style={{
//                           marginTop:
//                             activeTab == 3 ||
//                             activeTab == 4 ||
//                             activeTab == 5 ||
//                             activeTab == 6 ||
//                             activeTab == 7
//                               ? "0px"
//                               : "0px",
//                         }}
//                       >
//                         {jobcardState(jobCard.state)}
//                       </div>
//                     </JobCardColorStatus>
//                     {activeTab == 6 && (
//                       <JobCardColorStatus>
//                         <div
//                           className="statusVal"
//                           style={{ marginTop: "0px" }}
//                           dataval={jobCard.state}
//                         >
//                           {
//                             acceptedSolution?.solution?.data?.rewinder_details
//                               ?.code
//                           }
//                           {" - "}
//                           {jobcardState(
//                             acceptedSolution?.solution?.data?.rewinding_status
//                           )}
//                         </div>
//                       </JobCardColorStatus>
//                     )}
//                     {activeTab == 7 && (
//                       <JobCardColorStatus>
//                         <div
//                           className="statusVal"
//                           style={{ marginTop: "0px" }}
//                           dataval={jobCard.state}
//                         >
//                           {
//                             acceptedSolution?.solution?.data?.cutter_details
//                               ?.code
//                           }
//                           {" - "}
//                           {jobcardState(
//                             acceptedSolution?.solution?.data?.cutting_status
//                           )}
//                         </div>
//                       </JobCardColorStatus>
//                     )}

//                     <div
//                       className="statusVal"
//                       dataval={jobCard.state}
//                       style={{
//                         marginLeft:
//                           jobCard.state == "pending"
//                             ? "12px"
//                             : jobCard.state == "rejected"
//                             ? "10px"
//                             : jobCard.state == "approved"
//                             ? "10px"
//                             : jobCard.state == "in_production"
//                             ? "10px"
//                             : jobCard.state == "complete"
//                             ? "10px"
//                             : jobCard.state == "active"
//                             ? "10px"
//                             : jobCard.state == "under_review"
//                             ? "10px"
//                             : jobCard.state == "cancel"
//                             ? "10px"
//                             : "",
//                         marginTop:
//                           jobCard.state == "pending" ||
//                           jobCard.state == "active"
//                             ? "5px"
//                             : jobCard.state == "rejected" ||
//                               jobCard.state == "approved" ||
//                               jobCard.state == "in_production" ||
//                               jobCard.state == "complete" ||
//                               jobCard.state == "under_review" ||
//                               jobCard.state == "cancel"
//                             ? "4px"
//                             : "",
//                       }}
//                     >
//                       {/* Ply: {jobCard.ply} */}
//                     </div>

//                     {orderDetailsList && (
//                       <TableList
//                         style={{
//                           justifyContent: "flex-end",
//                           display: "flex",
//                         }}
//                       >
//                         {/*
//                   <div className="List-grid-View" onClick={printJobCardDetails}>
//                     <div className="printIcon">
//                       <svg
//                         width="20"
//                         height="20"
//                         viewBox="0 0 20 20"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M15.8334 6.66667H4.16669C2.78335 6.66667 1.66669 7.78334 1.66669 9.16667V14.1667H5.00002V17.5H15V14.1667H18.3334V9.16667C18.3334 7.78334 17.2167 6.66667 15.8334 6.66667ZM13.3334 15.8333H6.66669V11.6667H13.3334V15.8333ZM15.8334 10C15.375 10 15 9.62501 15 9.16667C15 8.70834 15.375 8.33334 15.8334 8.33334C16.2917 8.33334 16.6667 8.70834 16.6667 9.16667C16.6667 9.62501 16.2917 10 15.8334 10ZM15 2.50001H5.00002V5.83334H15V2.50001Z"
//                           fill="#605E5C"
//                         />
//                       </svg>
//                     </div>
//                   </div>
//                   */}
//                       </TableList>
//                     )}
//                   </div>
//                   {isParentReelCancelled &&
//                     activeTab != 6 &&
//                     activeTab != 7 &&
//                     activeTab != 1 && (
//                       <Col span={9} style={{ display: "absolute" }}>
//                         <div
//                           className="cancelledSetMessage"
//                           style={{
//                             display: "flex",
//                             justifyContent: "center", // Center content horizontally
//                             alignItems: "center", // Center content vertically
//                             marginTop: "25px",
//                             borderRadius: "4px",
//                             backgroundColor: "#f4f0ec",
//                             padding: "4px 6px",
//                             opacity: 0.95,
//                           }}
//                         >
//                           <div
//                             className="centerAlignMeVertically"
//                             style={{ padding: "2px 6px 0px 3px" }}
//                           >
//                             <Iconmoon
//                               icon="warning_new"
//                               size={20}
//                               style={{ color: "#808080" }}
//                             />
//                           </div>
//                           <span style={{ fontSize: "14px", color: "#555555" }}>
//                             A few sets were cancelled in this job card. Hence,
//                             fulfilled quantity might not be accurate for the
//                             cancelled sets.
//                           </span>
//                         </div>
//                       </Col>
//                     )}
//                 </PageTitleComp>
//                 <div className="MatchResult JobResulted">
//                   <Row span={24}>
//                     {((activeTab != 6 &&
//                       activeTab != 7 &&
//                       ((!sizeExpanded && activeTab == "2") ||
//                         (!sizeExpanded && activeTab == "3") ||
//                         (!sizeExpanded && activeTab == "4") ||
//                         (!sizeExpanded && activeTab == "5"))) ||
//                       activeTab == "1") && (
//                       <Col
//                         span={15}
//                         className="pipeBlock"
//                         style={{
//                           paddingRight: "20px",
//                           transform:
//                             isParentReelCancelled &&
//                             activeTab != 6 &&
//                             activeTab != 7 &&
//                             activeTab != 1
//                               ? "translateY(-14px)"
//                               : "",
//                           // transform: isParentReelCancelled && activeTab >= 2
//                           //   ? "translateY(-14px)"
//                           //   : "",
//                         }}
//                       >
//                         <>
//                           <TableList>
//                             <div
//                               className="radioSwitchStyle"
//                               style={{ zIndex: 10 }}
//                             >
//                               <div className="table-view">
//                                 <HaberForm>
//                                   <RadioButtonStyle>
//                                     <div
//                                       className="boxFormType switchRadio"
//                                       style={{
//                                         justifyContent: "flex-end",
//                                         display: "flex",
//                                         // paddingRight: "",
//                                         transform: "translate(-289px,0px)",
//                                         position: "absolute",
//                                         width: "276px",
//                                       }}
//                                     >
//                                      { orderDetailsList&&<div
//                                         className="List-grid-View"
//                                         onClick={printJobCardDetails}
//                                       >
//                                         <div className="printIcon">
//                                           <svg
//                                             width="20"
//                                             height="20"
//                                             viewBox="0 0 20 20"
//                                             fill="none"
//                                             xmlns="http://www.w3.org/2000/svg"
//                                           >
//                                             <path
//                                               d="M15.8334 6.66667H4.16669C2.78335 6.66667 1.66669 7.78334 1.66669 9.16667V14.1667H5.00002V17.5H15V14.1667H18.3334V9.16667C18.3334 7.78334 17.2167 6.66667 15.8334 6.66667ZM13.3334 15.8333H6.66669V11.6667H13.3334V15.8333ZM15.8334 10C15.375 10 15 9.62501 15 9.16667C15 8.70834 15.375 8.33334 15.8334 8.33334C16.2917 8.33334 16.6667 8.70834 16.6667 9.16667C16.6667 9.62501 16.2917 10 15.8334 10ZM15 2.50001H5.00002V5.83334H15V2.50001Z"
//                                               fill="#605E5C"
//                                             />
//                                           </svg>
//                                         </div>
//                                       </div>}
//                                       <Radio.Group
//                                         options={filterViewData}
//                                         onChange={handleViewChange}
//                                         value={
//                                           isJobcardView && isSheetView
//                                             ? "both"
//                                             : isJobcardView
//                                             ? "reel"
//                                             : "sheet"
//                                         }
//                                         optionType="button"
//                                         buttonStyle="solid"
//                                         className={
//                                           isSheetView && isJobcardView
//                                             ? "allActive"
//                                             : isSheetView
//                                             ? "sheetActive"
//                                             : "jcActive"
//                                         }
//                                         style={{
//                                           display: "flex",
//                                           flexDirection: "row",
//                                         }}
//                                       />
//                                     </div>
//                                   </RadioButtonStyle>
//                                 </HaberForm>
//                               </div>
//                               <div className="table-view">
//                                 <HaberForm>
//                                   <RadioButtonStyle>
//                                     <div
//                                       className="boxFormType switchRadio"
//                                       style={{
//                                         justifyContent: "flex-end",
//                                         display: "flex",
//                                         columnGap: "10px",
//                                       }}
//                                     >
//                                       <Radio.Group
//                                         options={cylinderMode}
//                                         onChange={handleCylinderViewChange}
//                                         value={cylinderViewData}
//                                         optionType="button"
//                                         buttonStyle="solid"
//                                         className={
//                                           cylinderViewData === "production"
//                                             ? "ListViewActive"
//                                             : "gridViewActive"
//                                         }
//                                       />
//                                       <Radio.Group
//                                         options={gridViewData}
//                                         onChange={handleViewChangeGrid}
//                                         value={isTabularView}
//                                         optionType="button"
//                                         buttonStyle="solid"
//                                         className={
//                                           !isTabularView
//                                             ? "gridViewActive"
//                                             : "ListViewActive"
//                                         }
//                                       />
//                                     </div>
//                                   </RadioButtonStyle>
//                                 </HaberForm>
//                               </div>
//                             </div>
//                           </TableList>

//                           <div
//                             style={{
//                               display: isJobcardView ? "block" : "none",
//                               padding: "0px",
//                               margin: "0px",
//                               transform: "translateY(-20px)",
//                             }}
//                           >
//                             <JobCardCylinderContainerMultistage
//                               jobId={jobId}
//                               solution={acceptedSolution.key}
//                               multiView={false}
//                               print_function={
//                                 orderDetailsList ? printJobCardDetails : null
//                               }
//                               collapse={props.collapse}
//                               isPrintDisabled={isPrintDisabled}
//                               toggleFetchingData={toggleFetchingData}
//                               // style={{width:'80%'}}
//                               deckleSize={calculateDeckleSize(jobCard, true)}
//                               rewinderName={`${
//                                 jobCard?.jobcard?.group.machines?.find(
//                                   (item) => item.machine_type !== "cutter"
//                                 )?.rewinder_name
//                               }`}
//                               solId={acceptedSolution.key}
//                               isTabularView={isTabularView}
//                               cylinderViewData={cylinderViewData}
//                             />
//                           </div>

//                           {isSheetView && (
//                             <SheetJobCardCylinderContainerMultistage
//                               jobId={jobId}
//                               solution={acceptedSolution.key}
//                               multiView={false}
//                               acceptedSolution={acceptedSolution?.solution}
//                               jobCard={jobCard.jobcard}
//                               print_function={
//                                 orderDetailsList ? printJobCardDetails : null
//                               }
//                               unitData={unitData}
//                               isTabularView={isTabularView}
//                               cylinderViewData={cylinderViewData}
//                             />
//                           )}
//                         </>
//                       </Col>
//                     )}
//                     <Col
//                       span={
//                         activeTab == 6 || activeTab == 7
//                           ? 24
//                           : ((sizeExpanded && activeTab == "2") ||
//                               (sizeExpanded && activeTab == "3") ||
//                               (sizeExpanded && activeTab == "4") ||
//                               (sizeExpanded && activeTab == "5")) &&
//                             activeTab != "1"
//                           ? 24
//                           : 9
//                       }
//                       className="colLayoutBlock leftPostTab"
//                     >
//                       <Tabs
//                         defaultActiveKey="1"
//                         activeKey={activeTab}
//                         onChange={tabChange}
//                         className="topPostTab innerPostTab"
//                       >
//                         <Panes tab="Summary" key="1">
//                           <div className="lossValue">
//                             <Row span={24} style={{ paddingTop: "10px" }}>
//                               <Col span={12}>
//                                 <div
//                                   className={
//                                     isParentReelCancelled
//                                       ? "summaryValueCancelled"
//                                       : "summaryValue"
//                                   }
//                                 >
//                                   <h5>
//                                     <span className="trimCut"></span> Trim Loss
//                                   </h5>
//                                   <span>
//                                     {acceptedSolution?.solution
//                                       ? acceptedSolution.solution.data.summary.match_trim_loss_percentage.toFixed(
//                                           3
//                                         )
//                                       : ""}{" "}
//                                     %
//                                   </span>
//                                 </div>
//                               </Col>
//                               <Col span={12}>
//                                 <div
//                                   className={
//                                     isParentReelCancelled
//                                       ? "summaryValueCancelled"
//                                       : "summaryValue"
//                                   }
//                                 >
//                                   <h5>
//                                     <span className="trimBox"></span> Fulfilment
//                                   </h5>
//                                   <span>
//                                     {acceptedSolution &&
//                                     acceptedSolution.solution
//                                       ? acceptedSolution.solution?.data.summary?.weight_requirement_fulfilled_percentage.toFixed(
//                                           3
//                                         )
//                                       : ""}{" "}
//                                     %
//                                   </span>
//                                 </div>
//                               </Col>
//                             </Row>
//                             <Row span={24}>
//                               <Col span={12}>
//                                 <div
//                                   className={
//                                     isParentReelCancelled
//                                       ? "summaryValueCancelled"
//                                       : "summaryValue"
//                                   }
//                                 >
//                                   <h5>
//                                     <span className="trimCut"></span> Net Trim
//                                     Loss:{" "}
//                                     {acceptedSolution.solution?.data.summary?.net_trim_loss_percentage.toFixed(
//                                       3
//                                     )}{" "}
//                                     %<p>Loss including edge trim</p>
//                                   </h5>
//                                 </div>
//                               </Col>
//                               <Col span={12}>
//                                 <div
//                                   className={
//                                     isParentReelCancelled
//                                       ? "summaryValueCancelled"
//                                       : "summaryValue"
//                                   }
//                                 >
//                                   <h5>
//                                     <span className="trimBox"></span> Weight:{" "}
//                                     {acceptedSolution.solution?.data.summary?.job_card_weight.toFixed(
//                                       3
//                                     )}{" "}
//                                     {acceptedSolution.solution?.data.summary
//                                       .units &&
//                                     acceptedSolution.solution?.data.summary
//                                       .units.job_card_weight
//                                       ? capitalize(
//                                           weightUnit[
//                                             acceptedSolution.solution?.data
//                                               .summary.units.job_card_weight
//                                           ]?.displayName
//                                         )
//                                       : "T"}
//                                     <p className="lesserSolution">
//                                       Total weight of Job Card
//                                     </p>
//                                   </h5>
//                                 </div>
//                               </Col>
//                             </Row>

//                             {isParentReelCancelled && (
//                               <>
//                                 <Row span={24} style={{ paddingTop: "10px" }}>
//                                   <Col span={12}>
//                                     <div className={"summaryValue"}>
//                                       <h5>
//                                         <span className="trimCut"></span>Updated
//                                         Trim Loss
//                                       </h5>
//                                       <span>
//                                         {acceptedSolution?.solution
//                                           ? acceptedSolution.solution.data.summary.new_match_trim_loss_percentage.toFixed(
//                                               3
//                                             )
//                                           : ""}{" "}
//                                         %
//                                       </span>
//                                     </div>
//                                   </Col>
//                                   <Col span={12}>
//                                     <div className={"summaryValue"}>
//                                       <h5>
//                                         <span className="trimBox"></span>Updated
//                                         Fulfilment
//                                       </h5>
//                                       <span>
//                                         {acceptedSolution &&
//                                         acceptedSolution.solution
//                                           ? acceptedSolution.solution?.data.summary?.new_weight_requirement_fulfilled_percentage.toFixed(
//                                               3
//                                             )
//                                           : ""}{" "}
//                                         {acceptedSolution &&
//                                         acceptedSolution.solution &&
//                                         acceptedSolution.solution?.data.summary
//                                           ?.units?.fulfilled_requirement_weight
//                                           ? capitalize(
//                                               weightUnit[
//                                                 acceptedSolution.solution?.data
//                                                   .summary?.units
//                                                   ?.fulfilled_requirement_weight
//                                               ].displayName
//                                             )
//                                           : "T"}
//                                       </span>
//                                     </div>
//                                   </Col>
//                                 </Row>

//                                 <Row span={24}>
//                                   <Col span={12}>
//                                     <div className={"summaryValue"}>
//                                       <h5>
//                                         <span className="trimCut"></span>Updated
//                                         Net Trim Loss:{" "}
//                                         {acceptedSolution.solution?.data.summary?.new_net_trim_loss_percentage?.toFixed(
//                                           3
//                                         )}{" "}
//                                         %<p>Loss including edge trim</p>
//                                       </h5>
//                                     </div>
//                                   </Col>
//                                   <Col span={12}>
//                                     <div className={"summaryValue"}>
//                                       <h5>
//                                         <span className="trimBox"></span>Updated
//                                         Weight:{" "}
//                                         {acceptedSolution.solution?.data.summary?.new_job_card_weight?.toFixed(
//                                           3
//                                         )}{" "}
//                                         {acceptedSolution.solution?.data.summary
//                                           .units &&
//                                         acceptedSolution.solution?.data.summary
//                                           .units.job_card_weight
//                                           ? capitalize(
//                                               weightUnit[
//                                                 acceptedSolution.solution?.data
//                                                   .summary.units.job_card_weight
//                                               ]?.displayName
//                                             )
//                                           : "T"}
//                                         <p className="lesserSolution">
//                                           Total weight of Job Card
//                                         </p>
//                                       </h5>
//                                     </div>
//                                   </Col>
//                                 </Row>
//                               </>
//                             )}
//                             <Collapse
//                               className="sub-category"
//                               expandIconPosition="right"
//                               defaultActiveKey={["1", "2", "3", "4"]}
//                               style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                               }}
//                             >
//                               <CollapsePanel
//                                 key="1"
//                                 header="General Information"
//                               >
//                                 <Row
//                                   span={24}
//                                   style={{
//                                     display: "flex",
//                                     justifyContent: "space-between",
//                                   }}
//                                 >
//                                   <Col span={11}>
//                                     {" "}
//                                     <span>Product Specifications</span>
//                                     <p
//                                       style={{
//                                         wordWrap: "break-word",
//                                       }}
//                                     >
//                                       {jobCard?.jobcard.product.product_spec}
//                                     </p>
//                                   </Col>

//                                   <Col span={11}>
//                                     <span>Priority Quantity</span>
//                                     <p>
//                                       {jobCard?.jobcard[
//                                         `solution_${acceptedSolution.key}`
//                                       ].data.summary?.forced_weight_requirement
//                                         ? jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary.forced_weight_requirement.toFixed(
//                                             3
//                                           )
//                                         : 0}{" "}
//                                       {jobCard?.jobcard[
//                                         `solution_${acceptedSolution.key}`
//                                       ].data.summary?.units
//                                         ?.forced_weight_requirement
//                                         ? capitalize(
//                                             weightUnit[
//                                               jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary?.units
//                                                 .forced_weight_requirement
//                                             ]?.displayName
//                                           )
//                                         : "T"}
//                                     </p>
//                                   </Col>
//                                 </Row>
//                                 {isParentReelCancelled && (
//                                   <Row
//                                     span={24}
//                                     style={{
//                                       display: "flex",
//                                       justifyContent: "space-between",
//                                       padding: "10px 0px 0 0",
//                                     }}
//                                   >
//                                     <Col span={11}>
//                                       <span
//                                         className="updatedText"
//                                         style={{
//                                           display: "flex",
//                                           gap: "5px",
//                                           alignItems: "center",
//                                         }}
//                                       >
//                                         Updated Priority Qty{" "}
//                                         <Styled>
//                                           <Tooltip
//                                             placement="bottom"
//                                             title={`This is the updated priority quantity after a few sets were cancelled`}
//                                             className="edit-tooltip"
//                                           >
//                                             <Iconmoon
//                                               icon="info_new"
//                                               size={14}
//                                               color="black"
//                                               style={{
//                                                 // opacity: 0.7,
//                                                 // marginTop: "2px",
//                                                 float: "right",
//                                               }}
//                                             />
//                                           </Tooltip>
//                                         </Styled>
//                                       </span>
//                                       <p>
//                                         {jobCard?.jobcard[
//                                           `solution_${acceptedSolution.key}`
//                                         ].data.summary
//                                           ?.new_forced_weight_requirement
//                                           ? jobCard?.jobcard[
//                                               `solution_${acceptedSolution.key}`
//                                             ].data.summary.new_forced_weight_requirement.toFixed(
//                                               3
//                                             )
//                                           : 0}{" "}
//                                         {jobCard?.jobcard[
//                                           `solution_${acceptedSolution.key}`
//                                         ].data.summary?.units
//                                           ?.new_forced_weight_requirement
//                                           ? capitalize(
//                                               weightUnit[
//                                                 jobCard?.jobcard[
//                                                   `solution_${acceptedSolution.key}`
//                                                 ].data.summary?.units
//                                                   .new_forced_weight_requirement
//                                               ]?.displayName
//                                             )
//                                           : "T"}
//                                       </p>
//                                     </Col>
//                                   </Row>
//                                 )}
//                               </CollapsePanel>

//                               <CollapsePanel key="2" header="Paper Machine">
//                                 <Row
//                                   span={24}
//                                   style={{
//                                     display: "flex",
//                                     justifyContent: "space-between",
//                                   }}
//                                 >
//                                   {" "}
//                                   <Col span={11}>
//                                     <span>Paper Machine</span>
//                                     <p>
//                                       {jobCard?.jobcard.group.machines[0].name}
//                                     </p>
//                                   </Col>
//                                   <Col span={11}>
//                                     <span>Deckle Width</span>
//                                     <p>{calculateDeckleSize(jobCard)}</p>
//                                   </Col>{" "}
//                                 </Row>{" "}
//                               </CollapsePanel>
//                               {isParentReelCancelled ? (
//                                 <>
//                                   <CollapsePanel key="3" header="Rewinding">
//                                     <Row
//                                       span={24}
//                                       style={{
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         padding: "10px 0px",
//                                       }}
//                                     >
//                                       {" "}
//                                       <Col span={11}>
//                                         <span
//                                           className="updatedText"
//                                           style={{
//                                             display: "flex",
//                                             gap: "5px",
//                                             alignItems: "center",
//                                           }}
//                                         >
//                                           Updated Rewinding Qty
//                                           <Styled>
//                                             <Tooltip
//                                               placement="bottom"
//                                               title={`This is the updated quantity that needs to be processed on the rewinder after a few sets were cancelled`}
//                                               className="edit-tooltip"
//                                             >
//                                               <Iconmoon
//                                                 icon="info_new"
//                                                 size={14}
//                                                 color="black"
//                                                 style={{
//                                                   // opacity: 0.7,
//                                                   // marginTop: "2px",
//                                                   float: "right",
//                                                 }}
//                                               />
//                                             </Tooltip>
//                                           </Styled>
//                                         </span>{" "}
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.new_net_rewinding_quantity
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary.new_net_rewinding_quantity.toFixed(
//                                                 3
//                                               )
//                                             : 0}{" "}
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary?.units
//                                             ?.new_net_rewinding_quantity
//                                             ? capitalize(
//                                                 weightUnit[
//                                                   jobCard?.jobcard[
//                                                     `solution_${acceptedSolution.key}`
//                                                   ].data.summary?.units
//                                                     .new_net_rewinding_quantity
//                                                 ]?.displayName
//                                               )
//                                             : "T"}
//                                         </p>
//                                       </Col>
//                                       <Col span={11}>
//                                         <span
//                                           className="updatedText"
//                                           style={{
//                                             display: "flex",
//                                             gap: "5px",
//                                             alignItems: "center",
//                                           }}
//                                         >
//                                           Updated Trim Loss
//                                           <Styled>
//                                             <Tooltip
//                                               placement="bottom"
//                                               title={`This is the updated trim loss of rewinding after a few sets were cancelled`}
//                                               className="edit-tooltip"
//                                             >
//                                               <Iconmoon
//                                                 icon="info_new"
//                                                 size={14}
//                                                 color="black"
//                                                 style={{
//                                                   // opacity: 0.7,
//                                                   // marginTop: "2px",
//                                                   float: "right",
//                                                 }}
//                                               />
//                                             </Tooltip>
//                                           </Styled>
//                                         </span>
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.new_rewinding_net_trim_loss
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary.new_rewinding_net_trim_loss.toFixed(
//                                                 3
//                                               )
//                                             : 0}{" "}
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary?.units
//                                             ?.new_rewinding_net_trim_loss
//                                             ? capitalize(
//                                                 weightUnit[
//                                                   jobCard?.jobcard[
//                                                     `solution_${acceptedSolution.key}`
//                                                   ].data.summary?.units
//                                                     .new_rewinding_net_trim_loss
//                                                 ]?.displayName
//                                               )
//                                             : "T"}
//                                         </p>
//                                       </Col>{" "}
//                                     </Row>{" "}
//                                     <Row
//                                       span={24}
//                                       style={{
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         padding: "10px 0px",
//                                       }}
//                                     >
//                                       {" "}
//                                       <Col span={11}>
//                                         <span>Rewinder</span>{" "}
//                                         <p>
//                                           {
//                                             jobCard?.jobcard?.group.machines?.filter(
//                                               (item) =>
//                                                 item.machine_type === "rewinder"
//                                             )[0]?.rewinder_name
//                                           }
//                                         </p>
//                                       </Col>
//                                       <Col span={11}>
//                                         <span
//                                           className="updatedText"
//                                           style={{
//                                             display: "flex",
//                                             gap: "5px",
//                                             alignItems: "center",
//                                           }}
//                                         >
//                                           Updated Processed Order
//                                           <Styled>
//                                             <Tooltip
//                                               placement="bottom"
//                                               title={`This is the updated order quantity fulfilled on the rewinder after a few sets were cancelled`}
//                                               className="edit-tooltip"
//                                             >
//                                               <Iconmoon
//                                                 icon="info_new"
//                                                 size={14}
//                                                 color="black"
//                                                 style={{
//                                                   // opacity: 0.7,
//                                                   // marginTop: "2px",
//                                                   float: "right",
//                                                 }}
//                                               />
//                                             </Tooltip>
//                                           </Styled>
//                                         </span>
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.new_rewinder_processed_order_quantity
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary.new_rewinder_processed_order_quantity.toFixed(
//                                                 3
//                                               )
//                                             : 0}{" "}
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary?.units
//                                             ?.new_rewinder_processed_order_quantity
//                                             ? capitalize(
//                                                 weightUnit[
//                                                   jobCard?.jobcard[
//                                                     `solution_${acceptedSolution.key}`
//                                                   ].data.summary?.units
//                                                     .new_rewinder_processed_order_quantity
//                                                 ]?.displayName
//                                               )
//                                             : "T"}
//                                         </p>
//                                       </Col>{" "}
//                                     </Row>{" "}
//                                     <Row
//                                       span={24}
//                                       style={{
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         padding: "10px 0px",
//                                       }}
//                                     >
//                                       {" "}
//                                       <Col span={11}>
//                                         <span
//                                           className="updatedText"
//                                           style={{
//                                             display: "flex",
//                                             gap: "5px",
//                                             alignItems: "center",
//                                           }}
//                                         >
//                                           Updated Unique Sets
//                                           <Styled>
//                                             <Tooltip
//                                               placement="bottom"
//                                               className="edit-tooltip"
//                                               title="This is the updated number of unique sets after a few sets were cancelled"
//                                             >
//                                               <Iconmoon
//                                                 icon="info_new"
//                                                 size={14}
//                                                 color="black"
//                                                 style={{
//                                                   // opacity: 0.7,
//                                                   // marginTop: "2px",
//                                                   float: "right",
//                                                 }}
//                                               />
//                                             </Tooltip>
//                                           </Styled>
//                                         </span>{" "}
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.new_unique_rewinding_partitions
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary
//                                                 .new_unique_rewinding_partitions
//                                             : 0}{" "}
//                                         </p>
//                                       </Col>
//                                       <Col span={11}>
//                                         <span
//                                           className="updatedText"
//                                           style={{
//                                             display: "flex",
//                                             gap: "5px",
//                                             alignItems: "center",
//                                           }}
//                                         >
//                                           Updated Total Sets
//                                           <Styled>
//                                             <Tooltip
//                                               placement="bottom"
//                                               title={`This is the updated number of total sets to be processed on this rewinder after a few sets were cancelled`}
//                                               className="edit-tooltip"
//                                             >
//                                               <Iconmoon
//                                                 icon="info_new"
//                                                 size={14}
//                                                 color="black"
//                                                 style={{
//                                                   // opacity: 0.7,
//                                                   // marginTop: "2px",
//                                                   float: "right",
//                                                 }}
//                                               />
//                                             </Tooltip>
//                                           </Styled>
//                                         </span>
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.new_total_rewinding_partitions
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary
//                                                 .new_total_rewinding_partitions
//                                             : 0}{" "}
//                                         </p>
//                                       </Col>{" "}
//                                     </Row>{" "}
//                                   </CollapsePanel>
//                                   <CollapsePanel key="4" header="Cutting">
//                                     <Row
//                                       span={24}
//                                       style={{
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         padding: "10px 0px",
//                                       }}
//                                     >
//                                       {" "}
//                                       <Col span={11}>
//                                         <span
//                                           className="updatedText"
//                                           style={{
//                                             display: "flex",
//                                             gap: "5px",
//                                             alignItems: "center",
//                                           }}
//                                         >
//                                           Updated Cutting Qty
//                                           <Styled>
//                                             <Tooltip
//                                               placement="bottom"
//                                               title={`This is the updated quantity that needs to be processed on the cutter after a few sets were cancelled`}
//                                               className="edit-tooltip"
//                                             >
//                                               <Iconmoon
//                                                 icon="info_new"
//                                                 size={14}
//                                                 color="black"
//                                                 style={{
//                                                   // opacity: 0.7,
//                                                   // marginTop: "2px",
//                                                   float: "right",
//                                                 }}
//                                               />
//                                             </Tooltip>
//                                           </Styled>
//                                         </span>{" "}
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.new_net_cutting_quantity
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary.new_net_cutting_quantity.toFixed(
//                                                 3
//                                               )
//                                             : 0}{" "}
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary?.units
//                                             ?.new_net_cutting_quantity
//                                             ? capitalize(
//                                                 weightUnit[
//                                                   jobCard?.jobcard[
//                                                     `solution_${acceptedSolution.key}`
//                                                   ].data.summary?.units
//                                                     .new_net_cutting_quantity
//                                                 ]?.displayName
//                                               )
//                                             : "T"}
//                                         </p>
//                                       </Col>
//                                       <Col span={11}>
//                                         <span
//                                           className="updatedText"
//                                           style={{
//                                             display: "flex",
//                                             gap: "5px",
//                                             alignItems: "center",
//                                           }}
//                                         >
//                                           Updated Trim Loss
//                                           <Styled>
//                                             <Tooltip
//                                               placement="bottom"
//                                               title={`This is the updated trim loss of cutting after a few sets were cancelled`}
//                                               className="edit-tooltip"
//                                             >
//                                               <Iconmoon
//                                                 icon="info_new"
//                                                 size={14}
//                                                 color="black"
//                                                 style={{
//                                                   // opacity: 0.7,
//                                                   // marginTop: "2px",
//                                                   float: "right",
//                                                 }}
//                                               />
//                                             </Tooltip>
//                                           </Styled>
//                                         </span>
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.new_cutting_net_trim_loss
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary.new_cutting_net_trim_loss.toFixed(
//                                                 3
//                                               )
//                                             : 0}{" "}
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary?.units
//                                             ?.new_cutting_net_trim_loss
//                                             ? capitalize(
//                                                 weightUnit[
//                                                   jobCard?.jobcard[
//                                                     `solution_${acceptedSolution.key}`
//                                                   ].data.summary?.units
//                                                     .new_cutting_net_trim_loss
//                                                 ]?.displayName
//                                               )
//                                             : "T"}
//                                         </p>
//                                       </Col>{" "}
//                                     </Row>{" "}
//                                     <Row
//                                       span={24}
//                                       style={{
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         padding: "10px 0px",
//                                       }}
//                                     >
//                                       {" "}
//                                       <Col span={11}>
//                                         <span>Cutter</span>{" "}
//                                         <p>
//                                           {
//                                             jobCard?.jobcard?.group.machines?.filter(
//                                               (item) =>
//                                                 item.machine_type === "cutter"
//                                             )[0]?.cutter_name
//                                           }
//                                         </p>
//                                       </Col>
//                                       <Col span={11}>
//                                         <span
//                                           className="updatedText"
//                                           style={{
//                                             display: "flex",
//                                             gap: "5px",
//                                             alignItems: "center",
//                                           }}
//                                         >
//                                           Updated Processed Order
//                                           <Styled>
//                                             <Tooltip
//                                               placement="bottom"
//                                               title={`This is the updated order quantity fulfilled on the cutter after a few sets were cancelled`}
//                                               className="edit-tooltip"
//                                             >
//                                               <Iconmoon
//                                                 icon="info_new"
//                                                 size={14}
//                                                 color="black"
//                                                 style={{
//                                                   // opacity: 0.7,
//                                                   // marginTop: "2px",
//                                                   float: "right",
//                                                 }}
//                                               />
//                                             </Tooltip>
//                                           </Styled>
//                                         </span>
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.new_cutting_processed_order_quantity
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary.new_cutting_processed_order_quantity.toFixed(
//                                                 3
//                                               )
//                                             : 0}{" "}
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary?.units
//                                             ?.new_cutting_processed_order_quantity
//                                             ? capitalize(
//                                                 weightUnit[
//                                                   jobCard?.jobcard[
//                                                     `solution_${acceptedSolution.key}`
//                                                   ].data.summary?.units
//                                                     .new_cutting_processed_order_quantity
//                                                 ]?.displayName
//                                               )
//                                             : "T"}
//                                         </p>
//                                       </Col>{" "}
//                                     </Row>{" "}
//                                     <Row
//                                       span={24}
//                                       style={{
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         padding: "10px 0px",
//                                       }}
//                                     >
//                                       {" "}
//                                       <Col span={11}>
//                                         <span
//                                           className="updatedText"
//                                           style={{
//                                             display: "flex",
//                                             gap: "5px",
//                                             alignItems: "center",
//                                           }}
//                                         >
//                                           Updated Unique Sets
//                                           <Styled>
//                                             <Tooltip
//                                               placement="bottom"
//                                               title={`This is the updated number of unique sets after a few sets were cancelled`}
//                                               className="edit-tooltip"
//                                             >
//                                               <Iconmoon
//                                                 icon="info_new"
//                                                 size={14}
//                                                 color="black"
//                                                 style={{
//                                                   // opacity: 0.7,
//                                                   // marginTop: "2px",
//                                                   float: "right",
//                                                 }}
//                                               />
//                                             </Tooltip>
//                                           </Styled>
//                                         </span>{" "}
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.new_unique_cutting_patterns
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary
//                                                 .new_unique_cutting_patterns
//                                             : 0}{" "}
//                                         </p>
//                                       </Col>
//                                       <Col span={11}>
//                                         <span
//                                           className="updatedText"
//                                           style={{
//                                             display: "flex",
//                                             gap: "5px",
//                                             alignItems: "center",
//                                           }}
//                                         >
//                                           Updated Sets
//                                           <Styled>
//                                             <Tooltip
//                                               placement="bottom"
//                                               title={`This is the updated number of total sets to be processed on this cutter after a few sets were cancelled`}
//                                               className="edit-tooltip"
//                                             >
//                                               <Iconmoon
//                                                 icon="info_new"
//                                                 size={14}
//                                                 color="black"
//                                                 style={{
//                                                   // opacity: 0.7,
//                                                   // marginTop: "2px",
//                                                   float: "right",
//                                                 }}
//                                               />
//                                             </Tooltip>
//                                           </Styled>
//                                         </span>
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.new_total_cutting_partitions
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary
//                                                 .new_total_cutting_partitions
//                                             : 0}{" "}
//                                         </p>
//                                       </Col>{" "}
//                                     </Row>{" "}
//                                   </CollapsePanel>
//                                 </>
//                               ) : (
//                                 <>
//                                   <CollapsePanel key="3" header="Rewinding">
//                                     <Row
//                                       span={24}
//                                       style={{
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         padding: "10px 0px",
//                                       }}
//                                     >
//                                       {" "}
//                                       <Col span={11}>
//                                         <span>Net Rewinding Qty</span>{" "}
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary?.net_rewinding_quantity
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary.net_rewinding_quantity.toFixed(
//                                                 3
//                                               )
//                                             : 0}{" "}
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary?.units
//                                             ?.net_rewinding_quantity
//                                             ? capitalize(
//                                                 weightUnit[
//                                                   jobCard?.jobcard[
//                                                     `solution_${acceptedSolution.key}`
//                                                   ].data.summary?.units
//                                                     .net_rewinding_quantity
//                                                 ]?.displayName
//                                               )
//                                             : "T"}
//                                         </p>
//                                       </Col>
//                                       <Col span={11}>
//                                         <span>Trim Loss</span>
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.rewinding_net_trim_loss
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary.rewinding_net_trim_loss.toFixed(
//                                                 3
//                                               )
//                                             : 0}{" "}
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary?.units
//                                             ?.rewinding_net_trim_loss
//                                             ? capitalize(
//                                                 weightUnit[
//                                                   jobCard?.jobcard[
//                                                     `solution_${acceptedSolution.key}`
//                                                   ].data.summary?.units
//                                                     .rewinding_net_trim_loss
//                                                 ]?.displayName
//                                               )
//                                             : "T"}
//                                         </p>
//                                       </Col>{" "}
//                                     </Row>{" "}
//                                     <Row
//                                       span={24}
//                                       style={{
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         padding: "10px 0px",
//                                       }}
//                                     >
//                                       {" "}
//                                       <Col span={11}>
//                                         <span>Rewinder</span>{" "}
//                                         <p>
//                                           {
//                                             jobCard?.jobcard?.group.machines?.filter(
//                                               (item) =>
//                                                 item.machine_type === "rewinder"
//                                             )[0]?.rewinder_name
//                                           }
//                                         </p>
//                                       </Col>
//                                       <Col span={11}>
//                                         <span>Processed Order Qty</span>
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.rewinder_processed_order_quantity
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary.rewinder_processed_order_quantity.toFixed(
//                                                 3
//                                               )
//                                             : 0}{" "}
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary?.units
//                                             ?.rewinder_processed_order_quantity
//                                             ? capitalize(
//                                                 weightUnit[
//                                                   jobCard?.jobcard[
//                                                     `solution_${acceptedSolution.key}`
//                                                   ].data.summary?.units
//                                                     .rewinder_processed_order_quantity
//                                                 ]?.displayName
//                                               )
//                                             : "T"}
//                                         </p>
//                                       </Col>{" "}
//                                     </Row>{" "}
//                                     <Row
//                                       span={24}
//                                       style={{
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         padding: "10px 0px",
//                                       }}
//                                     >
//                                       {" "}
//                                       <Col span={11}>
//                                         <span>Number of Unique Sets</span>{" "}
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.unique_rewinding_partitions
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary
//                                                 .unique_rewinding_partitions
//                                             : 0}{" "}
//                                         </p>
//                                       </Col>
//                                       <Col span={11}>
//                                         <span>Total Number of Sets</span>
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.total_rewinding_partitions
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary
//                                                 .total_rewinding_partitions
//                                             : 0}{" "}
//                                         </p>
//                                       </Col>{" "}
//                                     </Row>{" "}
//                                   </CollapsePanel>
//                                   <CollapsePanel key="4" header="Cutting">
//                                     <Row
//                                       span={24}
//                                       style={{
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         padding: "10px 0px",
//                                       }}
//                                     >
//                                       {" "}
//                                       <Col span={11}>
//                                         <span>Net Cutting Qty</span>{" "}
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary?.net_cutting_quantity
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary.net_cutting_quantity.toFixed(
//                                                 3
//                                               )
//                                             : 0}{" "}
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary?.units
//                                             ?.net_cutting_quantity
//                                             ? capitalize(
//                                                 weightUnit[
//                                                   jobCard?.jobcard[
//                                                     `solution_${acceptedSolution.key}`
//                                                   ].data.summary?.units
//                                                     .net_cutting_quantity
//                                                 ]?.displayName
//                                               )
//                                             : "T"}
//                                         </p>
//                                       </Col>
//                                       <Col span={11}>
//                                         <span>Trim Loss</span>
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary?.cutting_net_trim_loss
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary.cutting_net_trim_loss.toFixed(
//                                                 3
//                                               )
//                                             : 0}{" "}
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary?.units
//                                             ?.cutting_net_trim_loss
//                                             ? capitalize(
//                                                 weightUnit[
//                                                   jobCard?.jobcard[
//                                                     `solution_${acceptedSolution.key}`
//                                                   ].data.summary?.units
//                                                     .cutting_net_trim_loss
//                                                 ]?.displayName
//                                               )
//                                             : "T"}
//                                         </p>
//                                       </Col>{" "}
//                                     </Row>{" "}
//                                     <Row
//                                       span={24}
//                                       style={{
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         padding: "10px 0px",
//                                       }}
//                                     >
//                                       {" "}
//                                       <Col span={11}>
//                                         <span>Cutter</span>{" "}
//                                         <p>
//                                           {
//                                             jobCard?.jobcard?.group.machines?.filter(
//                                               (item) =>
//                                                 item.machine_type === "cutter"
//                                             )[0]?.cutter_name
//                                           }
//                                         </p>
//                                       </Col>
//                                       <Col span={11}>
//                                         <span>Processed Order Qty</span>
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.cutting_processed_order_quantity
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary.cutting_processed_order_quantity.toFixed(
//                                                 3
//                                               )
//                                             : 0}{" "}
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary?.units
//                                             ?.cutting_processed_order_quantity
//                                             ? capitalize(
//                                                 weightUnit[
//                                                   jobCard?.jobcard[
//                                                     `solution_${acceptedSolution.key}`
//                                                   ].data.summary?.units
//                                                     .cutting_processed_order_quantity
//                                                 ]?.displayName
//                                               )
//                                             : "T"}
//                                         </p>
//                                       </Col>{" "}
//                                     </Row>{" "}
//                                     <Row
//                                       span={24}
//                                       style={{
//                                         display: "flex",
//                                         justifyContent: "space-between",
//                                         padding: "10px 0px",
//                                       }}
//                                     >
//                                       {" "}
//                                       <Col span={11}>
//                                         <span>Number of Unique Sets</span>{" "}
//                                         <p>
//                                           {jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary
//                                             ?.unique_cutting_patterns
//                                             ? jobCard?.jobcard[
//                                                 `solution_${acceptedSolution.key}`
//                                               ].data.summary
//                                                 .unique_cutting_patterns
//                                             : 0}{" "}
//                                         </p>
//                                       </Col>
//                                       {/* <Col span={11}>
//                                     <span>Total Number of Sets</span>
//                                     <p>
//                                       {jobCard?.jobcard[
//                                         `solution_${acceptedSolution.key}`
//                                       ].data.summary?.total_cutting_partitions
//                                         ? jobCard?.jobcard[
//                                             `solution_${acceptedSolution.key}`
//                                           ].data.summary.total_cutting_partitions
//                                         : 0}{" "}
//                                     </p>
//                                   </Col>{" "} */}
//                                     </Row>{" "}
//                                   </CollapsePanel>
//                                 </>
//                               )}
//                             </Collapse>

//                             {jobCard.jobcard.group.merged && (
//                               <div className="alertmsd">
//                                 <h4>Merge Orders</h4>
//                                 <AlertContainer
//                                   color="blue"
//                                   icon={alertBlue}
//                                   msg="This Jobcard has merged orders"
//                                 />
//                               </div>
//                             )}
//                             {jobCard.state == "rejected" && (
//                               <div className="alertmsd">
//                                 <h4>Approver Remarks</h4>
//                                 <AlertContainer
//                                   color="red"
//                                   icon={alertRed}
//                                   msg={
//                                     jobCard.comments.length
//                                       ? jobCard.comments
//                                       : `Approver remarks does not have any data`
//                                   }
//                                 />
//                               </div>
//                             )}
//                           </div>
//                         </Panes>
//                         <Panes
//                           tab={
//                             <span>
//                               Size Fulfilment
//                               {activeTab == "2" && (
//                                 <Button
//                                   key="1"
//                                   style={{ border: "none" }}
//                                   onClick={(e) =>
//                                     setSizeExpanded(!sizeExpanded)
//                                   }
//                                 >
//                                   <Iconmoon
//                                     icon={
//                                       sizeExpanded
//                                         ? "contract_arrow"
//                                         : "expand_arrow"
//                                     }
//                                     size={14}
//                                     color="#EA4E2C"
//                                   />
//                                 </Button>
//                               )}
//                             </span>
//                           }
//                           key="2"
//                         >
//                           {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
//                       color="blue"
//                       icon={warningjob}
//                       msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
//                       removeBottomMargin={true}
//                       jobCard = {true}
//                     /> : ''} */}
//                           <TableLayoutData>
//                             <div
//                               className="tableDataFormat  "
//                               style={{ marginTop: "25px" }}
//                             >
//                               <Table
//                                 columns={sizeFulfillmentColumnsHead}
//                                 // dataSource={sizeFulfillmentDetailsList?.filter(
//                                 //   (order) => order.fulflilledWeight.split(" ")[0] > 0
//                                 // )}
//                                 dataSource={sizeFulfillmentDetailsList}
//                                 onChange={onChange}
//                                 scroll={{ x: 1200 }}
//                                 rowClassName={(record) =>
//                                   record.priority && "true"
//                                 }
//                                 pagination={{
//                                   total: sizeFulfillmentDetailsList?.length,
//                                   showTitle: false,
//                                   showSizeChanger: true,
//                                   showTotal: (total, range) =>
//                                     `Showing ${range[0]}-${range[1]} of ${total} results`,
//                                   pageSizeOptions: [10, 20, 50, 100],
//                                   current: currentPage,
//                                   pageSize: pageSize,
//                                   // showSizeChanger: true,
//                                 }}
//                               />
//                             </div>
//                           </TableLayoutData>
//                         </Panes>
//                         <Panes
//                           tab={
//                             <span>
//                               Order Fulfillment
//                               {activeTab == "3" && (
//                                 <Button
//                                   key="1"
//                                   style={{ border: "none" }}
//                                   onClick={(e) =>
//                                     setSizeExpanded(!sizeExpanded)
//                                   }
//                                 >
//                                   <Iconmoon
//                                     icon={
//                                       sizeExpanded
//                                         ? "contract_arrow"
//                                         : "expand_arrow"
//                                     }
//                                     size={14}
//                                     color="#EA4E2C"
//                                   />
//                                 </Button>
//                               )}
//                             </span>
//                           }
//                           key="3"
//                         >
//                           <TableLayoutData>
//                             <div
//                               className="tableDataFormat  "
//                               style={{ marginTop: "25px" }}
//                             >
//                               {" "}
//                               {isFetchingData ? (
//                                 <TableShimmer
//                                   header={orderFulfillmentColumnsHead}
//                                   scroll={1600}
//                                 />
//                               ) : (
//                                 <Table
//                                   columns={orderFulfillmentColumnsHead}
//                                   dataSource={orderDetailsList}
//                                   onChange={onChange}
//                                   scroll={{ x: 1900 }}
//                                   rowClassName={(record) =>
//                                     record.priority && "true"
//                                   }
//                                   pagination={{
//                                     current: currentPage,
//                                     pageSize: pageSize,
//                                     total: orderDetailsList?.length,
//                                     onChange: onPaginationChange,
//                                     showSizeChanger: true,
//                                     // showQuickJumper: true,
//                                     // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
//                                     showTotal: (total, range) =>
//                                     `Showing ${range[0]}-${range[1]} of ${total} results`,
//                                     pageSizeOptions: [10, 20, 50, 100],
//                                   }}
//                                 />
//                               )}
//                             </div>
//                           </TableLayoutData>
//                         </Panes>
//                         <Panes
//                           tab={
//                             <span>
//                               Intermediate Reels
//                               {activeTab == "5" && (
//                                 <Button
//                                   key="1"
//                                   style={{ border: "none" }}
//                                   onClick={(e) =>
//                                     setSizeExpanded(!sizeExpanded)
//                                   }
//                                 >
//                                   <Iconmoon
//                                     icon={
//                                       sizeExpanded
//                                         ? "contract_arrow"
//                                         : "expand_arrow"
//                                     }
//                                     size={14}
//                                     color="#EA4E2C"
//                                   />
//                                 </Button>
//                               )}
//                             </span>
//                           }
//                           key="5"
//                           // disabled={solutionSummary?.solution1.exception}
//                         >
//                           {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
//                       color="blue"
//                       icon={warningjob}
//                       msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
//                       removeBottomMargin={true}
//                       jobCard = {true}
//                     /> : ''} */}
//                           <TableLayoutData>
//                             <div
//                               className="tableDataFormat"
//                               style={{ marginTop: "25px" }}
//                             >
//                               <Table
//                                 columns={intermediateColumnsHead}
//                                 dataSource={intermediateData}
//                                 onChange={onChange}
//                                 scroll={{ x: 1200 }}
//                                 rowClassName={(record) =>
//                                   record.priority && "true"
//                                 }
//                                 pagination={{
//                                     current: currentPage,
//                                     pageSize: pageSize,
//                                     total: intermediateData?.length,
//                                     onChange: onPaginationChange,
//                                     showSizeChanger: true,
//                                     // showQuickJumper: true,
//                                     // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
//                                     showTotal: (total, range) =>
//                                     `Showing ${range[0]}-${range[1]} of ${total} results`,
//                                     pageSizeOptions: [10, 20, 50, 100],
//                                   }}
//                               />
//                             </div>
//                           </TableLayoutData>
//                         </Panes>
//                         {(jobCard.state === "in_production" ||
//                           jobCard.state === "complete" ||
//                           jobCard.state === "hold") && (
//                           <Panes tab="Map Rewinding" key="6">
//                             <TableLayoutData>
//                               <div
//                                 className="tableDataFormat "
//                                 style={{ marginTop: "25px" }}
//                               >
//                                 {isMapJumboLoading ? (
//                                   <TableShimmer
//                                     header={mapRewindingColumnsHead}
//                                     scroll={2000}
//                                   />
//                                 ) : (
//                                   <Table
//                                     columns={mapRewindingColumnsHead}
//                                     dataSource={jumboReelData}
//                                     onChange={onChange}
//                                     scroll={{
//                                       x: window.screen.width < 1500 && 1350,
//                                     }}
//                                     pagination={{
//                                       total: jumboReelData
//                                         ? jumboReelData.length
//                                         : 0,
//                                       showTitle: false,
//                                       showTotal: (total, range) =>
//                                         `Showing ${range[0]}-${range[1]} of ${total} results`,
//                                         pageSizeOptions: [10, 20, 50, 100],
//                                         current: currentPage,
//                                         pageSize: pageSize,
//                                     }}
//                                   />
//                                 )}
//                               </div>
//                             </TableLayoutData>
//                           </Panes>
//                         )}
//                         {(jobCard.state === "in_production" ||
//                           jobCard.state === "complete" ||
//                           jobCard.state === "hold") && (
//                           <Panes tab="Map Cutting" key="7">
//                             <TableLayoutData>
//                               <div
//                                 className="tableDataFormat "
//                                 style={{ marginTop: "25px" }}
//                               >
//                                 {isMapCuttingLoading ? (
//                                   <TableShimmer
//                                     header={mapCuttingColumnsHead}
//                                     scroll={2000}
//                                   />
//                                 ) : (
//                                   <Table
//                                     columns={mapCuttingColumnsHead}
//                                     dataSource={cuttingJumboReelData}
//                                     onChange={onChange}
//                                     scroll={{
//                                       x: window.screen.width < 1500 && 1370,
//                                     }}
//                                     pagination={{
//                                       total: cuttingJumboReelData
//                                         ? cuttingJumboReelData.length
//                                         : 0,
//                                       showTitle: false,
//                                       showTotal: (total, range) =>
//                                         `Showing ${range[0]}-${range[1]} of ${total} results`,
//                                         pageSizeOptions: [10, 20, 50, 100],
//                                         current: currentPage,
//                                         pageSize: pageSize,
//                                     }}
//                                   />
//                                 )}
//                               </div>
//                             </TableLayoutData>
//                           </Panes>
//                         )}
//                       </Tabs>
//                     </Col>
//                   </Row>
//                 </div>{" "}
//               </SolutionContainer>
//             </DetailFields>
//             {/* approve Modal */}
//             <ConfirmationModal
//               visible={isVisibleApproveModal}
//               icon={warning}
//               cancelAction={approveModalClose}
//               confirmAction={approveModalConfirm}
//               param={jobId}
//             >
//               <span>Are you sure?</span>
//               <p>
//                 You are about to approve this job card, once approved this job
//                 card can’t be altered later
//               </p>
//             </ConfirmationModal>

//             {/* <ConfirmationModal
//           visible={visibleStartProduction}
//           icon={warning}
//           cancelAction={closeStartProductionModal}
//           confirmAction={startProductionModalConfirm}
//           param={jobId}
//         >
//           <span>Start production ?</span>
//           <p>
//             The job card will move to the production. Are you sure you want to
//             proceed?
//           </p>
//         </ConfirmationModal> */}

//             {/* <ConfirmationModal
//           visible={visibleCancelProduction}
//           icon={warning}
//           cancelAction={closeCancelProductionModal}
//           confirmAction={cancelProductionModalConfirm}
//           param={jobId}
//         >
//           <span>Are you sure?</span>
//           <p>
//             You are about to cancel the production for this jobcard, are you
//             sure you want to continue?
//           </p>
//         </ConfirmationModal> */}

//             {/* <ConfirmationModal
//           visible={visibleMarkCompletedModal}
//           icon={warning}
//           cancelAction={closeMarkCompletedModal}
//           confirmAction={markCompletedModalConfirm}
//           param={jobId}
//         >
//           <span>Are you sure?</span>
//           <p>
//             You are about to mark this job as completed, are you sure you want
//             to continue?
//           </p>
//         </ConfirmationModal> */}

//             <JobCardRejectDrawer
//               visible={visibleRejectDrawer}
//               onClose={closeRejectDrawer}
//               onCloseGrade={closeRejectDrawer}
//               jobId={jobId}
//               setReFetch={setReFetch}
//               setActionResponse={setActionResponse}
//               showToaster={showToaster}
//               jobcardCode={jobcardCode}
//             />

//             {viewParentReelJobCardDrawer && (
//               <ParentReelJobCardDrawer
//                 parentReelId={selectedParentReel}
//                 visible={viewParentReelJobCardDrawer}
//                 onCloseParentReelCancel={onCloseParentReelCancel}
//                 onClose={closeParentReelJobCard}
//                 isProduced={isProduced}
//                 tabNo={activeTab}
//                 jobcardType={jobcardType}
//                 pageType={"deckle"}
//               />
//             )}

//             {toaster && actionResponse.msg && (
//               <AlertContainer
//                 color={`${actionResponse.error ? "red" : "green"} toaster`}
//                 icon={actionResponse.error ? alertRed : alertGreen}
//                 msg={capitalize(actionResponse.msg)}
//               />
//             )}

//             <ViewDeckleOrder
//               selectedOrderNo={selectedOrderNo}
//               // showButton={true}
//               visible={viewOrder}
//               onClose={closeViewDrawer}
//               onCloseGrade={closeViewDrawer}
//               category={selectedOrder?.category}
//             />
//           </ResultWrap>
//         </>
//       )}
//     </RightLayoutContainer>
//   ) : (
//     <RightLayoutContainer>
//       {/* {console.log("Jobcard", jobCard)} */}
//       <PageTitleComp className="marginRightAdg" style={{ borderBottom: "0px" }}>
//         <PageHeader
//           ghost={false}
//           onBack={() => navigate("../job-cards")}
//           // onBack={() => navigate(-2)}
//           title="Job Card Details"
//         ></PageHeader>
//       </PageTitleComp>
//       <ResultWrap>
//         <DetailFields
//           className="jobCardView"
//           style={{ justifyContent: "flex-start" }}
//         >
//           <PageTitleComp style={{ borderBottom: "0" }}>
//             <PageHeader
//               ghost={false}
//               // title={`Job Card ${jobCard.id}`}
//               className="jobCardList-Grid"
//             ></PageHeader>

//             <div
//               className={`jobCardList ${"fullWidth"}`}
//               style={{
//                 alignSelf: "center",
//                 display: "flex",
//                 marginTop:
//                   isParentReelCancelled && activeTab >= 2 ? "20px" : "34px",
//                 // alignContent:'top'
//               }}
//             >
//               {/* <JobCardColorStatus>
//                 <div className="statusVal" dataval={jobCard.state}>
//                   {jobcardState(jobCard.state)}
//                 </div>
//               </JobCardColorStatus> */}
//             </div>
//             {isParentReelCancelled && activeTab >= 2 && (
//               <Col span={9} style={{ display: "absolute" }}>
//                 <div
//                   className="cancelledSetMessage"
//                   style={{
//                     display: "flex",
//                     justifyContent: "center", // Center content horizontally
//                     alignItems: "center", // Center content vertically
//                     marginTop: "25px",
//                     borderRadius: "4px",
//                     backgroundColor: "#f4f0ec",
//                     padding: "4px 6px",
//                     opacity: 0.95,
//                   }}
//                 >
//                   {/* <div className="centerAlignMeVertically" style={{ padding: "2px 6px 0px 3px" }}>
//     <Iconmoon icon="warning_new" size={20} style={{ color: "#808080" }} />
//   </div>
//   <span style={{ fontSize: "14px", color: "#555555" }}>
//     A few sets were cancelled in this job card. Hence, fulfilled
//     quantity might not be accurate for the cancelled sets.
//   </span> */}
//                 </div>
//               </Col>
//             )}
//           </PageTitleComp>

//           <div className="MatchResult JobResulted">
//             <Row span={24}>
//               <Col
//                 span={15}
//                 className="pipeBlock"
//                 style={{
//                   paddingRight: "20px",
//                   transform:
//                     isParentReelCancelled && activeTab >= 2
//                       ? "translateY(-14px)"
//                       : "",
//                 }}
//               >
//                 <div
//                   style={{
//                     paddingTop: "50px",
//                     paddingBottom: "50px",
//                   }}
//                 >
//                   <CardShimmerStyle>
//                     <div
//                       style={{
//                         display: "block",
//                         marginLeft: "auto",
//                         marginRight: "auto",
//                         opacity: "70%",
//                         width: "341.62px",
//                         marginTop: "60px",
//                       }}
//                     >
//                       <Skeleton.Image
//                         active={true}
//                         style={{
//                           width: "105px",
//                           marginLeft: "auto",
//                           marginRight: "auto",
//                         }}
//                       />
//                     </div>
//                   </CardShimmerStyle>
//                   {/* <div 
//             style={{
//                 fontFamily: "var(--sf-pro-display-m)",
//                 fontWeight: "500",
//                 fontSize: "14px",
//                 height: "16px",
//                 color: "#A19F9D",
//                 paddingTop: "20px",
//                 display: "block",
//                 marginLeft: "auto",
//                 marginRight: "auto",
//                 width: "150px",
//                 textAlign: "center",
//            }}
//            >{heading}
//             </div> */}
//                   <div
//                     style={{
//                       paddingTop: "30px",
//                       fontFamily: "var(--sf-pro-display-m)",
//                       fontWeight: "400",
//                       fontSize: "12px",
//                       height: "20px",
//                       color: "#A19F9D",
//                       display: "block",
//                       marginLeft: "auto",
//                       marginRight: "auto",
//                       width: "311px",
//                       textAlign: "center",
//                     }}
//                   >
//                     {"Fetching jobcard details"}
//                   </div>
//                 </div>
//               </Col>
//               <Col span={9} className="colLayoutBlock leftPostTab">
//                 <Tabs
//                   defaultActiveKey="1"
//                   activeKey={activeTab}
//                   onChange={tabChange}
//                   className="topPostTab innerPostTab"
//                 >
//                   <Panes tab="Summary" key="1">
//                     <div className="lossValue">
//                       <Row span={24} style={{ paddingTop: "10px" }}>
//                         <Col span={12}>
//                           <div
//                             className={"summaryValue"}
//                             style={{ padding: "0px" }}
//                           >
//                             <CardShimmerStyle>
//                               <div style={{ width: "100%", display: "flex" }}>
//                                 <div
//                                   style={{
//                                     flexDirection: "row",
//                                     display: "flex",
//                                     width: "100%",
//                                   }}
//                                 >
//                                   <Skeleton.Button
//                                     active={true}
//                                     style={{ height: "100px" }}
//                                   ></Skeleton.Button>
//                                 </div>
//                               </div>
//                             </CardShimmerStyle>
//                           </div>
//                         </Col>
//                         <Col span={12}>
//                           <div
//                             className={"summaryValue"}
//                             style={{ padding: "0px" }}
//                           >
//                             <CardShimmerStyle>
//                               <div style={{ width: "100%", display: "flex" }}>
//                                 <div
//                                   style={{
//                                     flexDirection: "row",
//                                     display: "flex",
//                                     width: "100%",
//                                   }}
//                                 >
//                                   <Skeleton.Button
//                                     active={true}
//                                     style={{ height: "100px" }}
//                                   ></Skeleton.Button>
//                                 </div>
//                               </div>
//                             </CardShimmerStyle>
//                           </div>
//                         </Col>
//                       </Row>

//                       <Row span={24} style={{ paddingTop: "10px" }}>
//                         <Col span={12}>
//                           <div
//                             className={"summaryValue"}
//                             style={{ padding: "0px" }}
//                           >
//                             <CardShimmerStyle>
//                               <div style={{ width: "100%", display: "flex" }}>
//                                 <div
//                                   style={{
//                                     flexDirection: "row",
//                                     display: "flex",
//                                     width: "100%",
//                                   }}
//                                 >
//                                   <Skeleton.Button
//                                     active={true}
//                                     style={{ height: "100px" }}
//                                   ></Skeleton.Button>
//                                 </div>
//                               </div>
//                             </CardShimmerStyle>
//                           </div>
//                         </Col>
//                         <Col span={12}>
//                           <div
//                             className={"summaryValue"}
//                             style={{ padding: "0px" }}
//                           >
//                             <CardShimmerStyle>
//                               <div style={{ width: "100%", display: "flex" }}>
//                                 <div
//                                   style={{
//                                     flexDirection: "row",
//                                     display: "flex",
//                                     width: "100%",
//                                   }}
//                                 >
//                                   <Skeleton.Button
//                                     active={true}
//                                     style={{ height: "100px" }}
//                                   ></Skeleton.Button>
//                                 </div>
//                               </div>
//                             </CardShimmerStyle>
//                           </div>
//                         </Col>
//                       </Row>

//                       <Row span={24} style={{ paddingTop: "10px" }}>
//                         <Col span={12}>
//                           <div
//                             className={"summaryValue"}
//                             style={{ padding: "0px" }}
//                           >
//                             <CardShimmerStyle>
//                               <div style={{ width: "100%", display: "flex" }}>
//                                 <div
//                                   style={{
//                                     flexDirection: "row",
//                                     display: "flex",
//                                     width: "100%",
//                                   }}
//                                 >
//                                   <Skeleton.Button
//                                     active={true}
//                                     style={{ height: "60px" }}
//                                   ></Skeleton.Button>
//                                 </div>
//                               </div>
//                             </CardShimmerStyle>
//                           </div>
//                         </Col>
//                         <Col span={12}>
//                           <div
//                             className={"summaryValue"}
//                             style={{ padding: "0px" }}
//                           >
//                             <CardShimmerStyle>
//                               <div style={{ width: "100%", display: "flex" }}>
//                                 <div
//                                   style={{
//                                     flexDirection: "row",
//                                     display: "flex",
//                                     width: "100%",
//                                   }}
//                                 >
//                                   <Skeleton.Button
//                                     active={true}
//                                     style={{ height: "60px" }}
//                                   ></Skeleton.Button>
//                                 </div>
//                               </div>
//                             </CardShimmerStyle>
//                           </div>
//                         </Col>
//                       </Row>
//                       <Row span={24} style={{ paddingTop: "10px" }}>
//                         <Col span={12}>
//                           <div
//                             className={"summaryValue"}
//                             style={{ padding: "0px", backgroundColor: "white" }}
//                           >
//                             <CardShimmerStyle>
//                               <div style={{ width: "70%", display: "flex" }}>
//                                 <div
//                                   style={{
//                                     flexDirection: "row",
//                                     display: "flex",
//                                     width: "100%",
//                                   }}
//                                 >
//                                   <Skeleton.Button
//                                     active={true}
//                                     style={{ height: "20px" }}
//                                   ></Skeleton.Button>
//                                 </div>
//                               </div>
//                             </CardShimmerStyle>
//                           </div>
//                         </Col>
//                         <Col span={12}>
//                           <div
//                             className={"summaryValue"}
//                             style={{ padding: "0px", backgroundColor: "white" }}
//                           >
//                             <CardShimmerStyle>
//                               <div style={{ width: "70%", display: "flex" }}>
//                                 <div
//                                   style={{
//                                     flexDirection: "row",
//                                     display: "flex",
//                                     width: "100%",
//                                   }}
//                                 >
//                                   <Skeleton.Button
//                                     active={true}
//                                     style={{ height: "20px" }}
//                                   ></Skeleton.Button>
//                                 </div>
//                               </div>
//                             </CardShimmerStyle>
//                           </div>
//                         </Col>
//                       </Row>
//                     </div>
//                   </Panes>
//                   <Panes tab="Size Fulfilment" key="2">
//                     {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
//                       color="blue"
//                       icon={warningjob}
//                       msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
//                       removeBottomMargin={true}
//                       jobCard = {true}
//                     /> : ''} */}
//                     <TableLayoutData>
//                       <div
//                         className="tableDataFormat  "
//                         style={{ marginTop: "25px" }}
//                       >
//                         <TableShimmer
//                           header={sizeFulfillmentColumnsHead}
//                           scroll={1300}
//                         />
//                       </div>
//                     </TableLayoutData>
//                   </Panes>
//                   <Panes tab="Order Fulfilment" key="3">
//                     <TableLayoutData>
//                       <div
//                         className="tableDataFormat  "
//                         style={{ marginTop: "25px" }}
//                       >
//                         <TableShimmer header={orderFulfillmentColumnsHead} scroll={1600} />
//                       </div>
//                     </TableLayoutData>
//                   </Panes>

//                   <Panes
//                     tab="Intermediate Reels"
//                     key="5"
//                     // disabled={solutionSummary?.solution1.exception}
//                   >
//                     {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
//                       color="blue"
//                       icon={warningjob}
//                       msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
//                       removeBottomMargin={true}
//                       jobCard = {true}
//                     /> : ''} */}
//                     <TableLayoutData>
//                       <div
//                         className="tableDataFormat"
//                         style={{ marginTop: "25px" }}
//                       >
//                         <TableShimmer
//                           header={intermediateColumnsHead}
//                           scroll={1300}
//                         />
//                       </div>
//                     </TableLayoutData>
//                   </Panes>
//                   <Panes tab="Map Rewinding" key="6">
//                     <TableLayoutData>
//                       <div
//                         className="tableDataFormat"
//                         style={{ marginTop: "25px" }}
//                       >
//                         <TableShimmer
//                           header={mapRewindingColumnsHead}
//                           scroll={1300}
//                         />
//                       </div>
//                     </TableLayoutData>
//                   </Panes>
//                   <Panes tab="Map Cutting" key="7">
//                     <TableLayoutData>
//                       <div
//                         className="tableDataFormat"
//                         style={{ marginTop: "25px" }}
//                       >
//                         <TableShimmer
//                           header={mapCuttingColumnsHead}
//                           scroll={1300}
//                         />
//                       </div>
//                     </TableLayoutData>
//                   </Panes>
//                 </Tabs>
//               </Col>
//             </Row>
//           </div>
//         </DetailFields>
//         {/* approve Modal */}
//         <ConfirmationModal
//           visible={isVisibleApproveModal}
//           icon={warning}
//           cancelAction={approveModalClose}
//           confirmAction={approveModalConfirm}
//           param={jobId}
//         >
//           <span>Are you sure?</span>
//           <p>
//             You are about to approve this job card, once approved this job card
//             can’t be altered later
//           </p>
//         </ConfirmationModal>

//         {/* <ConfirmationModal
//           visible={visibleStartProduction}
//           icon={warning}
//           cancelAction={closeStartProductionModal}
//           confirmAction={startProductionModalConfirm}
//           param={jobId}
//         >
//           <span>Start production ?</span>
//           <p>
//             The job card will move to the production. Are you sure you want to
//             proceed?
//           </p>
//         </ConfirmationModal> */}

//         {/* <ConfirmationModal
//           visible={visibleCancelProduction}
//           icon={warning}
//           cancelAction={closeCancelProductionModal}
//           confirmAction={cancelProductionModalConfirm}
//           param={jobId}
//         >
//           <span>Are you sure?</span>
//           <p>
//             You are about to cancel the production for this jobcard, are you
//             sure you want to continue?
//           </p>
//         </ConfirmationModal> */}

//         {/* <ConfirmationModal
//           visible={visibleMarkCompletedModal}
//           icon={warning}
//           cancelAction={closeMarkCompletedModal}
//           confirmAction={markCompletedModalConfirm}
//           param={jobId}
//         >
//           <span>Are you sure?</span>
//           <p>
//             You are about to mark this job as completed, are you sure you want
//             to continue?
//           </p>
//         </ConfirmationModal> */}

//         <JobCardRejectDrawer
//           visible={visibleRejectDrawer}
//           onClose={closeRejectDrawer}
//           onCloseGrade={closeRejectDrawer}
//           jobId={jobId}
//           setReFetch={setReFetch}
//           setActionResponse={setActionResponse}
//           showToaster={showToaster}
//           jobcardCode={jobcardCode}
//         />

//         {toaster && actionResponse.msg && (
//           <AlertContainer
//             color={`${actionResponse.error ? "red" : "green"} toaster`}
//             icon={actionResponse.error ? alertRed : alertGreen}
//             msg={capitalize(actionResponse.msg)}
//           />
//         )}

//         <ViewDeckleOrder
//           selectedOrderNo={selectedOrderNo}
//           // showButton={true}
//           visible={viewOrder}
//           onClose={closeViewDrawer}
//           onCloseGrade={closeViewDrawer}
//           category={selectedOrder?.category}
//         />
//       </ResultWrap>
//     </RightLayoutContainer>
//   );
// };
// export default JobcardDetailsMultistage;

/* eslint-disable react-hooks/rules-of-hooks */
import { React, useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import upgrade from "../../../Assets/Icons/up-range.svg";
import downgrade from "../../../Assets/Icons/down-range.svg";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  ResultWrap,
  TableLayoutData,
  PipeDesign,
  SolutionContainer,
  ContentMiddle,
} from "../../styledElements";
import {
  Button,
  PageHeader,
  Tabs,
  Row,
  Col,
  Table,
  Tooltip,
  Radio,
  Skeleton,
  Collapse,
} from "antd";
import { Styled, RadioButtonStyle } from "../../pageStyled";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  approveRejectJobCard,
  cancelJobCard,
  createNewSolutionMultistage,
  getAlgorithmCompletionStatusMultiStage,
  getFailedGroups,
  getIntermediateList,
  getJobCardCylinders,
  getJobCardsById,
  getJobCardsByIdMultistage,
  getJobCardsDetailsMultistage,
  readyJobCardMultistageNewSolution,
} from "../../../Services/deckleMatchServices";
import {
  editQtyToBePlannedForReviewOrder,
  getOrdersList,
  getPosData,
} from "../../../Services/orderServices";
import moment from "moment";
import { TableList, JobCardColorStatus } from "../../pageStyled";
import { HaberForm } from "../../styledElements";
import JobCardCylinderContainer from "../../../Components/JobCardCylinders/JobCardCylinderContainer";
import warning from "../../../Assets/Icons/warning.png";
import warningjob from "../../../Assets/Icons/warningjob.svg";
import { ModalPopup } from "../../../Components/Modal/modal";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import JobCardRejectDrawer from "./JobCardRejectDrawer/JobCardRejectDrawer";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { getStocksDetailsByIds } from "../../../Services/productServices";
import ViewDeckleOrder from "../DeckleOrderDrawer/viewDeckleOrder";
import {
  CoversionFactorCMToUnits,
  CoversionFactorUnitsToCM,
  lengthUnit,
  weightUnit,
} from "../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../Services/measurementService";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import styled from "styled-components";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import JobCardCylinderContainerMultistage from "../../../Components/JobCardCylinders/JobCardCylinderContainerMultistage";
import SheetJobCardCylinderContainerMultistage from "../../../Components/JobCardCylinders/SheetJobCardCylinderContainerMultistage";
import {
  getJumboReelDetailsByIdForMultiStage,
  getProductionJobCardsById,
  changeMultiStageProductionJobCardState,
  markCompleteRewinding,
  markCompleteCutting,
  getProductionJobCardsByIdMultistage,
  changeProductionJobCardState,
  replanJobcard,
} from "../../../Services/productionPlanningServices";
import PrintIcon from "../../../Assets/Icons/printer2.svg";
import ParentReelJobCardDrawer from "../../ProductionPlanning/ProductionJobCards/JobcardDrawers/parentReelJobCardDrawer";
import { toHandlePOName } from "../../../Utils/helper/helper";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";
import CreateNewSolutionMultistage from "../DeckleResults/createNewSolutionMultistage";
import LottieAnimation from "../../../Lottie";
import JobcardPrepare from "../../../Components/IconsFiles/preparing_job_card";
const Panes = Tabs.TabPane;
const machineType = ["rewinding", "cutting"];
const gridViewData = [
  {
    label: <Iconmoon icon="grid-chart" size={20} color="#EA655B" />,
    value: "grid",
  },
  { label: <Iconmoon icon="table" size={20} color="#EA655B" />, value: "list" },
];

const CardShimmerStyle = styled.div`
  .ant-card-body {
    position: relative;
    z-index: 0;
    overflow: hidden;
    height: 100%;
    padding: 0px;
  }
  .ant-skeleton-element .ant-skeleton-button {
    min-width: 0px;
    width: 100%;
    border-radius: 3px;
  }
  .ant-skeleton-element .ant-skeleton-input {
    min-width: 0px;
    width: 100%;
    border-radius: 3px;
  }
  .ant-skeleton-element {
    width: 100%;
  }
  .ant-skeleton-element .ant-skeleton-image {
    min-width: 0px;
    width: 100%;
  }
`;

const JobcardDetailsMultistage = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  let [searchParams, setSearchParams] = useSearchParams();
  const [ordersFullFilledList, setOrdersFullFilledList] = useState([]);
  const [ordersUnFullFilledList, setOrdersUnFullFilledList] = useState([]);
  // const [posList, setPosList] = useState([]);
  // console.log(location.state)
  const [jobId, setJobId] = useState(
    location.state ? location.state.id : searchParams.get("id")
  );
  const [jobCard, setJobCard] = useState();
  const [processType, setProcessType] = useState(
    location.state ? location.state.processType : ""
  );
  const [jobcardType, setJobCardType] = useState(
    location.state ? location.state.jobcardType : ""
  );
  const [jobcardCode, setJobcardcode] = useState();
  const [acceptedSolution, setAcceptedSolution] = useState({
    name: null,
    key: null,
    solution: null,
  });
  // const [cylinderData, setCylinderData] = useState();
  //List view state
  // const [gridView, setGridView] = useState(true);
  // const [cylinderColumnHead, setCylinderColumnHead] = useState([]);
  // const [loadingColumnHead, setLoadingColumnHead] = useState(true);
  const [solutionId, setSolutionId] = useState("1");
  //List view state ends here
  const [isVisibleApproveModal, setIsVisibleApproveModal] = useState(false);
  const [visibleRejectDrawer, setVisibleRejectDrawer] = useState(false);
  const [visibleMarkCompletedModal, setVisibleMarkCompletedModal] =
    useState(false);
  const [visibleCancelProduction, setVisibleCancelProduction] = useState(false);
  const [visibleStartProduction, setVisibleStartProduction] = useState(false);
  const [actionResponse, setActionResponse] = useState({});
  const [reFetch, setReFetch] = useState(true);
  const [toaster, setToaster] = useState(false);
  const [viewOrder, setViewOrder] = useState(false);
  const [orderDetailsList, setOrderDetailsList] = useState();
  const [selectedOrderNo, setSelectedOrderNo] = useState();
  const [selectedOrder, setSelectedOrder] = useState();

  const [intermediateData, setIntermediateData] = useState([]);
  const [isMapJumboLoading, setIsMapJumboLoading] = useState(false);
  const [isMapCuttingLoading, setIsMapCuttingLoading] = useState(false);
  const [jumboReelData, setJumboReelData] = useState();
  const [cuttingJumboReelData, setCuttingJumboReelData] = useState();
  const [isParentReelCancelled, setIsParentReelCancelled] = useState(false);
  const [totalFulfilledOrders, setTotalFulfilledOrders] = useState(0);
  const [totalUnfulfilledOrders, setTotalUnfulfilledOrders] = useState(0);
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [isFetchingDataForCylinder, setIsFetchingDataForCylinder] =
    useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isSheetView, setIsSheetView] = useState(true);
  const [isJobcardView, setIsJobcardView] = useState(true);
  const [isTabularView, setIsTabularView] = useState(false);
  const [cylinderViewData, setCylinderViewData] = useState('order');
  const [pageSize, setPageSize] = useState(10);
  const [isApproveLoading, setIsApproveLoading] = useState(false);
  const [isRejectLoading, setIsRejectLoading] = useState(false);
  const [jobCardDetailsListForPrint, setJobCardDetailsListForPrint] =
    useState();
  const [isPrintDisabled, setIsPrintDisabled] = useState(false);
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [settingsData, setSettingsData] = useState(
    JSON.parse(localStorage.getItem("setting-data"))
  );
  const [activeTab, setActiveTab] = useState("1");
  const [sizeFulfillmentDetailsList, setSizeFulfillmentDetailsList] =
    useState();
  const [unitData, setUnitData] = useState();
  const [selectedParentReel, setSelectedParentReel] = useState(
    location?.state?.parentReelId ? location?.state?.parentReelId : ""
  );
  const [isProduced, setIsProduced] = useState(false);
  const [viewParentReelJobCardDrawer, setViewParentReelJobCardDrawer] =
    useState(false);
  const [sizeExpanded, setSizeExpanded] = useState(false);
  const columnBlacklist =
    settingsData?.settings?.orders_page?.tables?.jobcard_orders || [];
  const format = settingsData?.settings?.product_spec?.format || "";
  // const [sizeExpanded, setSizeExpanded] = useState(false);
  // const [sizeExpanded, setSizeExpanded] = useState(false);
  // const [sizeExpanded, setSizeExpanded] = useState(false);
  const [orderManagementSettings, setOrderManagementSettings] = useState(JSON.parse(localStorage.getItem("order-management-settings")));
  const [deckleManagementSettings, setDeckleManagementSettings] = useState();
  const [jobCardDetailsList, setJobCardDetailsList] = useState([]);
  const [createNewSolutionClicked, setCreateNewSolutionClicked] =
    useState(false);
  const [formValuesForStock, setFormValuesForStock] = useState({});
  const [jobIndex, setJobIndex] = useState(0);
  const [
    createNewSolutionFormValuesForSizes,
    setCreateNewSolutionFormValuesForSizes,
  ] = useState();
  const [optimizePartition, setOptimizePartition] = useState(false);
  const [minimizeOverfulfillment, setMinimizeOverfulfillment] = useState(false);
  const [isReplanClicked, setIsReplanClicked] = useState(false);
  const [stockSizes, setStockSizes] = useState([]);
  const [ordersIdList, setOrderIdList] = useState([]);
  // const [solutionId, setSolutionId] = useState("1");
  const [dynamicStock, setDynamicStock] = useState([]);
  const printJobCardDetails = () => {
    navigate("../job-card-details/viewer/", {
      state: {
        jobId: jobId,
        jobcardCode: getJCCode(jobCard.jobcard_code),
        solution: acceptedSolution.key,
        orderDetailsList: jobCardDetailsListForPrint,
        type: "multiStage",
      },
    });
  };

  const getJCCode = (str) => {
    if (str) {
      let splittedString = str?.split("~");
      let mergeString;
      mergeString = splittedString?.join("");
      return mergeString;
    }
  };

  const handleViewChange = (e) => {
    // setGridView(e.target.value);
    if (e.target.value === "both") {
      setIsJobcardView(true);
      setIsSheetView(true);
    } else if (e.target.value === "reel") {
      setIsJobcardView(true);
      setIsSheetView(false);
    } else {
      setIsJobcardView(false);
      setIsSheetView(true);
    }
    // console.log("view check", e.target.value);
  };

  useEffect(() => { }, [isTabularView]);
  const handleViewChangeGrid = (e) => {
    setIsTabularView(e.target.value === "list");
  };
  const handleCylinderViewChange = (e) => {
    if (e.target.value === "production") {
      setCylinderViewData('production');
    } else {
      setCylinderViewData('order');
    }
  }
  const filterViewData = [
    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View rewinding and sheeting plan"}
          className="edit-tooltip"
        >
          <span
            style={{
              transform: "translateY(-5px)",
              color: isJobcardView && isSheetView && "#ea655b",
              fontFamily: "var(--sf-pro-display) !important",
            }}
          >
            All
          </span>
          {/* <Iconmoon icon="sheet" size={20} color="#EA655B" /> */}
        </Tooltip>
      ),
      value: "both",
    },

    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View rewinding plan"}
          className="edit-tooltip"
        >
          <Iconmoon icon="tissue-role" size={18} color="#EA655B" />
        </Tooltip>
      ),
      value: "reel",
    },
    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View sheeting plan"}
          className="sheet"
        >
          <Iconmoon icon="sheet" size={20} color="#EA655B !important" />
        </Tooltip>
      ),
      value: "sheet",
    },
  ];
  const gridViewData = [
    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View in grid mode"}
          className="edit-tooltip"
        >
          <Iconmoon icon="grid-chart" size={20} color="#EA655B" />
        </Tooltip>
      ),
      value: "grid",
    },
    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View in tabular mode"}
          className="edit-tooltip"
        >
          <Iconmoon icon="table" size={20} color="#EA655B" />
        </Tooltip>
      ),
      value: "list",
    },
  ];
  const cylinderMode = [
    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View in order mode"}
          className="edit-tooltip"
        >
          <Iconmoon icon="order-entry-icon" size={20} color="#EA655B" />

        </Tooltip>
      ),
      value: "order",
    },
    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View in production mode"}
          className="edit-tooltip"
        >
          <Iconmoon icon="production-icon" size={20} color="#EA655B" />
        </Tooltip>
      ),
      value: "production",
    },

  ];

  const tabChange = (key) => setActiveTab(key);
  const approveJobCard = (jobId) => {
    setIsApproveLoading(true);
    approveRejectJobCard({ id: jobId, state: "approved" })
      .then((response) => {
        setActionResponse({ error: response.error, msg: response.msg });
        setReFetch(true);
      })
      .catch((error) => {
        setActionResponse({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        console.log(error);
      })
      .finally(() => {
        setIsApproveLoading(false);
      });
  };
  const onPaginationChange = (page, pageSize, isUnfulfilled) => {
    // console.log(page, pageSize);
    setCurrentPage(page);
    setPageSize(pageSize);
    // isUnfulfilled && setIsUnfulfilledTab(true);
  };

  function onChange(pagination, filters, sorter, extra) {
    // console.log("params", pagination, filters, sorter, extra);
    if (pagination) onPaginationChange(pagination.current, pagination.pageSize);
  }

  useEffect(() => {
    setPageSize(10);
    setCurrentPage(1);
  }, [activeTab]);
  const showToaster = () => {
    setToaster(true);
    setTimeout(() => setToaster(false), 3000);
  };

  const approveModalShow = () => {
    setIsVisibleApproveModal(true);
  };

  const approveModalClose = () => {
    setIsVisibleApproveModal(false);
  };

  const approveModalConfirm = (value) => {
    approveJobCard(value);
    setIsVisibleApproveModal(false);
    setReFetch(true);
    showToaster();
  };

  // const showStartProductionModal = () => {
  //   setVisibleStartProduction(true);
  // };

  // const closeStartProductionModal = () => {
  //   setVisibleStartProduction(false);
  // };

  // const startProductionModalConfirm = (value) => {
  //   startProduction(value);
  //   setVisibleStartProduction(false);
  //   setReFetch(true);
  //   showToaster();
  // };

  // const showCancelProductionModal = () => {
  //   setVisibleCancelProduction(true);
  // };

  // const closeCancelProductionModal = () => {
  //   setVisibleCancelProduction(false);
  // };

  // const cancelProductionModalConfirm = (value) => {
  //   cancelProduction(value);
  //   setVisibleCancelProduction(false);
  //   setReFetch(true);
  //   showToaster();
  // };

  // const showMarkCompletedModal = () => {
  //   setVisibleMarkCompletedModal(true);
  // };

  // const closeMarkCompletedModal = () => {
  //   setVisibleMarkCompletedModal(false);
  // };

  // const markCompletedModalConfirm = (value) => {
  //   markAsCompleted(value);
  //   setVisibleMarkCompletedModal(false);
  //   setReFetch(true);
  //   showToaster();
  // };

  const showRejectDrawer = () => {
    setVisibleRejectDrawer(true);
  };

  const routeChange = (record) => {
    console.log(jobId, record.parentReel);
    navigate("../job-card-details-multistage/print-parent-reel/pdf", {
      state: {
        jobId: jobId,
        parentReel: record.parentReel,
        machine_type: record.machine_type ? record.machine_type : "rewinder",
      },
    });
  };

  const closeRejectDrawer = () => {
    setVisibleRejectDrawer(false);
  };

  const showViewDrawer = (value, record) => {
    setSelectedOrderNo(value);
    setSelectedOrder(record);
    setViewOrder(true);
  };

  const closeViewDrawer = () => {
    setViewOrder(false);
  };

  const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item.slice(1);

  //A switch case function to return states of a job card.
  const jobcardState = (state) => {
    switch (state) {
      // case "pending":
      //   return "Pending for approval";
      // case "approved":
      //   return "Approved";
      // case "rejected":
      //   return "Rejected";
      // case "in_production":
      //   return "In Production";
      // case "complete":
      //   return "Complete";
      case "pending":
        return "Pending for approval";
      case "approved":
        return "Approved";
      case "rejected":
        return "Rejected";
      case "in_production":
        return "In Production";
      case "cancel":
        return "Production Cancelled";
      case "complete":
        return "Complete";
      case "hold":
        return "On Hold";
      case "produced":
        return "Produced";
      case "active":
        return "Active";
      case "under_review":
        return "Under Review";
      case "cancelled":
        return "Cancelled";
      default:
        return;
    }
  };
  //api-call to get the details of a specific jobcard
  const getJobCardDetailsById = async () => {
    try {
      const response = await getJobCardsByIdMultistage(jobId);
      if (response?.jobcard_code) {
        let splittedString = response?.jobcard_code?.split("~");
        setJobcardcode(splittedString?.join(""));
      }
      setJobCard(response);
      setJobCardType(response.type);
      setProcessType(response.process_type);
      const selectedState =
        response.state === "complete" ||
        response.state === "in_production" ||
        response.state === "hold" ||
        response.state === "cancel";

      Object.keys(response?.jobcard ?? {})?.forEach((key) => {
        if (key.startsWith("solution_")) {
          let solno = key.split("_")[1];
          if (response?.jobcard[key]?.status == "accept") {
            setAcceptedSolution({
              name: `Solution ${solno}`,
              key: solno,
              solution: response?.jobcard[key],
            });
            setIsParentReelCancelled(
              response.jobcard[key].data.parent_reel_cancelled &&
              selectedState
            );
            setSizeFulfillmentDetails(response.jobcard[key].data);
          }
        }
      })
      // if (response?.jobcard.solution_1.status === "accept") {
      //   // console.log("acc1", acceptedSolution);
      //   setAcceptedSolution({
      //     name: "Solution 1",
      //     key: 1,
      //     solution: response.jobcard.solution_1,
      //   });
      //   // console.log(response.jobcard.solution_1.data)
      //   // console.log(response.state)
      //   setIsParentReelCancelled(
      //     response.jobcard.solution_1.data.parent_reel_cancelled &&
      //       selectedState
      //   );
      //   setSizeFulfillmentDetails(response.jobcard.solution_1.data);
      // } else if (response?.jobcard.solution_2.status === "accept") {
      //   // console.log("acc2", acceptedSolution);
      //   setAcceptedSolution({
      //     name: "Solution 2",
      //     key: 2,
      //     solution: response.jobcard.solution_2,
      //   });
      //   setIsParentReelCancelled(
      //     response.jobcard.solution_2.data.parent_reel_cancelled &&
      //       selectedState
      //   );
      //   setSizeFulfillmentDetails(response.jobcard.solution_2.data);
      // }
    } catch (error) {
      console.log("Error in accepting solution", error.response);
    }
  };

  const setSizeFulfillmentDetails = (data) => {
    const sizes = data.sizes;
    let diameterFulfilmentArray = [];
    data.orders?.map((order) => {
      diameterFulfilmentArray.push(order.diameter_fulfillment);
    });
    let sizeFulfillmentList = sizes.map((size, index) => {
      return {
        key: index + 1,
        type: "Order",
        size: `${size.size} ${size.lateral_size ? "X " + size.lateral_size : ""
          } ${" "} ${size.units && size.units.size
            ? lengthUnit[size.units.size]?.displayName
            : "CM"
          }`,
        grain: size?.grain && size?.grain !== "None" && size?.grain !== 'null' && size?.grain !== null ? size?.grain : "-",
        plannedReels: size.fulfilled + size.unfulfilled,
        plannedWeight:
          (size.fulfilled_weight + size.unfulfilled_weight).toFixed(3) +
          " " +
          (size?.units && size?.units?.fulfilled_weight
            ? capitalize(weightUnit[size.units.fulfilled_weight]?.displayName)
            : "T"),
        fulflilledReels: size.fulfilled,
        fulflilledWeight:
          size.fulfilled_weight.toFixed(3) +
          " " +
          (size?.units && size?.units?.fulfilled_weight
            ? capitalize(weightUnit[size.units.fulfilled_weight]?.displayName)
            : "T"),
        unFulflilledReels: size.unfulfilled,
        unFulflilledWeight:
          size.unfulfilled_weight.toFixed(3) +
          " " +
          (size?.units && size?.units?.unfulfilled_weight
            ? capitalize(weightUnit[size.units.unfulfilled_weight]?.displayName)
            : "T"),
        reelSpecification: size?.diameter_fulfillment.map((diaItem) => {
          const reelOd = diaItem.reel_od;
          const coreId = diaItem.core_id;
          const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
          const fulfilledValue = diaItem.fulfilled;
          const fulfilledWeightUnit = size?.units?.fulfilled_weight
            ? capitalize(
              size.units?.fulfilled_weight
                ? capitalize(
                  weightUnit[size.units.unfulfilled_weight]?.displayName
                )
                : "t"
            )
            : "";
          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue} ${size?.grain && size?.grain !== "None" ? "S" : "R"
            })\n`;
        }),
      };
    });

    setSizeFulfillmentDetailsList(sizeFulfillmentList);
  };
  const getIntermediateListItems = (
    ordersList,
    jobcard,
    solution,
    isNewSolution
  ) => {
    // console.log(jobIndex, jobCardDetailsList[jobIndex]);
    getIntermediateList(ordersList, jobcard, solution).then((response) => {
      // console.log(response);
      if (!response) return;
      // const intermediateDataTemp = response?.map((item, index) => {
      //   const reelSpecifications = item.reel_specification?.map((spec) => {
      //     const outerDiameters = Array.isArray(spec?.reel_od)
      //       ? spec.reel_od.join(", ")
      //       : spec.reel_od;
      //     return `${outerDiameters} / ${
      //       spec?.core_id
      //     } (${spec?.fulfilled_weight?.toFixed(3)} ${capitalize(weightUnit[
      //       spec?.units?.fulfilled_weight
      //     ]?.displayName)}, ${spec.fulfilled}R)`;
      //   });

      //   return {
      //     key: index,
      //     srno: index + 1,
      //     reel_size: `${item.reel_size} ${lengthUnit[
      //       item.units.reel_size
      //     ]?.displayName}`,
      //     order_size: item.length
      //       ? `${item.width} ${lengthUnit[
      //           item.units.width
      //         ]?.displayName} x ${item.length} ${lengthUnit[
      //           item.units.length
      //         ]?.displayName}`
      //       : `${item.width} ${lengthUnit[
      //           item.units.width
      //         ]?.displayName}`,
      //     grain: item.grain,
      //     quantity: `${item.quantity?.toFixed(3)} ${capitalize(weightUnit[
      //       item.units.quantity
      //     ]?.displayName)}`,
      //     reelSpecification: reelSpecifications?.join("\n"),
      //   };
      // });
      const tempIntermediateData =
        acceptedSolution?.solution?.data?.intermediate_reels?.map(
          (item, index) => {
            const reelSpecifications = item.diameter_fulfillment?.map(
              (spec) => {
                const outerDiameters = Array.isArray(spec?.reel_od)
                  ? spec.reel_od.join(", ")
                  : spec.reel_od +
                  " " +
                  (item.units?.reel_od
                    ? lengthUnit[item.units?.reel_od].displayName
                    : "cm");
                return `${outerDiameters} / ${spec?.core_id} ${item?.units?.core_id
                  ? lengthUnit[item?.units?.core_id]?.displayName
                  : "cm"
                  } (${spec?.fulfilled_weight?.toFixed(3)} ${item?.units?.fulfilled_weight
                    ? capitalize(
                      weightUnit[item?.units?.fulfilled_weight]?.displayName
                    )
                    : "T"
                  }, ${spec.fulfilled_reels}R)`;
              }
            );
            const cancelledQuantity = item?.cancelled_diameter_fulfillment
              ? item?.cancelled_diameter_fulfillment
                ?.filter((spec) => spec.fulfilled_weight > 0)
                ?.map((spec) => {
                  const outerDiameters = Array.isArray(spec?.reel_od)
                    ? spec.reel_od.join(", ")
                    : spec.reel_od +
                    " " +
                    (item.units?.reel_od
                      ? lengthUnit[item.units?.reel_od].displayName
                      : "cm");
                  return `${outerDiameters} / ${spec?.core_id} ${item?.units?.core_id
                    ? lengthUnit[item?.units?.core_id]?.displayName
                    : "cm"
                    } (${spec?.fulfilled_weight?.toFixed(3)} ${item?.units?.fulfilled_weight
                      ? capitalize(
                        weightUnit[item?.units?.fulfilled_weight]
                          ?.displayName
                      )
                      : "T"
                    }, ${spec.fulfilled_reels}R)`;
                })
              : ["-"];
            const cuttingPattern =
              "(" +
              item.cutting_pattern.partitions
                .map((item) => item.size)
                .join("+") +
              ") x " +
              item.cutting_pattern.ir_length +
              " " +
              (item.units?.ir_width ? item.units?.ir_width : "cm");
            return {
              key: index,
              srno: index + 1,
              reel_size: `${item.size} ${item.units?.size
                ? lengthUnit[item.units?.size]?.displayName
                : "cm"
                }`,
              cuttingPattern: cuttingPattern,
              quantity: `${item.fulfilled_weight?.toFixed(3)} ${item.units?.fulfilled_weight
                ? capitalize(
                  weightUnit[item.units?.fulfilled_weight]?.displayName
                )
                : "T"
                }`,
              reelSpecification: reelSpecifications?.join("\n"),
              cancelledQty: cancelledQuantity?.join("\n"),
            };
          }
        );
      setIntermediateData(tempIntermediateData);

      //setIntermediateData(intermediateDataTemp);
    });
  };
  const toggleFetchingData = (isFetching) => {
    console.log(isFetching);
    setIsFetchingDataForCylinder(isFetching);
  };
  useEffect(() => {
    console.log(isFetchingDataForCylinder);
  }, [isFetchingDataForCylinder]);
  useEffect(() => {
    if (!acceptedSolution) return;
    const ordersList = acceptedSolution?.solution?.data?.orders
      ?.filter((order) => {
        return order.item_type == "order";
      })
      .map((item) => item.order_id);
    ordersList &&
      getIntermediateListItems(
        ordersList,
        jobId,
        `solution_${acceptedSolution?.key}`
      );
  }, [acceptedSolution]);

  useEffect(() => {
    if (acceptedSolution.solution !== null) fetchOrdersForPrint();
  }, [acceptedSolution]);
  const fetchOrders = async () => {
    setIsFetchingData(true);
    let orderList = [];
    const ordersList = acceptedSolution.solution.data.orders
      ?.filter((order) => {
        return order.item_type == "order";
      })
      .map((item) => item.order_id);
    const fulfilledOrdersList = acceptedSolution.solution.data.orders
      ?.filter((order) => {
        return order.item_type == "order" && order.fulfilled_weight > 0;
      })
      ?.map((item) => item.order_id);

    const unfulfilledOrdersList = acceptedSolution.solution.data.orders
      ?.filter((order) => {
        return order.item_type == "order" && order.unfulfilled_weight > 0;
      })
      ?.map((item) => item.order_id);

    setTotalFulfilledOrders(fulfilledOrdersList.length);
    setTotalUnfulfilledOrders(unfulfilledOrdersList.length);
    // console.log(tota)
    // if()
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    ordersList &&
      (await getOrdersList([
        ...fulfilledOrdersList,
        ...unfulfilledOrdersList
        // ...fulfilledOrdersList.slice(startIndex, endIndex),
        // ...unfulfilledOrdersList.slice(startIndex, endIndex),
      ])
        .then((response) => {
          orderList = response.data.map((item, index) => {
            const orderData = acceptedSolution.solution.data.orders.filter(
              (order) => parseFloat(order.order_id) === item.number
            )[0];

            // console.log(orderData);
            let unitValue = orderData.units ? orderData.units : {};
            unitValue["fulfilled_weight"] = unitValue?.fulfilled_weight
              ? unitValue?.fulfilled_weight
              : unitData.units_management.weight.default;
            return {
              key: index + 1,
              pono: `${item.po}`,
              category: item?.category,
              sono: item?.so,
              orderno: `${item.number}`,
              overfulfillmentPercentage: `${(((orderData.fulfilled_weight / orderData.requirement) - 1) * 100).toFixed(2)}%`,
              type: "Order",
              grain: item?.grain,
              length: item?.length,
              width: item?.width,
              matchedGrain: orderData?.grain,
              isReel: orderData.type === "reel",
              productspec: item?.product_spec,
              customercode: item.customer,
              customername: item.customer_name,
              customer_alias: item.customer_alias,
              size: `${item.width}${item.length ? ` x ${item.length}` : ""
                } ${" "} ${item?.units && item?.units?.width
                  ? lengthUnit[item.units.width]?.displayName
                  : "CM"
                }`,
              productInfo: item.product_info,
              plannedReels: orderData.requirement,
              plannedreel: orderData.requirement,
              plannedWeight:
                orderData.requirement?.toFixed(3) +
                " " +
                (orderData?.units && orderData.units.requirement
                  ? capitalize(
                    weightUnit[orderData.units.requirement]?.displayName
                  )
                  : "T"),
              fulflilledReels: orderData.fulfilled,
              fulflilledWeight:
                orderData.fulfilled_weight.toFixed(3) +
                " " +
                (orderData?.units && orderData.units.fulfilled_weight
                  ? capitalize(
                    weightUnit[orderData.units.fulfilled_weight]?.displayName
                  )
                  : "T"),
              unFulflilledReels: orderData.unfulfilled,
              unFulflilledWeight:
                orderData.unfulfilled_weight.toFixed(3) +
                " " +
                (orderData?.units && orderData.units.unfulfilled_weight
                  ? capitalize(
                    weightUnit[orderData.units.unfulfilled_weight]
                      ?.displayName
                  )
                  : "T"),
              priority: jobCard.jobcard.group.orders.filter(
                (order) => order.order_id === item.number
              )[0].forced,
              deliverydate:
                item.category === "so"
                  ? "-"
                  : moment(item.delivery_date).format("DD MMM YYYY"),
              remarks: item.remarks,
              reel_od: item.reel_od,
              core_id: item.core_id,
              consignee_name: item.consignee_name,
              consignee_code: item.consignee_code,
              reelSpecification: orderData?.diameter_fulfillment?.map(
                (diaItem) => {
                  const reelOd = diaItem.reel_od;
                  const coreId = diaItem.core_id;
                  const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
                  const fulfilledValue = diaItem.fulfilled;
                  const fulfilledWeightUnit = capitalize(
                    orderData.units?.fulfilled_weight
                      ? capitalize(
                        weightUnit[orderData.units?.fulfilled_weight]
                          .displayName
                      )
                      : "T"
                  );
                  return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R) \n`;
                }
              ),
              diameter_fulfillment: orderData?.diameter_fulfillment?.map(
                (diaItem, index) => {
                  return {
                    reel_od: diaItem.reel_od,
                    core_id: diaItem.core_id,
                    fulfilled_weight:
                      diaItem.fulfilled_weight -
                      orderData?.cancelled_diameter_fulfillment[index]
                        ?.fulfilled_weight,
                    fulfilled:
                      diaItem.fulfilled -
                      orderData?.cancelled_diameter_fulfillment[index]
                        ?.fulfilled,
                    fulfilledWeightUnit: orderData.units?.fulfilled_weight
                      ? orderData.units?.fulfilled_weight
                      : unitData.units_management.weight.default,
                  };
                }
              ),
              cancelled_diameter_fulfillment:
                orderData?.cancelled_diameter_fulfillment,
              fulfilled_quantity:
                orderData.fulfilled_weight - orderData.cancelled_weight,
              units: unitValue,
              cancelledQty: orderData?.cancelled_diameter_fulfillment
                ?.filter((dia) => dia.fulfilled_weight > 0)
                ?.map((diaItem) => {
                  const reelOd = diaItem.reel_od;
                  const coreId = diaItem.core_id;
                  const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
                  const fulfilledValue = diaItem.fulfilled;
                  const fulfilledWeightUnit = capitalize(
                    orderData.units?.fulfilled_weight
                      ? capitalize(
                        weightUnit[orderData.units?.fulfilled_weight]
                          .displayName
                      )
                      : "T"
                  );
                  return fulfilledWeight && fulfilledValue
                    ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue} ${orderData.type !== "reel" ? "S" : "R"
                    })\n`
                    : "-";
                }),
              external_order_id: item.external_order_id,
              remarks: item.remarks
            };
          });

          const stockSizesList = acceptedSolution.solution.data.orders
            ?.filter((order) => {
              return order.item_type == "stock" || order.item_type === 'product_stock_size';
            })
            .map((item) => item.order_id);

          const dynamicStock = acceptedSolution.solution.data.orders
            ?.filter((order) => {
              return (
                (order.item_type == "stock" || order.item_type === 'product_stock_size') &&
                (order.creation_type === "dynamic" ||
                  order.creation_type === "required")
              );
            })
            .map((item) => {
              return {
                allowedQuantity: item?.requirement,
                isSelected: true,
                ...(item.creation_type === "dynamic" && { isNew: true }),
                ...(item.creation_type === "required" && {
                  isRequired: true,
                  weight_lb: item.requirement_lb,
                  weight_ub: item.requirement_ub,
                  priority_stock: item.priority_stock,
                }),
                length: item.lateral_size,
                width: item.size,
                isGrainChanged: item.rotated,
                type: item.type,
                grain: item.grain,
                availableUnit: item.units.requirement,
                stockSizeId: item.id,
                stockSize:
                  item.type === "reel"
                    ? +item.size + ' ' + lengthUnit[item.units.size].displayName.toUpperCase()
                    : +item.size + ' ' + lengthUnit[item.units.size].displayName.toUpperCase() + " * " + +item.lateral_size + ' ' + lengthUnit[item.units.lateral_size].displayName.toUpperCase(),

                isEdit: false,
                units: {
                  ...item.units,
                  quantity: item?.units?.fulfilled_weight,
                  width: item?.units?.size,
                  length: item?.units?.lateral_size,
                  weight_lb: item?.units?.requirement_lb,
                  weight_ub: item?.units?.requirement_ub,
                },
              };
            });
          setDynamicStock(dynamicStock);
          if (stockSizesList.length > 0) {
            getStocksDetailsByIds({ stocks: stockSizesList })
              .then((response) => {
                let sizesList = response.data.map((item, index) => {
                  const orderData =
                    acceptedSolution.solution.data.orders.filter(
                      (order) => order.order_id === item.id
                    )[0];
                  //console.log(orderData);
                  let unitValue = orderData.units ? orderData.units : {};
                  unitValue["fulfilled_weight"] = unitValue?.fulfilled_weight
                    ? unitValue?.fulfilled_weight
                    : unitData.units_management.weight.default;

                  return {
                    key: index + 1,
                    pono: "-",
                    overfulfillmentPercentage: `${(((orderData.fulfilled_weight / orderData.requirement) - 1) * 100).toFixed(2)}%`,
                    orderno: `${item.id}`,
                    type: "Stock",
                    grain: item?.grain,
                    length: item?.length,
                    width: item?.width,
                    customercode: "-",
                    customername: "-",
                    customer_alias: "-",
                    size: `${item.width}${item.length ? ` x ${item.length}` : ""
                      } ${" "} ${item.units && item.units?.width
                        ? lengthUnit[item.units.width]?.displayName
                        : "CM"
                      }`,
                    productInfo: item.product_info,
                    productspec: item?.product_spec,
                    orderWeight: `${item?.weight} ${item?.units?.weight?.toUpperCase()}`,
                    plannedReels: "-",
                    plannedreel: orderData.requirement,
                    plannedWeight: "-",
                    fulflilledReels: orderData.fulfilled,
                    fulflilledWeight:
                      orderData.fulfilled_weight.toFixed(3) +
                      " " +
                      (orderData?.units && orderData.units.fulfilled_weight
                        ? capitalize(
                          weightUnit[orderData.units.fulfilled_weight]
                            ?.displayName
                        )
                        : "T"),
                    unFulflilledReels: "-",
                    unFulflilledWeight: "-",
                    priority: false,
                    deliverydate: "-",
                    external_order_id: item.external_order_id,
                    remarks: item.remarks,
                    reel_od: item.reel_od,
                    core_id: item.core_id,
                    consignee_name: "-",
                    consignee_code: "-",
                    consignee: item.consignee_name,
                    reelSpecification: orderData?.diameter_fulfillment?.map(
                      (diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[orderData.units?.fulfilled_weight]
                            ?.displayName
                        );
                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                      }
                    ),
                    diameter_fulfillment: orderData?.diameter_fulfillment?.map(
                      (diaItem, index) => {
                        return {
                          reel_od: diaItem.reel_od,
                          core_id: diaItem.core_id,
                          fulfilled_weight:
                            diaItem.fulfilled_weight -
                            orderData?.cancelled_diameter_fulfillment[index]
                              ?.fulfilled_weight,
                          fulfilled:
                            diaItem.fulfilled -
                            orderData?.cancelled_diameter_fulfillment[index]
                              ?.fulfilled,
                          fulfilledWeightUnit: orderData.units?.fulfilled_weight
                            ? orderData.units?.fulfilled_weight
                            : unitData.units_management.weight.default,
                        };
                      }
                    ),
                    cancelled_diameter_fulfillment:
                      orderData?.cancelled_diameter_fulfillment,
                    fulfilled_quantity:
                      orderData.fulfilled_weight - orderData.cancelled_weight,
                    units: unitValue,
                    cancelledQty: orderData?.cancelled_diameter_fulfillment
                      ?.filter((dia) => dia.fulfilled_weight > 0)
                      ?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          orderData.units?.fulfilled_weight
                            ? capitalize(
                              weightUnit[orderData.units?.fulfilled_weight]
                                .displayName
                            )
                            : "T"
                        );
                        return fulfilledWeight && fulfilledValue
                          ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue} ${orderData.type !== "reel" ? "S" : "R"
                          })\n`
                          : "-";
                      }),
                    isReel: item?.type === "reel",
                  };
                });

                setOrderDetailsList([...orderList, ...sizesList]);
              })
              .catch((error) => console.log(error));
          } else {
            setOrderDetailsList(orderList);
          }
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setIsFetchingData(false);
        }));
  };
  function calculateDeckleSize(job, isCylinder, sheet) {
    const machine = sheet
      ? job?.jobcard?.group?.machines[1]
      : job?.jobcard?.group?.machines[0];

    if (machine) {
      const deckleSizeUB = machine.deckle_size_ub || 0;
      const leftEdgeTrim = machine.left_edge_trim || 0;
      const rightEdgeTrim = machine.right_edge_trim || 0;

      const lengthUnitDisplayName =
        lengthUnit[machine.units?.deckle_size_ub]?.displayName || "";

      const totalValue =
        deckleSizeUB +
        (leftEdgeTrim + rightEdgeTrim) *
        CoversionFactorUnitsToCM[machine.units?.right_edge_trim] *
        CoversionFactorCMToUnits[machine.units?.deckle_size_ub];

      const deckleSizeLB = machine.deckle_size_lb || 0;

      let formattedTotalValue;
      if (Number.isInteger(totalValue)) {
        formattedTotalValue = totalValue.toFixed(0);
      } else {
        formattedTotalValue = totalValue.toFixed(3);
      }
      let formattedLB = Number.isInteger(deckleSizeLB)
        ? deckleSizeLB
        : deckleSizeLB?.toFixed(3);
      return isCylinder
        ? `${formattedLB} - ${formattedTotalValue} ${lengthUnitDisplayName}`
        : `${formattedTotalValue} - ${formattedLB} ${lengthUnitDisplayName}`;
    }

    return "";
  }

  const fetchOrdersForPrint = async () => {
    setIsPrintDisabled(true);
    let orderList = [];
    const ordersList = acceptedSolution.solution.data.orders
      ?.filter((order) => {
        return order.item_type == "order";
      })
      .map((item) => item.order_id);
    setOrderIdList(ordersList);

    ordersList &&
      (await getOrdersList(ordersList)
        .then((response) => {
          orderList = response.data.map((item, index) => {
            const orderData = acceptedSolution.solution.data.orders.filter(
              (order) => parseFloat(order.order_id) === item.number
            )[0];

            // console.log(orderData);
            let unitValue = orderData.units ? orderData.units : {};
            unitValue["fulfilled_weight"] = unitValue?.fulfilled_weight
              ? unitValue?.fulfilled_weight
              : unitData.units_management.weight.default;
            return {
              key: index + 1,
              orderType: item.type,
              grain: item.grain,
              length: item.length,
              width: item.width,
              pono: `${item.po}`,
              category: item?.category,
              sono: item?.so,
              orderno: `${item.number}`,
              type: "Order",
              overfulfillmentPercentage: `${(((orderData.fulfilled_weight / orderData.requirement) - 1) * 100).toFixed(2)}%`,
              productspec: item?.product_spec,
              customercode: item.customer,
              customername: item.customer_name,
              customer_alias: item.customer_alias,
              size: `${item.width}${item.length ? ` x ${item.length}` : ""
                } ${" "} ${item?.units && item?.units?.width
                  ? lengthUnit[item.units.width]?.displayName
                  : "CM"
                }`,
              matchedGrain: orderData?.grain,
              isReel: orderData.type === "reel",
              productInfo: item.product_info,
              orderWeight: `${item?.weight?.toFixed(3)} ${item?.units?.weight?.toUpperCase()}`,
              plannedReels: orderData.requirement,
              plannedreel: orderData.requirement,
              plannedWeight:
                orderData.requirement?.toFixed(3) +
                " " +
                (orderData?.units && orderData.units.requirement
                  ? capitalize(
                    weightUnit[orderData.units.requirement]?.displayName
                  )
                  : "T"),
              fulflilledReels: orderData.fulfilled,
              fulflilledWeight:
                orderData.fulfilled_weight.toFixed(3) +
                " " +
                (orderData?.units && orderData.units.fulfilled_weight
                  ? capitalize(
                    weightUnit[orderData.units.fulfilled_weight]?.displayName
                  )
                  : "T"),
              unFulflilledReels: orderData.unfulfilled,
              unFulflilledWeight:
                orderData.unfulfilled_weight.toFixed(3) +
                " " +
                (orderData?.units && orderData.units.unfulfilled_weight
                  ? capitalize(
                    weightUnit[orderData.units.unfulfilled_weight]
                      ?.displayName
                  )
                  : "T"),
              priority: jobCard.jobcard.group.orders.filter(
                (order) => order.order_id === item.number
              )[0].forced,
              deliverydate:
                item.category === "so"
                  ? "-"
                  : moment(item.delivery_date).format("DD MMM YYYY"),
              reel_od: item.reel_od,
              core_id: item.core_id,
              consignee_name: item.consignee_name,
              consignee_code: item.consignee_code,
              reelSpecification: orderData?.diameter_fulfillment?.map(
                (diaItem) => {
                  const reelOd = diaItem.reel_od;
                  const coreId = diaItem.core_id;
                  const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
                  const fulfilledValue = diaItem.fulfilled;
                  const fulfilledWeightUnit = capitalize(
                    orderData.units?.fulfilled_weight
                      ? capitalize(
                        weightUnit[orderData.units?.fulfilled_weight]
                          .displayName
                      )
                      : "T"
                  );
                  return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R) \n`;
                }
              ),
              diameter_fulfillment: orderData?.diameter_fulfillment?.map(
                (diaItem, index) => {
                  return {
                    reel_od: diaItem.reel_od,
                    core_id: diaItem.core_id,
                    fulfilled_weight:
                      diaItem.fulfilled_weight -
                      orderData?.cancelled_diameter_fulfillment[index]
                        ?.fulfilled_weight,
                    fulfilled:
                      diaItem.fulfilled -
                      orderData?.cancelled_diameter_fulfillment[index]
                        ?.fulfilled,
                    fulfilledWeightUnit: orderData.units?.fulfilled_weight
                      ? orderData.units?.fulfilled_weight
                      : unitData.units_management.weight.default,
                  };
                }
              ),
              cancelled_diameter_fulfillment:
                orderData?.cancelled_diameter_fulfillment,
              fulfilled_quantity:
                orderData.fulfilled_weight - orderData.cancelled_weight,
              units: unitValue,
              cancelledQty: orderData?.cancelled_diameter_fulfillment
                ?.filter((dia) => dia.fulfilled_weight > 0)
                ?.map((diaItem) => {
                  const reelOd = diaItem.reel_od;
                  const coreId = diaItem.core_id;
                  const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
                  const fulfilledValue = diaItem.fulfilled;
                  const fulfilledWeightUnit = capitalize(
                    orderData.units?.fulfilled_weight
                      ? capitalize(
                        weightUnit[orderData.units?.fulfilled_weight]
                          .displayName
                      )
                      : "T"
                  );
                  return fulfilledWeight && fulfilledValue
                    ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue} ${orderData.type !== "reel" ? "S" : "R"
                    })\n`
                    : "-";
                }),
              external_order_id: item.external_order_id,
              remarks: item.remarks
            };
          });

          const stockSizesList = acceptedSolution.solution.data.orders
            ?.filter((order) => {
              return order.item_type == "stock" || order.item_type == "product_stock_size";
            })
            .map((item) => item.order_id);
          if (stockSizesList.length > 0) {
            getStocksDetailsByIds({ stocks: stockSizesList })
              .then((response) => {
                let sizesList = response.data.map((item, index) => {
                  const orderData =
                    acceptedSolution.solution.data.orders.filter(
                      (order) => order.order_id === item.id
                    )[0];
                  //console.log(orderData);
                  let unitValue = orderData.units ? orderData.units : {};
                  unitValue["fulfilled_weight"] = unitValue?.fulfilled_weight
                    ? unitValue?.fulfilled_weight
                    : unitData.units_management.weight.default;

                  return {
                    key: index + 1,
                    pono: "-",
                    orderno: `${item.id}`,
                    type: "Stock",
                    grain: item.grain,
                    length: item.length,
                    width: item.width,
                    orderType: item.type,
                    customercode: "-",
                    customername: "-",
                    customer_alias: "-",
                    size: `${item.width}${item.length ? ` x ${item.length}` : ""
                      } ${" "} ${item.units && item.units?.width
                        ? lengthUnit[item.units.width]?.displayName
                        : "CM"
                      }`,
                    productInfo: item.product_info,
                    productspec: item?.product_spec,
                    plannedReels: "-",
                    plannedreel: orderData.requirement,
                    plannedWeight: "-",
                    fulflilledReels: orderData.fulfilled,
                    fulflilledWeight:
                      orderData.fulfilled_weight.toFixed(3) +
                      " " +
                      (orderData?.units && orderData.units.fulfilled_weight
                        ? capitalize(
                          weightUnit[orderData.units.fulfilled_weight]
                            ?.displayName
                        )
                        : "T"),
                    unFulflilledReels: "-",
                    unFulflilledWeight: "-",
                    priority: false,
                    deliverydate: "-",
                    remarks: "",
                    reel_od: item.reel_od,
                    core_id: item.core_id,
                    consignee_name: "-",
                    consignee_code: "-",
                    consignee: item.consignee_name,
                    reelSpecification: orderData?.diameter_fulfillment?.map(
                      (diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[orderData.units?.fulfilled_weight]
                            ?.displayName
                        );
                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                      }
                    ),
                    diameter_fulfillment: orderData?.diameter_fulfillment?.map(
                      (diaItem, index) => {
                        return {
                          reel_od: diaItem.reel_od,
                          core_id: diaItem.core_id,
                          fulfilled_weight:
                            diaItem.fulfilled_weight -
                            orderData?.cancelled_diameter_fulfillment[index]
                              ?.fulfilled_weight,
                          fulfilled:
                            diaItem.fulfilled -
                            orderData?.cancelled_diameter_fulfillment[index]
                              ?.fulfilled,
                          fulfilledWeightUnit: orderData.units?.fulfilled_weight
                            ? orderData.units?.fulfilled_weight
                            : unitData.units_management.weight.default,
                        };
                      }
                    ),
                    cancelled_diameter_fulfillment:
                      orderData?.cancelled_diameter_fulfillment,
                    fulfilled_quantity:
                      orderData.fulfilled_weight - orderData.cancelled_weight,
                    units: unitValue,
                    cancelledQty: orderData?.cancelled_diameter_fulfillment
                      ?.filter((dia) => dia.fulfilled_weight > 0)
                      ?.map((diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          orderData.units?.fulfilled_weight
                            ? weightUnit[orderData.units?.fulfilled_weight]
                              .displayName
                            : "T"
                        );
                        return fulfilledWeight && fulfilledValue
                          ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue} ${orderData.type !== "reel" ? "S" : "R"
                          })\n`
                          : "-";
                      }),
                    isReel: item?.type === "reel",
                  };
                });

                setJobCardDetailsListForPrint([...orderList, ...sizesList]);
              })
              .catch((error) => console.log(error));
          } else {
            setJobCardDetailsListForPrint(orderList);
          }
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setIsPrintDisabled(false);
        }));
  };

  const showParentReelJobCard = (id, isProduced) => {
    setSelectedParentReel(id);
    setViewParentReelJobCardDrawer(true);
    setIsProduced(isProduced);
  };

  const onCloseParentReelCancel = (id) => {
    setViewParentReelJobCardDrawer(false);
    // showCancelProduction(id);
  };
  const closeParentReelJobCard = () => {
    setSelectedParentReel();
    setViewParentReelJobCardDrawer(false);
    setIsProduced(false);
  };

  useEffect(async () => {
    try {
      const unitData = await getUnitData();
      if (!unitData.error) {
        setUnitData(unitData.data);
      }
    } catch (err) {
      console.log(err);
    }
    if (location.state) setSearchParams({ id: location.state.id });
  }, []);

  useEffect(() => {
    if (reFetch) {
      getJobCardDetailsById();
      setReFetch(false);
    }
  }, [reFetch]);

  useEffect(() => {
    if (acceptedSolution.solution) fetchOrders();
  }, [acceptedSolution, pageSize, currentPage]);
  useEffect(async () => {
    const orderMangSettings = await getWorkflowSettings("order_management");
    setOrderManagementSettings(orderMangSettings.data);
    const deckleMangSettings = await getWorkflowSettings("deckle_management");
    setDeckleManagementSettings(deckleMangSettings?.data);
  }, []);
  useEffect(() => {
    if (!orderManagementSettings) return;
    if (orderManagementSettings.fetch_balance_quantity.value) return;
    if (
      jobCard?.state === "in_production" ||
      jobCard?.state === "complete" ||
      jobCard?.state === "hold"
    ) {
      for (let i = 0; i < machineType.length; i++) {
        if (machineType[i] == "rewinding") {
          setIsMapJumboLoading(true);
          getJumboReelDetailsByIdForMultiStage(jobId, "rewinding")
            .then((response) => {
              // let isCancelDisabled = false;
              // let holdProductionCounter = 0;
              if (response.data.data && response.data.data.length == 0) {
                // isCancelDisabled = true;
                // setDisableCancel(true);
                setJumboReelData([]);
              } else {
                setJumboReelData(
                  response.data.data?.map((item) => {
                    // if (item.status === "produced") setProducedParentReelBool(true);

                    // if (item.status === "mapped" || item.status === "produced" || item.status === "rejected") {
                    //   setDisableCancel(true);
                    //   isCancelDisabled = true;
                    // }

                    const reelOdValue = item.reel_od
                      ? `${item.reel_od} ${jobCard.jobcard.group.grouping_params.units &&
                        jobCard.jobcard.group.grouping_params.units.reel_od
                        ? lengthUnit[
                          jobCard.jobcard.group.grouping_params.units
                            .reel_od
                        ]?.displayName.toUpperCase()
                        : "CM"
                      }`
                      : "0";
                    const coreIdValue = item.core_id
                      ? `${item.core_id} ${jobCard.jobcard.group.grouping_params.units &&
                        jobCard.jobcard.group.grouping_params.units.core_id
                        ? lengthUnit[
                          jobCard.jobcard.group.grouping_params.units
                            .core_id
                        ]?.displayName.toUpperCase()
                        : "CM"
                      }`
                      : "0";

                    // if (item.status !== 'cancel' && item.status !== 'produced') holdProductionCounter++;

                    return {
                      leftTrim:
                        item.left_edge_trim +
                        " " +
                        (item.units.left_edge_trim
                          ? lengthUnit[
                            item.units.left_edge_trim
                          ]?.displayName?.toUpperCase()
                          : ""),
                      rightTrim:
                        item.right_edge_trim +
                        " " +
                        (item.units.right_edge_trim
                          ? lengthUnit[
                            item.units.right_edge_trim
                          ]?.displayName?.toUpperCase()
                          : ""),
                      deckleWidth: item.deckle_width,
                      priority: item.priority,
                      parentReel: item.parent_reel.id,
                      combinations: item.combinations,
                      d_com_width:
                        item.d_com_width +
                        " " +
                        (item.units.d_com_width
                          ? lengthUnit[
                            item.units.d_com_width
                          ]?.displayName?.toUpperCase()
                          : ""),
                      trimLoss: item.trim_loss,
                      netTrimLoss: item.net_trim_loss,
                      deliverydate: item.earliest_delivery_date,
                      mappedJumboRoll: item?.mapped_jumbo_reels,
                      status:
                        item.status === "open"
                          ? "Not Mapped"
                          : item.status === "cancel"
                            ? "Cancelled"
                            : capitalize(item.status),
                      core_id: item.core_id,
                      reel_od: item.reel_od,
                      machine_type: item.machine_type,
                      units: item.units,
                      diaValue: `${reelOdValue} / ${coreIdValue}`,
                      combination_no: item.combination_no,
                      number_of_reels: item.no_of_reels,
                      reel_length: item.reel_length,
                      reels: item.reels,
                      rewinder_id: item.rewinder_id,
                    };
                  })
                );
              }
              // if (!holdProductionCounter) setDisableHoldProduction(true);
              // if (!isCancelDisabled) setDisableCancel(false);
            })
            .catch((error) => {
              if (
                error?.response?.data?.msg ===
                "only in production jobcards are required"
              ) {
                setReFetch(true);
                setActiveTab("1");
              }
            })
            .finally(() => setIsMapJumboLoading(false));
        } else {
          setIsMapCuttingLoading(true);
          getJumboReelDetailsByIdForMultiStage(jobId, "cutting")
            .then((response) => {
              // let isCuttingCancelDisabled = false;
              // let holdProductionCounter = 0;
              if (response.data.data && response.data.data.length == 0) {
                // isCuttingCancelDisabled = true;
                // setCuttingDisableCancel(true);
                setCuttingJumboReelData([]);
              } else {
                setCuttingJumboReelData(
                  response.data.data?.map((item) => {
                    // if (item.status === "produced") setCuttingProducedParentReelBool(true);

                    // if (item.status === "mapped" || item.status === "produced") {
                    //   // setCuttingDisableCancel(true);
                    //   isCuttingCancelDisabled = true;
                    // }

                    const reelOdValue = item.reel_od
                      ? `${item.reel_od} ${jobCard.jobcard.group.grouping_params.units &&
                        jobCard.jobcard.group.grouping_params.units.reel_od
                        ? lengthUnit[
                          jobCard.jobcard.group.grouping_params.units
                            .reel_od
                        ]?.displayName.toUpperCase()
                        : "CM"
                      }`
                      : "0";
                    const coreIdValue = item.core_id
                      ? `${item.core_id} ${jobCard.jobcard.group.grouping_params.units &&
                        jobCard.jobcard.group.grouping_params.units.core_id
                        ? lengthUnit[
                          jobCard.jobcard.group.grouping_params.units
                            .core_id
                        ]?.displayName.toUpperCase()
                        : "CM"
                      }`
                      : "0";

                    // if (item.status !== 'cancel' && item.status !== 'produced') holdProductionCounter++;

                    return {
                      leftTrim:
                        item.left_edge_trim +
                        " " +
                        (item.units.left_edge_trim
                          ? lengthUnit[
                            item.units.left_edge_trim
                          ]?.displayName?.toUpperCase()
                          : ""),
                      rightTrim:
                        item.right_edge_trim +
                        " " +
                        (item.units.right_edge_trim
                          ? lengthUnit[
                            item.units.right_edge_trim
                          ]?.displayName?.toUpperCase()
                          : ""),
                      combinations: item.combinations,
                      d_com_width:
                        item.d_com_width +
                        " " +
                        (item.units.d_com_width
                          ? lengthUnit[
                            item.units.d_com_width
                          ]?.displayName?.toUpperCase()
                          : ""),
                      trimLoss: item.trim_loss,
                      netTrimLoss: item.net_trim_loss,
                      deliverydate: item.earliest_delivery_date,
                      status:
                        item.status === "open"
                          ? "Not Mapped"
                          : item.status === "cancel"
                            ? "Cancelled"
                            : capitalize(item.status),
                      core_id: item.core_id,
                      reel_od: item.reel_od,
                      units: item.units,
                      diaValue: `${reelOdValue} / ${coreIdValue}`,
                      combination_no: item.combination_no,
                      number_of_reels: item.no_of_reels,
                      cutter_id: item.cutter_id,
                      reel_no: item.cutting_pattern.id,
                      parent_reel_size:
                        item.cutting_pattern_size +
                        " " +
                        (item.units.reel_size
                          ? lengthUnit[
                            item.units.reel_size
                          ]?.displayName?.toUpperCase()
                          : ""),
                      quantity:
                        item?.cutting_pattern?.weight?.toFixed(3) +
                        " " +
                        (item?.cutting_pattern?.units?.weight
                          ? capitalize(
                            weightUnit[item?.cutting_pattern?.units?.weight]
                              ?.displayName
                          )
                          : ""),
                      cutting_pattern: item.cutting_pattern,
                      cutter_type: item.cutter_type,
                      length: item.length,
                      left_length: item.left_length,
                      right_length: item.right_length,
                      priority: item.priority,
                      machine_type: item.machine_type,
                    };
                  })
                );
              }
              // if (!holdProductionCounter) setDisableCuttingHoldProduction(true);
              // if (!isCuttingCancelDisabled) setCuttingDisableCancel(false);
            })
            .catch((error) => {
              if (
                error?.response?.data?.msg ===
                "only in production jobcards are required"
              ) {
                setReFetch(true);
                setActiveTab("1");
              }
            })
            .finally(() => setIsMapCuttingLoading(false));
        }
      }
    }
  }, [jobCard]);

  // Column heads
  // const columnsHead = [
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "8%",
  //     fixed: "left",
  //     align: "center",
  //     render: (text, record) => {
  //       const value =
  //         record.category === "po"
  //           ? toHandlePOName(record.pono)
  //           : record.category === "so"
  //           ? toHandlePOName(record.sono)
  //           : toHandlePOName(record.pono);

  //       return (
  //         <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" }}>
  //           {value
  //             ?.match(/.{1,15}/g)
  //             ?.map((chunk, index) => (
  //               <span key={index}>
  //                 {chunk}
  //                 <br />
  //               </span>
  //             ))}
  //         </span>
  //       );
  //     }

  //   },
  //   {
  //     title: "Order No/Stock No",
  //     dataIndex: "orderno",
  //     width: "9%",
  //     fixed: "left",
  //   },
  //   {
  //     title: "Type",
  //     dataIndex: "type",
  //     width: "6%",
  //     fixed: "left",
  //   },
  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "9%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customername}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias||'-'}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_name",
  //     width: "10%",
  //     render: (text, record) => (
  //       record?.consignee_name||'-'
  //     )
  //   },
  //   {
  //     title: (
  //       <div>
  //         Product Spec
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     dataIndex: "productspec",
  //     width: "14%",
  //   },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "9%",
  //   },
  //   // {
  //   //   title: "Planned Reels",
  //   //   dataIndex: "plannedReels",
  //   //   width: "8%",
  //   //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
  //   // },
  //   {
  //     title: "Matched Grain",
  //     dataIndex: "matchedGrain",
  //     width: "10%",
  //     render: (text, record) => (!record.isReel ? <div>{text}</div> : "-"),
  //   },
  //   {
  //     title: "Planned Quantity",
  //     dataIndex: "plannedWeight",
  //     width: "10%",
  //   },
  //   // {
  //   //   title: "Fulfilled Reels",
  //   //   dataIndex: "fulflilledReels",
  //   //   width: "8%",
  //   //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
  //   // },
  //   {
  //     title: "Fulfilled Quanitity",
  //     dataIndex: "fulflilledWeight",
  //     width: "10%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5%",
  //   // },
  //   {
  //     title: "REEL SPECIFICATION",
  //     dataIndex: "reelSpecification",
  //     width: "22%",
  //     render: (text, record) =>
  //       record.isReel ? (
  //         <div
  //           dangerouslySetInnerHTML={{
  //             __html: String(text).replace(/\n/g, "<br />"),
  //           }}
  //         />
  //       ) : (
  //         "-"
  //       ),
  //   },
  //   {
  //     title: "Del Date",
  //     dataIndex: "deliverydate",
  //     width: "10%",
  //   },

  //   {
  //     title: "Cancelled Quantity",
  //     dataIndex: "cancelledQty",
  //     width: "22%",
  //     render: (text) =>
  //       isParentReelCancelled ? (
  //         <div
  //           dangerouslySetInnerHTML={{
  //             __html: String(text).replace(/\n/g, "<br />"),
  //           }}
  //         />
  //       ) : (
  //         "-"
  //       ),
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "8%",
  //     render: (text, record) =>
  //       record.type === "Order" && (
  //         <div className="actionBtn">
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={record.remarks}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button style={{ cursor: "default" }}>
  //                 <Iconmoon icon="message" size={16} color="#EA655B" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         </div>
  //       ),
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "8%",
  //     render: (text, record) =>
  //       record.type === "Order" && (
  //         <div className="actionBtn">
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"View details of this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button onClick={() => showViewDrawer(record.orderno,record)}>
  //                 <Iconmoon icon="file-view" size={16} color="#A19F9D" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         </div>
  //       ),
  //     align: "center",
  //   },
  // ];

  const intermediateColumnsHead = [
    {
      title: "Sr.No",
      dataIndex: "srno",
      width: 6,
      fixed: "left",
      align: "center",
    },
    {
      title: "Reel Size",
      dataIndex: "reel_size",
      width: 8,
      // fixed: "left",
      align: "center",
    },
    {
      title: "Cutting Pattern",
      dataIndex: "cuttingPattern",
      width: 10,
      align: "center",
    },
    // {
    //   title: "",
    //   dataIndex: "grain",
    //   width: 8,
    //   align: "center",
    // },
    {
      title: "Quantity",
      dataIndex: "quantity",
      width: 8,
      align: "center",
    },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: 16,
      align: "center",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{
            __html: String(text).replace(/\n/g, "<br />"),
          }}
        />
      ),
    },
    {
      title: "Cancelled Quantity",
      dataIndex: "cancelledQty",
      width: 16,
      align: "center",
      render: (text) =>
        isParentReelCancelled ? (
          <div
            dangerouslySetInnerHTML={{
              __html: String(text).replace(/\n/g, "<br />"),
            }}
          />
        ) : (
          "-"
        ),
    },
  ];

  // const unfulfilledColumnsHead = [
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "7%",
  //     fixed: "left",
  //     align: "center",
  //     render: (text, record) => {
  //       const value =
  //         record.category === "po"
  //           ? toHandlePOName(record.pono)
  //           : record.category === "so"
  //           ? toHandlePOName(record.sono)
  //           : toHandlePOName(record.pono);

  //       return (
  //         <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" }}>
  //           {value
  //             ?.match(/.{1,15}/g)
  //             ?.map((chunk, index) => (
  //               <span key={index}>
  //                 {chunk}
  //                 <br />
  //               </span>
  //             ))}
  //         </span>
  //       );
  //     }

  //   },
  //   {
  //     title: "Order No/Stock No",
  //     dataIndex: "orderno",
  //     width: "7%",
  //     fixed: "left",
  //   },
  //   {
  //     title: "Type",
  //     dataIndex: "type",
  //     width: "7%",
  //     fixed: "left",
  //   },
  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "10%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customername}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias||'-'}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_name",
  //     width: "10%",
  //     render: (text, record) => (
  //       record?.consignee_name||'-'
  //     )
  //   },
  //   {
  //     title: (
  //       <div>
  //         Product Spec
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     dataIndex: "productspec",
  //     width: "14%",
  //   },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "9%",
  //   },
  //   // {
  //   //   title: "Planned Reels",
  //   //   dataIndex: "plannedReels",
  //   //   width: "8%",
  //   //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
  //   // },
  //   {
  //     title: "Matched Grain",
  //     dataIndex: "matchedGrain",
  //     width: "8%",
  //     render: (text, record) => `${!record.isReel ? text : "-"}`,
  //   },
  //   {
  //     title: "Planned Quantity",
  //     dataIndex: "plannedWeight",
  //     width: "10%",
  //   },
  //   // {
  //   //   title: "Unfulfilled Reels",
  //   //   dataIndex: "unFulflilledReels",
  //   //   width: "8%",
  //   //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
  //   // },
  //   {
  //     title: "Unfulfilled Quantity",
  //     dataIndex: "unFulflilledWeight",
  //     width: "10%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5%",
  //   // },
  //   {
  //     title: "Del Date",
  //     dataIndex: "deliverydate",
  //     width: "10%",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "8%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "7%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View details of this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button onClick={() => showViewDrawer(record.orderno,record)}>
  //               <Iconmoon icon="file-view" size={16} color="#A19F9D" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  // ];

  const sizeFulfillmentColumnsHead = [
    {
      title: "Sr.No",
      dataIndex: "key",
      width: "7%",
      fixed: "left",
      align: "center",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "7%",
    //   fixed: "left",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "Matched Grain",
      dataIndex: "grain",
      width: "10%",
      // render: (record, text) => (
      //   record.type == 'Sheet' ?
      // )
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    {
      title: "Fulfilled Quantity",
      dataIndex: "fulflilledWeight",
      width: "10%",
    },
    {
      title: "UnFulfilled/(Overfulfilled) Quantity",
      dataIndex: "unFulflilledWeight",
      width: "10%",
      render: (text, record) => {
        const parsedValue = parseFloat(text?.split(" ")[0]);
        const positiveValue = Math.abs(parsedValue);
        return parsedValue < 0 ? (
          <div>
            ({positiveValue} {text?.split(" ")[1]})
          </div>
        ) : (
          text
        );
      },
    },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: "20%",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{
            __html: String(text).replace(/\n/g, "<br />"),
          }}
        />
      ),
    },
    // {
    //   title: "Planned Reels",
    //   dataIndex: "plannedReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    // {
    //   title: "Fulfilled Reels",
    //   dataIndex: "fulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    // {
    //   title: "Unfulfilled Reels",
    //   dataIndex: "unFulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
  ];

  const mapRewindingColumnsHead = [
    {
      title: "Com No",
      dataIndex: "combination_no",
      width: 5,
      fixed: "left",
      align: "center",
    },
    {
      title: "Combination",
      dataIndex: "combinations",
      width: 10,
      // sorter: {
      //   compare: (a, b) => {},
      // },
      render: (text, record) => (
        <div className="combination-rl">
          {record.machine_type !== "cutter" ? (
            <h4>
              {text?.map(
                (item, index, array) =>
                  `${item.width} ${index + 1 !== array.length ? "+" : ""}`
              )}{" "}
              {record?.combinations[0]?.units?.width
                ? lengthUnit[
                  record?.combinations[0]?.units?.width
                ]?.displayName?.toUpperCase()
                : ""}
              {record.priority && <span dataset="Priority">Priority</span>}
            </h4>
          ) : (
            <h4>
              {`(`}
              {text?.map(
                (item, index) =>
                  `${item.width} ${index + 1 !== text.length ? "+" : ""}`
              )}{" "}
              {`) X ${text[0].length}`}{" "}
              {record?.combinations[0]?.units?.width
                ? lengthUnit[
                  record?.combinations[0]?.units?.width
                ]?.displayName?.toUpperCase()
                : ""}
              {record.priority && <span dataset="Priority">Priority</span>}
            </h4>
          )}

          {record.core_id &&
            record.reel_od &&
            record.machine_type !== "cutter" ? (
            <p>Parent Reel: {record.parentReel}</p>
          ) : (
            <p>Parent Set: {record.parentReel}</p>
          )}
        </div>
      ),
    },
    {
      title: "D.Com Width",
      dataIndex: "d_com_width",
      width: 5,
      align: "center",
    },
    {
      title: "Reel OD/ Core OD",
      dataIndex: "diaValue",
      width: 5,
      align: "center",
    },
    {
      title: "Left Edge Trim",
      dataIndex: "leftTrim",
      width: 5,
      align: "center",
    },
    {
      title: "Right Edge Trim",
      dataIndex: "rightTrim",
      width: 5,
      align: "center",
    },
    {
      title: "Trim",
      dataIndex: "trimLoss",
      width: 5,
      align: "center",
      render: (text, record) =>
        `${text.toFixed(3)} ${" "} ${record?.units && record?.units?.trim_loss
          ? lengthUnit[record.units.trim_loss]?.displayName?.toUpperCase()
          : "CM"
        }`,
    },
    {
      title: (
        <div>
          Net Trim
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={"Net trim loss including the edge trim"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "netTrimLoss",
      width: 5,
      align: "center",
      render: (text, record) =>
        `${text.toFixed(3)} ${" "} ${record?.units && record?.units?.net_trim_loss
          ? lengthUnit[record.units.net_trim_loss]?.displayName?.toUpperCase()
          : "CM"
        }`,
    },
    {
      title: (
        <div>
          Earliest Delivery <br /> Date
        </div>
      ),
      dataIndex: "deliverydate",
      width: 10,
      align: "center",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      render: (text) => moment(text).format("DD MMM YYYY"),
    },
    {
      title: "Mapped Jumbo Roll",
      dataIndex: "mappedJumboRoll",
      width: 10,
      align: "center",
      render: (text) => {
        return text.length === 0
          ? "-"
          : text?.map(
            (item, index, array) =>
              `${item.number}${index + 1 != array.length ? ", " : ""}`
          );
      },
    },
    {
      title: "Production status",
      dataIndex: "status",
      width: 10,
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.reel_od && record.core_id
                  ? text === "Produced"
                    ? "The production of this parent reel is completed"
                    : text === "Mapped"
                      ? "This parent reel is mapped to jumbo roll for rewinding"
                      : text === "Not Mapped"
                        ? "This parent reel is not mapped to jumbo roll yet"
                        : text === "Cancelled"
                          ? "The production of this parent reel is cancelled"
                          : null
                  : text === "Produced"
                    ? " The production of this parent set is completed"
                    : text === "Mapped"
                      ? "The parent set has been mapped to a jumbo roll"
                      : text === "Not Mapped"
                        ? "The parent set is not mapped to a jumbo roll yet"
                        : text === "Cancelled"
                          ? "The production of this parent set is cancelled"
                          : text === "Rejected"
                            ? "The production of this parent set is rejected "
                            : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {text}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "ACTIONS",
      dataIndex: "action",
      width: "13%",
      align: "center",
      render: (text, record) => (
        <div
          className="actionBtn"
          style={{ display: "flex", justifyContent: "end" }}
        >
          {record.status == "Mapped" &&
            jobCard.state !== "hold" &&
            jobCard.state !== "complete" && (
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={"Print details of the parent reel"}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Button onClick={() => routeChange(record)}>
                    <img style={{ width: "20px" }} src={PrintIcon} />
                  </Button>
                </Tooltip>
              </Styled>
            )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View parent reel details"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() =>
                  showParentReelJobCard(
                    record.parentReel,
                    record.status === "Produced" || record.status === "Rejected"
                  )
                }
              >
                <Iconmoon icon="file-view" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
    },
  ];

  const mapCuttingColumnsHead = [
    {
      title: "Com No.",
      dataIndex: "combination_no",
      width: 5,
      fixed: "left",
      align: "center",
    },
    {
      title: "Combination",
      dataIndex: "combinations",
      width: 10,
      fixed: "left",
      align: "center",
      render: (text, record) => {
        let leftPartitionData = "( ";
        let rightPartitionData = "( ";
        if (processType == "duplex") {
          text?.forEach((order, index) => {
            if (order.position === "left")
              leftPartitionData = leftPartitionData + order.width + " + ";
            else rightPartitionData = rightPartitionData + order.width + " + ";
          });

          let leftData = text.filter((order) => order.position === "left");
          let rightData = text.filter((order) => order.position === "right");

          if (leftData.length && rightData.length) {
            leftPartitionData = leftPartitionData.substring(
              0,
              leftPartitionData.length - 2
            );
            leftPartitionData =
              leftPartitionData + ") x " + record.left_length + " + ";
            rightPartitionData = rightPartitionData.substring(
              0,
              rightPartitionData.length - 2
            );
            rightPartitionData =
              rightPartitionData + ") x " + record.right_length;
          }

          if (!leftData.length) {
            leftPartitionData = "";
            rightPartitionData = rightPartitionData.substring(
              0,
              rightPartitionData.length - 2
            );
            rightPartitionData =
              rightPartitionData + ") x " + record.right_length;
          }

          if (!rightData.length) {
            rightPartitionData = "";
            leftPartitionData = leftPartitionData.substring(
              0,
              leftPartitionData.length - 2
            );
            leftPartitionData = leftPartitionData + ") x " + record.left_length;
          }
        }
        let partitionData = leftPartitionData + rightPartitionData;

        return (
          <div className="combination-rl">
            {processType != "duplex" ? (
              <h4>
                {`(`}
                {text?.map(
                  (item, index) =>
                    `${item.width} ${index + 1 !== text.length ? "+" : ""}`
                )}{" "}
                {`) X ${record.length}`}{" "}
                {record?.combinations[0]?.units?.width
                  ? lengthUnit[
                    record?.combinations[0]?.units?.width
                  ]?.displayName?.toUpperCase()
                  : ""}
                {record.priority && <span dataset="Priority">Priority</span>}
              </h4>
            ) : (
              <h4>
                {`${partitionData}${" "}
                      ${record?.combinations[0]?.units?.width
                    ? lengthUnit[
                      record?.combinations[0]?.units?.width
                    ]?.displayName?.toUpperCase()
                    : ""
                  }`}
                {record.priority && <span dataset="Priority">Priority</span>}
              </h4>
            )}
          </div>
        );
      },
    },
    {
      title: "D.Com Width",
      dataIndex: "d_com_width",
      width: 5,
      align: "center",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      width: 7,
      align: "center",
    },
    {
      title: "Left Edge Trim",
      dataIndex: "leftTrim",
      width: 5,
      align: "center",
    },
    {
      title: "Right Edge Trim",
      dataIndex: "rightTrim",
      width: 5,
      align: "center",
    },
    {
      title: "Trim",
      dataIndex: "trimLoss",
      width: 5,
      align: "center",
      render: (text, record) =>
        `${text.toFixed(3)} ${" "} ${record?.units && record?.units?.trim_loss
          ? lengthUnit[record.units.trim_loss]?.displayName?.toUpperCase()
          : "CM"
        }`,
    },
    {
      title: (
        <div>
          Net Trim
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={"Net trim loss including the edge trim"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "netTrimLoss",
      width: 5,
      align: "center",
      render: (text, record) =>
        `${text.toFixed(3)} ${" "} ${record?.units && record?.units?.net_trim_loss
          ? lengthUnit[record.units.net_trim_loss]?.displayName?.toUpperCase()
          : "CM"
        }`,
    },
    {
      title: "Parent Reel Size",
      dataIndex: "parent_reel_size",
      width: 6,
      align: "center",
    },
    {
      title: "No. of Reels",
      dataIndex: "number_of_reels",
      width: 5,
      align: "center",
    },
    {
      title: "Reel OD/ Core OD",
      dataIndex: "diaValue",
      width: 5,
      align: "center",
    },
    {
      title: "Reel No.",
      dataIndex: "reel_no",
      width: 5,
      align: "center",
    },
    {
      title: (
        <div>
          Earliest Delivery <br /> Date
        </div>
      ),
      dataIndex: "deliverydate",
      width: 10,
      align: "center",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      render: (text) => moment(text).format("DD MMM YYYY"),
    },
    {
      title: "Production status",
      dataIndex: "status",
      width: 8,
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.reel_od && record.core_id
                  ? text === "Produced"
                    ? "The production of this parent reel is completed"
                    : text === "Mapped"
                      ? "This parent reel is mapped to jumbo roll for rewinding"
                      : text === "Not Mapped"
                        ? "This parent reel is not mapped to jumbo roll yet"
                        : text === "Cancelled"
                          ? "The production of this parent reel is cancelled"
                          : null
                  : text === "Produced"
                    ? " The production of this parent set is completed"
                    : text === "Mapped"
                      ? "The parent set has been mapped to a jumbo roll"
                      : text === "Not Mapped"
                        ? "The parent set is not mapped to a jumbo roll yet"
                        : text === "Cancelled"
                          ? "The production of this parent set is cancelled"
                          : text === "Rejected"
                            ? "The production of this parent set is rejected "
                            : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {text}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "ACTIONS",
      dataIndex: "action",
      width: 12,
      align: "center",
      render: (text, record) => (
        <div
          className="actionBtn"
        // style={{ display: "flex", justifyContent: "end" }}
        >
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View parent reel details"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() =>
                  showParentReelJobCard(
                    record.reel_no,
                    record.status === "Produced" || record.status === "Rejected"
                  )
                }
              >
                <Iconmoon icon="file-view" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
    },
  ];

  const fullColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "8%",
      fixed: "left",
      align: "center",
      render: (text, record) => {
        const value =
          record.category === "po"
            ? toHandlePOName(record.pono)
            : record.category === "so"
              ? toHandlePOName(record.sono)
              : toHandlePOName(record.pono);

        return (
          <span
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.4",
            }}
          >
            {value?.match(/.{1,15}/g)?.map((chunk, index) => (
              <span key={index}>
                {chunk}
                <br />
              </span>
            ))}
          </span>
        );
      },
    },
    {
      title: "Order No/Stock No",
      dataIndex: "orderno",
      width: "9%",
      fixed: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "6%",
      fixed: "left",
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "9%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customername}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_name",
      width: "10%",
      render: (text, record) => record?.consignee_name || "-",
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={`The product specification is in the ${format}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    // {
    //   title: "Planned Reels",
    //   dataIndex: "plannedReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Matched Grain",
      dataIndex: "matchedGrain",
      width: "10%",
      render: (text, record) => (!record.isReel ? <div>{text}</div> : "-"),
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    // {
    //   title: "Fulfilled Reels",
    //   dataIndex: "fulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Fulfilled Quanitity",
      dataIndex: "fulflilledWeight",
      width: "10%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5%",
    // },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: "22%",
      render: (text, record) =>
        record.isReel ? (
          <div
            dangerouslySetInnerHTML={{
              __html: String(text).replace(/\n/g, "<br />"),
            }}
          />
        ) : (
          "-"
        ),
    },
    {
      title: "Del Date",
      dataIndex: "deliverydate",
      width: "10%",
    },

    {
      title: "Cancelled Quantity",
      dataIndex: "cancelledQty",
      width: "22%",
      render: (text) =>
        isParentReelCancelled ? (
          <div
            dangerouslySetInnerHTML={{
              __html: String(text).replace(/\n/g, "<br />"),
            }}
          />
        ) : (
          "-"
        ),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "8%",
      render: (text, record) =>
        record.type === "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={record.remarks}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button style={{ cursor: "default" }}>
                  <Iconmoon icon="message" size={16} color="#EA655B" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "8%",
      render: (text, record) =>
        record.type === "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => showViewDrawer(record.orderno, record)}>
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
  ];

  const fullUnfulfilledColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "7%",
      fixed: "left",
      align: "center",
      render: (text, record) => {
        const value =
          record.category === "po"
            ? toHandlePOName(record.pono)
            : record.category === "so"
              ? toHandlePOName(record.sono)
              : toHandlePOName(record.pono);

        return (
          <span
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.4",
            }}
          >
            {value?.match(/.{1,15}/g)?.map((chunk, index) => (
              <span key={index}>
                {chunk}
                <br />
              </span>
            ))}
          </span>
        );
      },
    },
    {
      title: "Order No/Stock No",
      dataIndex: "orderno",
      width: "7%",
      fixed: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "7%",
      fixed: "left",
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "10%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customername}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_name",
      width: "10%",
      render: (text, record) => record?.consignee_name || "-",
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={`The product specification is in the ${format}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    // {
    //   title: "Planned Reels",
    //   dataIndex: "plannedReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Matched Grain",
      dataIndex: "matchedGrain",
      width: "8%",
      render: (text, record) => `${!record.isReel ? text : "-"}`,
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    // {
    //   title: "Unfulfilled Reels",
    //   dataIndex: "unFulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Unfulfilled Quantity",
      dataIndex: "unFulflilledWeight",
      width: "10%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5%",
    // },
    {
      title: "Del Date",
      dataIndex: "deliverydate",
      width: "10%",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "8%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "7%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => showViewDrawer(record.orderno, record)}>
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ];
  const orderFulfillmentColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "8%",
      fixed: "left",
      align: "center",
      render: (text, record) => {
        const value =
          record.category === "po"
            ? toHandlePOName(record.pono)
            : record.category === "so"
              ? toHandlePOName(record.sono)
              : toHandlePOName(record.pono);

        return (
          <span
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.4",
            }}
          >
            {value?.match(/.{1,15}/g)?.map((chunk, index) => (
              <span key={index}>
                {chunk}
                <br />
              </span>
            ))}
          </span>
        );
      },
    },
    {
      title: "Order No/Stock No",
      dataIndex: "orderno",
      width: "10%",
      fixed: "left",
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={`The product specification is in the ${format}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    {
      title: "Fulfilled Quanitity",
      dataIndex: "fulflilledWeight",
      width: "10%",
    },
    {
      title: "Overfulfilment %",
      dataIndex: "overfulfillmentPercentage",
      width: "10%",
    },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: "22%",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{
            __html: String(text).replace(/\n/g, "<br />"),
          }}
        />
      ),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "10%",
      render: (text, record) =>
        record.type === "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={record.remarks}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button style={{ cursor: "default" }}>
                  <Iconmoon icon="message" size={16} color="#EA655B" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "10%",
      render: (text, record) =>
        record.type === "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => showViewDrawer(record.orderno, record)}>
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
  ];

  const filteredColumns1 = fullColumnsHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );
  const filteredColumns2 = fullUnfulfilledColumnsHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );

  const columnsHead = filteredColumns1;
  const unfulfilledColumnsHead = filteredColumns2;
  const handleDropdownClick = async (record, key) => {
    try {
      switch (key) {
        case "sendForReview": // sendForReview
          const response1 = await changeProductionJobCardState({
            id: jobId,
            state: "under_review",
          });
          // setUnderReviewJobCards([...underReviewJobcards, record]);
          // setGridView(true);
          setReFetch(true);
          showToaster();

          break;

        case "markCancelled": // markCancelled
          const response2 = await changeProductionJobCardState({
            id: jobId,
            state: "cancel",
          });
          // setCancelledJobCards([...cancelledJobcards, record]);
          // setGridView(true);
          setReFetch(true);
          showToaster();

          break;

        case "markCompleted": // markCompleted
          const response3 = await changeProductionJobCardState({
            id: jobId,
            state: "complete",
          });
          // setCompleteCards([...completeCards, record]);
          // setGridView(true);
          setReFetch(true);
          showToaster();
          break;

        case "replan":
          const response4 = await replanJobcard(
            {
              jobcard: jobId,
              // state: "complete",
            },
            "multistage"
          );
          // setIsReplanClicked(true);
          setIsReplanClicked(true);
          break;
        default:
          console.warn("Unknown dropdown key:", key);
      }
    } catch (error) {
      console.error("Error handling dropdown click:", error);
      setActionResponse({
        error: error.response.data.error,
        msg: error.response.data.msg,
      });
      showToaster();
    }
  };
  const fetchJobcardDetails = (jobcardIds, parentJobCardId = 0, uuid = "") => {
    let newsolcnt = false;
    getJobCardsDetailsMultistage({ jobcards: jobcardIds })
      .then((response) => {
        if (!createNewSolutionClicked) {
          const tempJobcardDetailsList = [...jobCardDetailsList];

          response?.forEach((job) => {
            if (
              !tempJobcardDetailsList.some(
                (existingJob) => existingJob.id === job.id
              )
            ) {
              tempJobcardDetailsList.push(job);
            }
          });
          setJobCardDetailsList(tempJobcardDetailsList);
          // setSyncFailedGroups(false);
          // setRerendering(!rerendering);
        } else {
          newsolcnt = true;
          let detailsList = jobCardDetailsList;
          let filteredJobCardIndex = detailsList.findIndex(function (
            jobCardDetails
          ) {
            return jobCardDetails.uuid == uuid;
          });
          if (filteredJobCardIndex != -1) {
            detailsList[filteredJobCardIndex] = {
              ...detailsList[filteredJobCardIndex],
              newlyCreatedJobCardsDetails: response,
            };
            //set isSuccessful true when new sol for failedJC is created
            if (detailsList[filteredJobCardIndex]?.isFailedJobcard) {
              detailsList[filteredJobCardIndex] = {
                ...detailsList[filteredJobCardIndex],
                isSuccessful: true,
              };
            }
          }
          setJobCardDetailsList(detailsList);
          setCreateNewSolutionClicked(false);
          // setRerendering(!rerendering);
          // setIsTabularView(false);
        }
        const rewinderMachine = response[0]?.jobcard?.group?.machines?.find(
          (machine) => machine.machine_type === "rewinder"
        );
        const cutterMachine = response[0]?.jobcard?.group?.machines?.find(
          (machine) => machine.machine_type === "cutter"
        );
        let stockMachineValue = { ...formValuesForStock?.[jobIndex] };
        if (rewinderMachine) {
          const {
            deckle_size_lb,
            deckle_size_ub,
            left_edge_trim,
            right_edge_trim,
            original_cutters,
            effective_deckle_length,
            units,
            machine_type,
            machine_code,
          } = rewinderMachine;

          const rightEdgeTrimConversionFactor =
            CoversionFactorUnitsToCM[units.right_edge_trim];
          const deckleSizeUbConversionFactor =
            CoversionFactorCMToUnits[units.deckle_size_ub];

          const minDeckleLength = deckle_size_lb;
          const maxDeckleLength =
            deckle_size_ub +
            (left_edge_trim + right_edge_trim) *
            rightEdgeTrimConversionFactor *
            deckleSizeUbConversionFactor;

          stockMachineValue = {
            ...stockMachineValue,
            min_deckle_length: minDeckleLength,
            max_deckle_length: maxDeckleLength,
            maximum_cutters: original_cutters,
            effective_deckle_length: effective_deckle_length,
            left_edge_trim: left_edge_trim,
            right_edge_trim: right_edge_trim,
            units: units,
          };
        }
        if (cutterMachine) {
          const {
            deckle_size_lb,
            deckle_size_ub,
            left_edge_trim,
            right_edge_trim,
            original_cutters,
            effective_deckle_length,
            max_chop_size,
            min_chop_size,
            maximum_reel_dia,
            minimum_reel_dia,
            allowed_trim,
            units,
            cutters,
          } = cutterMachine;

          const rightEdgeTrimConversionFactor =
            CoversionFactorUnitsToCM[units.right_edge_trim];
          const deckleSizeUbConversionFactor =
            CoversionFactorCMToUnits[units.deckle_size_ub];

          const minDeckleLength = deckle_size_lb;
          const maxDeckleLength =
            deckle_size_ub +
            (left_edge_trim + right_edge_trim) *
            rightEdgeTrimConversionFactor *
            deckleSizeUbConversionFactor;

          stockMachineValue = {
            ...stockMachineValue,
            min_deckle_length_cutter: minDeckleLength,
            max_deckle_length_cutter: maxDeckleLength,
            maximum_cutters_cutter: original_cutters,
            effective_deckle_length_cutter: effective_deckle_length,
            left_edge_trim_cutter: left_edge_trim,
            right_edge_trim_cutter: right_edge_trim,
            min_chop_cutter: min_chop_size,
            max_chop_cutter: max_chop_size,
            min_dia_cutter: minimum_reel_dia,
            max_dia_cutter: maximum_reel_dia,
            units_cutter: units,
            max_trim_intermediate_cutter: allowed_trim,
            cutters_cutter: cutters,
          };
        }
        setFormValuesForStock({
          ...formValuesForStock,
          [jobIndex ? jobIndex : 0]: stockMachineValue,
        });
        // const orderIds = [];
        // response.forEach((item) => {
        //   item.jobcard?.group?.orders?.map((order) => {
        //     orderIds.push(order.order_id);
        //   });
        // });
        // setOrderIdList(orderIds);
      })
      .catch((error) => {
        newsolcnt = true;
        let detailsList = jobCardDetailsList;
        let filteredJobCardIndex = detailsList.findIndex(function (
          jobCardDetails
        ) {
          return jobCardDetails.uuid == uuid;
        });

        if (filteredJobCardIndex != -1) {
          let jobcardData = [
            {
              created_at: detailsList[filteredJobCardIndex].created_at,
              uuid: detailsList[filteredJobCardIndex].uuid,
              id: detailsList[filteredJobCardIndex].id,
              user_id: detailsList[filteredJobCardIndex].user_id,
              updated_at: detailsList[filteredJobCardIndex].updated_at,
              jobcard: {
                group: detailsList[filteredJobCardIndex].jobcard.group,
                solution_1: {
                  data: {
                    exception:
                      "Job card could not be created for the input.Please check the input and try again",
                  },
                },
                solution_2: {
                  data: {
                    exception:
                      "Job card could not be created for the input.Please check the input and try again",
                  },
                },
              },
            },
          ];

          detailsList[filteredJobCardIndex] = {
            ...detailsList[filteredJobCardIndex],
            newlyCreatedJobCardsDetails: jobcardData,
          };
          !detailsList[filteredJobCardIndex]?.isFailedJobcard &&
            setJobCardDetailsList(detailsList);
          setCreateNewSolutionClicked(false);
          // setRerendering(!rerendering);
        }
      });
  };
  const getUpdatedOrders = async (group) => {
    try {
      const response = await getOrdersList(
        group?.orders?.map((order) => (order.item_type !== "stock" && order.item_type != "product_stock_size") && order.order_id)?.sort()
      );
      return response?.data?.filter((order) => order.cutter_reel_dia === true);
    } catch (error) {
      console.error("Error fetching orders list:", error);
      throw error;
    }
  };
  const createRequest = (
    ordersList,
    group,
    machine,
    isManualInput,
    min,
    max,
    unit
  ) => {
    return ordersList?.map((order) => {
      const isConstant = isManualInput
        ? min === max
        : machine.minimum_reel_dia === machine.maximum_reel_dia;
      const reelOdValue = isManualInput
        ? `${max} ${unit}`
        : `${machine.minimum_reel_dia} ${machine.units}`;
      const unitsValue = isManualInput ? unit : machine.units?.minimum_reel_dia;

      return {
        order_id: JSON.stringify(order.id),
        planned_weight: order?.planned_weight,
        reel_od: isConstant
          ? [reelOdValue]
          : {
            minimum_reel_od: isManualInput ? min : machine.minimum_reel_dia,
            maximum_reel_od: isManualInput ? max : machine.maximum_reel_dia,
          },
        group_id: group.group_id,
        od_type: isConstant ? "constant" : "range",
        cutter_reel_dia: true,
        units: isConstant
          ? {
            planned_weight: order?.units?.planned_weight,
          }
          : {
            planned_weight: order?.units?.planned_weight,
            minimum_reel_od: unitsValue,
            maximum_reel_od: unitsValue,
          },
      };
    });
  };

  const handleCutterReelDiaChange = async (e, cutterMachine) => {
    // if (showAimation[jobIndex]) return;

    const isManualInput = Boolean(e);
    const group =
      jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails?.[0]?.jobcard
        ?.group || jobCardDetailsList[jobIndex].jobcard?.group;
    if (!group) return;

    try {
      const ordersList = await getUpdatedOrders(group);
      if (!ordersList?.length) return;

      let request;
      if (!isManualInput) {
        const machine = group?.machines?.find(
          (machine) => machine.machine_type === "cutter"
        );
        if (!machine) return;

        request = createRequest(ordersList, group, machine, false);
      } else {
        const min = parseFloat(e.min_dia_cutter);
        const max = parseFloat(e.max_dia_cutter);
        const unit = e.reel_dia_unit_cutter;

        if (
          min === cutterMachine.minimum_reel_dia &&
          max === cutterMachine.maximum_reel_dia &&
          unit === cutterMachine.units
        )
          return;

        request = createRequest(
          ordersList,
          group,
          cutterMachine,
          true,
          min,
          max,
          unit
        );
      }

      if (!request?.length) return;

      const response = await editQtyToBePlannedForReviewOrder(
        request,
        "new_solution"
      );
    } catch (error) {
      console.log("Error in updating order:", error?.response?.data);
    }
  };
  const onClickCreateSolution = async (e, jobCardId, uuid, jobIndex) => {
    // setActiveTab('1');
    // setCurrentSummaryTab('1');
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    // setShowAimation((prev) => {
    //   return { ...prev, [jobIndex]: true };
    // });
    let sizes = [];
    setCreateNewSolutionFormValuesForSizes(e);
    if (e.selectedSizes.length > 0) {
      e.selectedSizes.forEach((size) => {
        let sizeObject = {
          id: size.stockSizeId,
          //size: size.stockSize,
          allowed_quantity: parseFloat(size.allowedQuantity),
          reels: size.reels,
          planned_weight: parseFloat(size.plannedWeight),
          type: size.type,
          sheets: size.sheets,

          ...((size.type === "sheet") && {
            lateral_size: size.length,
            grain: size.grain,
          }),
          ...((size.type === "reel") && {
            grain: null,
          }),
          size: size.width,
          mixed_grain: false,
          ...(size.creation_type === "required" && {
            weight_lb: parseFloat(size.weight_lb),
            weight_ub: parseFloat(size.weight_ub),

            priority_stock: size.priority_stock,
          }),
          units: {
            ...size.units,

            lateral_size: size.units.length,
            size: size.units.width,
          },
          creation_type: size.creation_type,
        };
        sizes.push(sizeObject);
      });
    }
    let updatedFormValues = { ...formValuesForStock?.[jobIndex] };
    updatedFormValues["max_deckle_length"] = e.maxDeckleLength
      ? parseFloat(e.maxDeckleLength)
      : updatedFormValues?.max_deckle_length;
    updatedFormValues["min_deckle_length"] = e.minDeckleLength
      ? parseFloat(e.minDeckleLength)
      : updatedFormValues?.min_deckle_length;
    updatedFormValues["left_edge_trim"] = e.minWidth
      ? parseFloat(e.minWidth)
      : updatedFormValues?.left_edge_trim;
    updatedFormValues["right_edge_trim"] = e.maxWidth
      ? parseFloat(e.maxWidth)
      : updatedFormValues?.right_edge_trim;
    updatedFormValues["maximum_cutters"] = e.cutters
      ? parseFloat(e.cutters)
      : updatedFormValues?.cutters;
    updatedFormValues["effective_deckle_length"] = e.cutters
      ? parseFloat(e.effectiveDeckleLength)
      : "";
    updatedFormValues["units"] = {
      max_deckle_length: e.deckleLengthUnit,
      min_deckle_length: e.deckleLengthUnit,
      left_edge_trim: e.widthUnit,
      right_edge_trim: e.widthUnit,
      effective_deckle_length: e.deckleLengthUnit,
      deckle_size_ub: e.deckleLengthUnit,
      deckle_size_lb: e.deckleLengthUnit,
    };
    updatedFormValues["max_deckle_length_cutter"] = e.maxDeckleLengthCutter
      ? parseFloat(e.maxDeckleLengthCutter)
      : updatedFormValues?.max_deckle_length;
    updatedFormValues["min_deckle_length_cutter"] = e.minDeckleLengthCutter
      ? parseFloat(e.minDeckleLengthCutter)
      : updatedFormValues?.min_deckle_length;
    updatedFormValues["left_edge_trim_cutter"] = e.minWidthCutter
      ? parseFloat(e.minWidthCutter)
      : updatedFormValues?.left_edge_trim;
    updatedFormValues["right_edge_trim_cutter"] = e.maxWidthCutter
      ? parseFloat(e.maxWidthCutter)
      : updatedFormValues?.right_edge_trim;
    updatedFormValues["maximum_cutters_cutter"] = e.cuttersCutter
      ? parseFloat(e.cuttersCutter)
      : updatedFormValues?.cuttersCutter;
    updatedFormValues["effective_deckle_length_cutter"] =
      e.effectiveDeckleLengthCutter
        ? parseFloat(e.effectiveDeckleLengthCutter)
        : "";
    updatedFormValues["min_dia_cutter"] = parseFloat(e.min_dia_cutter);
    updatedFormValues["max_dia_cutter"] = parseFloat(e.max_dia_cutter);
    updatedFormValues["min_chop_cutter"] = parseFloat(e.min_chop_cutter);
    updatedFormValues["max_chop_cutter"] = parseFloat(e.max_chop_cutter);
    updatedFormValues["max_trim_intermediate_cutter"] = parseFloat(
      e.max_trim_intermediate_cutter
    );
    updatedFormValues["units_cutter"] = {
      ...e.units_cutter,
      max_deckle_length: e.deckleLengthUnitCutter,
      min_deckle_length: e.deckleLengthUnitCutter,
      left_edge_trim: e.widthUnitCutter,
      right_edge_trim: e.widthUnitCutter,
      effective_deckle_length: e.deckleLengthUnitCutter,
      minimum_reel_dia: e.reel_dia_unit_cutter,
      maximum_reel_dia: e.reel_dia_unit_cutter,
      max_chop_size: e.chopUnit,
      min_chop_cutter: e.chopUnit,
      deckle_size_ub: e.deckleLengthUnitCutter,
      deckle_size_lb: e.deckleLengthUnitCutter,
      allowed_trim: e.max_trim_intermediate_unit_cutter,
    };

    setFormValuesForStock({
      ...formValuesForStock,
      [jobIndex]: updatedFormValues,
    });
    const rewinderMachine = jobCardDetailsList[
      jobIndex
    ].jobcard?.group?.machines?.find(
      (machine) => machine.machine_type === "rewinder"
    );
    const cutterMachine = jobCardDetailsList[
      jobIndex
    ].jobcard?.group?.machines?.find(
      (machine) => machine.machine_type === "cutter"
    );

    const config = jobCardDetailsList?.[jobIndex]?.jobcard?.group?.config || [];
    let matchedConfig;
    if (jobCardDetailsList?.[jobIndex]?.isFailedJobcard) {
      const solutionNumber = Number(acceptedSolution.key);
      const configIndex = Math.floor((solutionNumber - 1) / 2);
      matchedConfig = config?.[configIndex];
    } else {
      matchedConfig = config.find(
        (item) =>
          item?.set_name === acceptedSolution?.solution?.set_name
      );
    }

    let request = {
      [`${jobCardDetailsList[jobIndex]?.isFailedJobcard
        ? "failed_group"
        : "jobcard"
        }`]: jobCardDetailsList[jobIndex]?.isFailedJobcard
          ? jobCardDetailsList[jobIndex]?.failedGroupId
          : jobCardId,
      run_type: "selected_sizes",
      machine_selection_data: [
        {
          ...rewinderMachine,
          maximum_deckle_size: e.maxDeckleLength
            ? parseFloat(e.maxDeckleLength)
            : updatedFormValues?.max_deckle_length,
          minimum_deckle_size: e.minDeckleLength
            ? parseFloat(e.minDeckleLength)
            : updatedFormValues?.min_deckle_length,
          left_edge_trim: e.minWidth
            ? parseFloat(e.minWidth)
            : updatedFormValues?.left_edge_trim,
          right_edge_trim: e.maxWidth
            ? parseFloat(e.maxWidth)
            : updatedFormValues?.right_edge_trim,
          maximum_cutters: e.cutters
            ? parseFloat(e.cutters)
            : updatedFormValues?.maximum_cutters,
          effective_deckle_length: e.effectiveDeckleLength
            ? parseFloat(e.effectiveDeckleLength)
            : "",
          units: {
            maximum_deckle_size: e.deckleLengthUnit,
            minimum_deckle_size: e.deckleLengthUnit,
            left_edge_trim: e.widthUnit,
            right_edge_trim: e.widthUnit,
            effective_deckle_length: e.deckleLengthUnit,
          },
        },
        {
          ...cutterMachine,
          maximum_deckle_size:
            e.maxDeckleLengthCutter >= 0
              ? parseFloat(e.maxDeckleLengthCutter)
              : updatedFormValues?.max_deckle_length_cutter,
          minimum_deckle_size:
            e.minDeckleLengthCutter >= 0
              ? parseFloat(e.minDeckleLengthCutter)
              : updatedFormValues?.min_deckle_length_cutter,
          left_edge_trim:
            e.minWidthCutter >= 0
              ? parseFloat(e.minWidthCutter)
              : updatedFormValues?.left_edge_trim_cutter,
          right_edge_trim:
            e.maxWidthCutter >= 0
              ? parseFloat(e.maxWidthCutter)
              : updatedFormValues?.right_edge_trim_cutter,
          maximum_cutters:
            e.cuttersCutter >= 0
              ? parseFloat(e.cuttersCutter)
              : updatedFormValues?.maximum_cutters_cutter,
          effective_deckle_length: e.effectiveDeckleLengthCutter
            ? parseFloat(e.effectiveDeckleLengthCutter)
            : "",
          minimum_reel_dia: parseFloat(e.min_dia_cutter),
          maximum_reel_dia: parseFloat(e.max_dia_cutter),
          max_chop_size: parseFloat(e.max_chop_cutter),
          min_chop_size: parseFloat(e.min_chop_cutter),
          allowed_trim: parseFloat(e.max_trim_intermediate_cutter),
          units: {
            maximum_deckle_size: e.deckleLengthUnitCutter,
            minimum_deckle_size: e.deckleLengthUnitCutter,
            left_edge_trim: e.widthUnit_cutter,
            right_edge_trim: e.widthUnit_cutter,
            effective_deckle_length: e.deckleLengthUnitCutter,
            minimum_reel_dia: e.reel_dia_unit_cutter,
            maximum_reel_dia: e.reel_dia_unit_cutter,
            max_chop_size: e.chopUnit,
            min_chop_size: e.chopUnit,
            allowed_trim: e.max_trim_intermediate_unit_cutter,
          },
        },
      ],
      sizes: sizes,
      optimize_unique_partitions: optimizePartition,
      minimize_overfulfillment: minimizeOverfulfillment,
      config: [matchedConfig]
    };
    await handleCutterReelDiaChange(e, cutterMachine);
    try {
      setCreateNewSolutionClicked(true);
      let jobCard = await createNewSolutionMultistage(request);

      let newJobCardId = null;
      let isDone = false;

      while (!isDone) {
        let readyRes = await readyJobCardMultistageNewSolution();

        if (readyRes?.jobcard_output_mapping && readyRes.jobcard_output_mapping[jobCardId]) {
          const rawValue = readyRes.jobcard_output_mapping[jobCardId];
          const rawEntries = Array.isArray(rawValue) ? rawValue : [rawValue];
          const lastEntry = rawEntries[rawEntries.length - 1];

          if (lastEntry && typeof lastEntry === "object") {
            newJobCardId = lastEntry?.new_jobcard !== undefined ? lastEntry?.new_jobcard : lastEntry?.jobcard;
          } else {
            newJobCardId = parseInt(lastEntry, 10);
          }

          if (newJobCardId) {
            isDone = true;
            break;
          }
        }

        let completionRes = await getAlgorithmCompletionStatusMultiStage();
        if (completionRes?.data?.failed_groups?.includes(Number(jobCardId))) {
          throw new Error("Job card creation failed");
        }

        await new Promise((resolve) => setTimeout(resolve, 5000));
      }

      //  if(showAimation[jobIndex]) setCurrentSolution("3");
      // fetchJobcardDetails([newJobCardId], jobCardId, uuid);
      const data = {
        done: true,
        failed_groups: [],
        jobcards: [newJobCardId],
        total_groups: 1,
      };
      navigate("../deckle-match-result-multistage-multi-solutions", {
        state: {
          jobCards: data,
          parentJCid: jobCardId,
          type: "replan",
          jobcardType: jobcardType,
          isDummyJC: jobCardDetailsList[jobIndex].is_dummy,
        },
      });

      // setFailedNewSol((prev) => {
      //   return { ...prev, [jobIndex]: false };
      // });
    } catch (error) {
      let jobcardResp = [];
      let response = [];

      // console.log(error?.response?.data?.data?.group_id, error?.response?.data?.data, response);
      if (error?.response?.data?.data?.group_id) {
        response.push(error?.response?.data?.data);
      } else {
        let jobCard = await getAlgorithmCompletionStatusMultiStage();
        response = await getFailedGroups({
          failed_groups: jobCard.data.failed_groups,
        });
      }

      // setFailedNewSol((prev) => {
      //   return { ...prev, [jobIndex]: true };
      // });

      let detailsList = jobCardDetailsList;
      let filteredJobCardIndex = detailsList.findIndex(function (
        jobCardDetails
      ) {
        return jobCardDetails.uuid == uuid;
      });

      let data = {
        orders: [],
        partitions: [],
        sizes: [],
        summary: {},
      };

      let jobcardData = {};

      if (!response.length) {
        jobcardData = {
          created_at: detailsList[filteredJobCardIndex].created_at,
          uuid: detailsList[filteredJobCardIndex].uuid,
          id: detailsList[filteredJobCardIndex].id,
          user_id: detailsList[filteredJobCardIndex].user_id,
          updated_at: detailsList[filteredJobCardIndex].updated_at,
          jobcard: {
            group: detailsList[filteredJobCardIndex].jobcard.group,
            solution_1: {
              data: {
                exception:
                  "Job card could not be created for the input.Please check the input and try again",
              },
            },
            solution_2: {
              data: {
                exception:
                  "Job card could not be created for the input.Please check the input and try again",
              },
            },
          },
        };
      } else {
        jobcardData = {
          created_at: response[0].created_at,
          uuid: response[0].uuid,
          id: response[0].id,
          user_id: response[0].user_id,
          updated_at: response[0].updated_at,
          jobcard: {
            group: error?.response?.data?.data?.group_id
              ? response[0]
              : response[0].group,
            solution_1: { data },
            solution_2: { data },
          },
        };
      }
      jobcardResp.push(jobcardData);
      //set isSucessful to false if the new solution for failedJC is failed
      detailsList[filteredJobCardIndex] = {
        ...detailsList[filteredJobCardIndex],
        isSuccessful: false,
        newlyCreatedJobCardsDetails: jobcardResp,
      };
      setJobCardDetailsList(detailsList);
      // if(showAimation[jobIndex])
      //   setCurrentSolution("3");
      // setSolutionId("3");
      // fetchOrders("current_solution", jobcardData.jobcard);
    } finally {
      setCreateNewSolutionClicked(false);
      // setTimeout(()=>{setShowAimation((prev) => {
      //   return { ...prev, [jobIndex]: false };
      // });},4000)
    }
  };
  const handleOptimizePartitionChange = (isChecked) => {
    setOptimizePartition(isChecked);
  };
  const handleMinimizeOverfulfillmentChange = (isChecked) => {
    setMinimizeOverfulfillment(isChecked);
  };
  useEffect(() => {
    fetchJobcardDetails([jobId]);
    // setJobCardDetailsList(jobcardIds);
  }, [jobId]);
  return jobCard && acceptedSolution.solution ? (
    <RightLayoutContainer>
      {/* {console.log("Jobcard", jobCard)} */}
      {isReplanClicked ? (
        createNewSolutionClicked ? (
          <ContentMiddle>
            <div className="imageAnimate">
              <div className="imageCover">
                <LottieAnimation lotti={JobcardPrepare} />
                <p>
                  Our algorithms are cooking a job card for you <br />
                  please wait, it will take less than a minute
                </p>
              </div>
            </div>
          </ContentMiddle>
        ) : (
          <CreateNewSolutionMultistage
            jobId={jobCardDetailsList[0].id}
            onClickCreateSolution={(e) =>
              onClickCreateSolution(
                e,
                jobCardDetailsList[0].id,
                jobCardDetailsList[0].uuid,
                0
              )
            }
            formValuesForStock={formValuesForStock?.[jobIndex]}
            jobCardDetails={jobCardDetailsList[0]?.jobcard}
            backButtonClicked={() => {
              setCreateNewSolutionClicked(false);
              handleCutterReelDiaChange();
              setIsReplanClicked(false);
              cancelJobCard();
            }}
            stockSizesArray={stockSizes}
            setStockSizesArray={setStockSizes}
            createNewSolutionFormValuesForSizes={
              createNewSolutionFormValuesForSizes
            }
            unselectedOrders={
              jobCardDetailsList[0]?.newlyCreatedJobCardsDetails
                ? jobCardDetailsList[0]?.newlyCreatedJobCardsDetails[0]?.jobcard
                  ?.group?.unselected_orders
                : jobCardDetailsList[0]?.jobcard?.group?.unselected_orders
            }
            ordersIdList={ordersIdList}
            optimizePartition={optimizePartition}
            minimizeOverfulfillment={minimizeOverfulfillment}
            onOptimizePartitionChange={handleOptimizePartitionChange}
            onMinimizeOverfulfillmentChange={
              handleMinimizeOverfulfillmentChange
            }
            machineData={location?.state?.body}
            solutionId={solutionId}
            completeJCDetails={jobCardDetailsList[jobIndex]}
            replan={true}
            dynamicStock={dynamicStock}
            solutionType={'replan'}
          />
        )
      ) : (
        <>
          <PageTitleComp
            className="marginRightAdg"
            style={{ borderBottom: "0px" }}
          >
            <PageHeader
              ghost={false}
              onBack={() => navigate("../job-cards")}
              // onBack={() => navigate(-2)}
              title="Job Card Details"
              extra={
                jobCard.state == "pending"
                  ? [
                    <Button
                      key="1"
                      className="themeBtn noBg"
                      onClick={showRejectDrawer}
                      disabled={!userDetails.roles.approve_jobcards.edit}
                      loading={isRejectLoading}
                    >
                      {!isRejectLoading && (
                        <Iconmoon
                          icon="wrong-file"
                          size={14}
                          color="#EA4E2C"
                        />
                      )}
                      Reject Job Card
                    </Button>,
                    <Button
                      key="1"
                      className="themeBtn"
                      onClick={approveModalShow}
                      disabled={!userDetails.roles.approve_jobcards.edit}
                      loading={isApproveLoading}
                    >
                      {!isApproveLoading && (
                        <Iconmoon
                          icon="correct-file"
                          size={14}
                          color="#fff"
                        />
                      )}
                      Approve Job Card
                    </Button>,
                  ]
                  : jobCard.state == "approved"
                    ? [
                      // <Button
                      //   key="1"
                      //   className="themeBtn"
                      //   onClick={showStartProductionModal}
                      // >
                      //   <Iconmoon icon="correct-file" size={14} color="#fff" />
                      //   Start Production
                      // </Button>,
                    ]
                    : jobCard.state === "in_production"
                      ? [
                        // <Button
                        //   key="1"
                        //   className="themeBtn noBg"
                        //   onClick={showCancelProductionModal}
                        // >
                        //   <Iconmoon icon="wrong-file" size={14} color="#EA4E2C" />
                        //   Cancel Production
                        // </Button>,
                        // <Button
                        //   key="1"
                        //   className="themeBtn"
                        //   onClick={showMarkCompletedModal}
                        // >
                        //   <Iconmoon icon="correct-file" size={14} color="#fff" />
                        //   Mark as Completed
                        // </Button>,
                      ]
                      : jobCard.state === "active"
                        ? [
                          <Button
                            key="1"
                            className="themeBtn noBg"
                            onClick={() =>
                              handleDropdownClick(jobcardCode, "sendForReview")
                            }
                            disabled={!userDetails.roles.approve_jobcards.edit}
                          >
                            <Iconmoon icon="file-view" size={16} color="#EA4E2C" />
                            Send for Review
                          </Button>,

                          <Button
                            key="1"
                            className="themeBtn noBg"
                            onClick={() =>
                              handleDropdownClick(jobcardCode, "markCancelled")
                            }
                            disabled={!userDetails.roles.approve_jobcards.edit}
                          >
                            <Iconmoon icon="wrong-file" size={14} color="#EA4E2C" />
                            Mark Cancelled
                          </Button>,
                          <Button
                            key="1"
                            className="themeBtn"
                            onClick={() =>
                              handleDropdownClick(jobcardCode, "markCompleted")
                            }
                            disabled={!userDetails.roles.approve_jobcards.edit}
                          >
                            <Iconmoon icon="correct-file" size={14} color="#fff" />
                            Mark Complete
                          </Button>,
                        ]
                        : jobCard.state === "cancel"
                          ? []
                          : jobCard.state === "under_review"
                            ? [
                              <Button
                                key="1"
                                className="themeBtn noBg"
                                onClick={() =>
                                  handleDropdownClick(jobcardCode, "markCompleted")
                                }
                                disabled={!userDetails.roles.approve_jobcards.edit}
                              >
                                <Iconmoon
                                  icon="correct-file"
                                  size={14}
                                  color="#EA4E2C"
                                />
                                Mark Complete
                              </Button>,
                              <Button
                                key="1"
                                className="themeBtn noBg"
                                onClick={() =>
                                  handleDropdownClick(jobcardCode, "markCancelled")
                                }
                                disabled={!userDetails.roles.approve_jobcards.edit}
                              >
                                <Iconmoon icon="wrong-file" size={14} color="#EA4E2C" />
                                Mark Cancelled
                              </Button>,
                              <Button
                                key="1"
                                className="themeBtn"
                                onClick={() =>
                                  handleDropdownClick(jobcardCode, "replan")
                                }
                                disabled={!userDetails.roles.approve_jobcards.edit}
                              >
                                <Iconmoon icon="replan" size={16} color="#ffffff" />
                                Re-Plan
                              </Button>,
                            ]
                            : null
              }
            ></PageHeader>
          </PageTitleComp>
          <ResultWrap>
            <DetailFields
              className="jobCardView"
              style={{ justifyContent: "flex-start" }}
            >
              <SolutionContainer>
                <PageTitleComp style={{ borderBottom: "0" }}>
                  <PageHeader
                    ghost={false}
                    // title={`${jobcardCode}`}
                    title={
                      jobcardCode?.length > 15 ? (
                        <Tooltip placement="bottomLeft" title={jobcardCode}>
                          <h5>{jobcardCode?.slice(0, 16) + "..."}</h5>
                        </Tooltip>
                      ) : (
                        <h5>{jobcardCode}</h5>
                      )
                    }
                    className="jobCardList-Grid"
                  ></PageHeader>

                  <div
                    className={`jobCardList ${"fullWidth"}`}
                    style={{
                      alignSelf: "center",
                      display: "flex",
                      marginTop:
                        isParentReelCancelled &&
                          activeTab != 6 &&
                          activeTab != 7 &&
                          activeTab != 1
                          ? "20px"
                          : "34px",
                      // activeTab >= 2 ? "20px" : "34px",
                      // alignContent:'top'
                    }}
                  >
                    <JobCardColorStatus>
                      <div
                        className="statusVal"
                        dataval={jobCard.state}
                        style={{
                          marginTop:
                            activeTab == 3 ||
                              activeTab == 4 ||
                              activeTab == 5 ||
                              activeTab == 6 ||
                              activeTab == 7
                              ? "0px"
                              : "0px",
                        }}
                      >
                        {jobcardState(jobCard.state)}
                      </div>
                    </JobCardColorStatus>
                    {activeTab == 6 && (
                      <JobCardColorStatus>
                        <div
                          className="statusVal"
                          style={{ marginTop: "0px" }}
                          dataval={jobCard.state}
                        >
                          {
                            acceptedSolution?.solution?.data?.rewinder_details
                              ?.code
                          }
                          {" - "}
                          {jobcardState(
                            acceptedSolution?.solution?.data?.rewinding_status
                          )}
                        </div>
                      </JobCardColorStatus>
                    )}
                    {activeTab == 7 && (
                      <JobCardColorStatus>
                        <div
                          className="statusVal"
                          style={{ marginTop: "0px" }}
                          dataval={jobCard.state}
                        >
                          {
                            acceptedSolution?.solution?.data?.cutter_details
                              ?.code
                          }
                          {" - "}
                          {jobcardState(
                            acceptedSolution?.solution?.data?.cutting_status
                          )}
                        </div>
                      </JobCardColorStatus>
                    )}

                    <div
                      className="statusVal"
                      dataval={jobCard.state}
                      style={{
                        marginLeft:
                          jobCard.state == "pending"
                            ? "12px"
                            : jobCard.state == "rejected"
                              ? "10px"
                              : jobCard.state == "approved"
                                ? "10px"
                                : jobCard.state == "in_production"
                                  ? "10px"
                                  : jobCard.state == "complete"
                                    ? "10px"
                                    : jobCard.state == "active"
                                      ? "10px"
                                      : jobCard.state == "under_review"
                                        ? "10px"
                                        : jobCard.state == "cancel"
                                          ? "10px"
                                          : "",
                        marginTop:
                          jobCard.state == "pending" ||
                            jobCard.state == "active"
                            ? "5px"
                            : jobCard.state == "rejected" ||
                              jobCard.state == "approved" ||
                              jobCard.state == "in_production" ||
                              jobCard.state == "complete" ||
                              jobCard.state == "under_review" ||
                              jobCard.state == "cancel"
                              ? "4px"
                              : "",
                      }}
                    >
                      {/* Ply: {jobCard.ply} */}
                    </div>

                    {orderDetailsList && (
                      <TableList
                        style={{
                          justifyContent: "flex-end",
                          display: "flex",
                        }}
                      >
                        {/*
                  <div className="List-grid-View" onClick={printJobCardDetails}>
                    <div className="printIcon">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.8334 6.66667H4.16669C2.78335 6.66667 1.66669 7.78334 1.66669 9.16667V14.1667H5.00002V17.5H15V14.1667H18.3334V9.16667C18.3334 7.78334 17.2167 6.66667 15.8334 6.66667ZM13.3334 15.8333H6.66669V11.6667H13.3334V15.8333ZM15.8334 10C15.375 10 15 9.62501 15 9.16667C15 8.70834 15.375 8.33334 15.8334 8.33334C16.2917 8.33334 16.6667 8.70834 16.6667 9.16667C16.6667 9.62501 16.2917 10 15.8334 10ZM15 2.50001H5.00002V5.83334H15V2.50001Z"
                          fill="#605E5C"
                        />
                      </svg>
                    </div>
                  </div>
                  */}
                      </TableList>
                    )}
                  </div>
                  {isParentReelCancelled &&
                    activeTab != 6 &&
                    activeTab != 7 &&
                    activeTab != 1 && (
                      <Col span={9} style={{ display: "absolute" }}>
                        <div
                          className="cancelledSetMessage"
                          style={{
                            display: "flex",
                            justifyContent: "center", // Center content horizontally
                            alignItems: "center", // Center content vertically
                            marginTop: "25px",
                            borderRadius: "4px",
                            backgroundColor: "#f4f0ec",
                            padding: "4px 6px",
                            opacity: 0.95,
                          }}
                        >
                          <div
                            className="centerAlignMeVertically"
                            style={{ padding: "2px 6px 0px 3px" }}
                          >
                            <Iconmoon
                              icon="warning_new"
                              size={20}
                              style={{ color: "#808080" }}
                            />
                          </div>
                          <span style={{ fontSize: "14px", color: "#555555" }}>
                            A few sets were cancelled in this job card. Hence,
                            fulfilled quantity might not be accurate for the
                            cancelled sets.
                          </span>
                        </div>
                      </Col>
                    )}
                </PageTitleComp>
                <div className="MatchResult JobResulted">
                  <Row span={24}>
                    {((activeTab != 6 &&
                      activeTab != 7 &&
                      ((!sizeExpanded && activeTab == "2") ||
                        (!sizeExpanded && activeTab == "3") ||
                        (!sizeExpanded && activeTab == "4") ||
                        (!sizeExpanded && activeTab == "5"))) ||
                      activeTab == "1") && (
                        <Col
                          span={15}
                          className="pipeBlock"
                          style={{
                            paddingRight: "20px",
                            transform:
                              isParentReelCancelled &&
                                activeTab != 6 &&
                                activeTab != 7 &&
                                activeTab != 1
                                ? "translateY(-14px)"
                                : "",
                            // transform: isParentReelCancelled && activeTab >= 2
                            //   ? "translateY(-14px)"
                            //   : "",
                          }}
                        >
                          <>
                            <TableList>
                              <div
                                className="radioSwitchStyle"
                                style={{ zIndex: 10 }}
                              >
                                <div className="table-view">
                                  <HaberForm>
                                    <RadioButtonStyle>
                                      <div
                                        className="boxFormType switchRadio"
                                        style={{
                                          justifyContent: "flex-end",
                                          display: "flex",
                                          // paddingRight: "",
                                          transform: "translate(-289px,0px)",
                                          position: "absolute",
                                          width: "276px",
                                        }}
                                      >
                                        {orderDetailsList && <div
                                          className="List-grid-View"
                                          onClick={printJobCardDetails}
                                        >
                                          <div className="printIcon">
                                            <svg
                                              width="20"
                                              height="20"
                                              viewBox="0 0 20 20"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M15.8334 6.66667H4.16669C2.78335 6.66667 1.66669 7.78334 1.66669 9.16667V14.1667H5.00002V17.5H15V14.1667H18.3334V9.16667C18.3334 7.78334 17.2167 6.66667 15.8334 6.66667ZM13.3334 15.8333H6.66669V11.6667H13.3334V15.8333ZM15.8334 10C15.375 10 15 9.62501 15 9.16667C15 8.70834 15.375 8.33334 15.8334 8.33334C16.2917 8.33334 16.6667 8.70834 16.6667 9.16667C16.6667 9.62501 16.2917 10 15.8334 10ZM15 2.50001H5.00002V5.83334H15V2.50001Z"
                                                fill="#605E5C"
                                              />
                                            </svg>
                                          </div>
                                        </div>}
                                        <Radio.Group
                                          options={filterViewData}
                                          onChange={handleViewChange}
                                          value={
                                            isJobcardView && isSheetView
                                              ? "both"
                                              : isJobcardView
                                                ? "reel"
                                                : "sheet"
                                          }
                                          optionType="button"
                                          buttonStyle="solid"
                                          className={
                                            isSheetView && isJobcardView
                                              ? "allActive"
                                              : isSheetView
                                                ? "sheetActive"
                                                : "jcActive"
                                          }
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                          }}
                                        />
                                      </div>
                                    </RadioButtonStyle>
                                  </HaberForm>
                                </div>
                                <div className="table-view">
                                  <HaberForm>
                                    <RadioButtonStyle>
                                      <div
                                        className="boxFormType switchRadio"
                                        style={{
                                          justifyContent: "flex-end",
                                          display: "flex",
                                          columnGap: "10px",
                                        }}
                                      >
                                        <Radio.Group
                                          options={cylinderMode}
                                          onChange={handleCylinderViewChange}
                                          value={cylinderViewData}
                                          optionType="button"
                                          buttonStyle="solid"
                                          className={
                                            cylinderViewData === "production"
                                              ? "ListViewActive"
                                              : "gridViewActive"
                                          }
                                        />
                                        <Radio.Group
                                          options={gridViewData}
                                          onChange={handleViewChangeGrid}
                                          value={isTabularView}
                                          optionType="button"
                                          buttonStyle="solid"
                                          className={
                                            !isTabularView
                                              ? "gridViewActive"
                                              : "ListViewActive"
                                          }
                                        />
                                      </div>
                                    </RadioButtonStyle>
                                  </HaberForm>
                                </div>
                              </div>
                            </TableList>

                            <div
                              style={{
                                display: isJobcardView ? "block" : "none",
                                padding: "0px",
                                margin: "0px",
                                transform: "translateY(-20px)",
                              }}
                            >
                              <JobCardCylinderContainerMultistage
                                jobId={jobId}
                                solution={acceptedSolution.key}
                                multiView={false}
                                print_function={
                                  orderDetailsList ? printJobCardDetails : null
                                }
                                collapse={props.collapse}
                                isPrintDisabled={isPrintDisabled}
                                toggleFetchingData={toggleFetchingData}
                                // style={{width:'80%'}}
                                deckleSize={calculateDeckleSize(jobCard, true)}
                                rewinderName={`${jobCard?.jobcard?.group.machines?.find(
                                  (item) => item.machine_type !== "cutter"
                                )?.rewinder_name
                                  }`}
                                solId={acceptedSolution.key}
                                isTabularView={isTabularView}
                                cylinderViewData={cylinderViewData}
                              />
                            </div>

                            {isSheetView && (
                              <SheetJobCardCylinderContainerMultistage
                                jobId={jobId}
                                solution={acceptedSolution.key}
                                multiView={false}
                                acceptedSolution={acceptedSolution?.solution}
                                jobCard={jobCard.jobcard}
                                print_function={
                                  orderDetailsList ? printJobCardDetails : null
                                }
                                unitData={unitData}
                                isTabularView={isTabularView}
                                cylinderViewData={cylinderViewData}
                              />
                            )}
                          </>
                        </Col>
                      )}
                    <Col
                      span={
                        activeTab == 6 || activeTab == 7
                          ? 24
                          : ((sizeExpanded && activeTab == "2") ||
                            (sizeExpanded && activeTab == "3") ||
                            (sizeExpanded && activeTab == "4") ||
                            (sizeExpanded && activeTab == "5")) &&
                            activeTab != "1"
                            ? 24
                            : 9
                      }
                      className="colLayoutBlock leftPostTab"
                    >
                      <Tabs
                        defaultActiveKey="1"
                        activeKey={activeTab}
                        onChange={tabChange}
                        className="topPostTab innerPostTab"
                      >
                        <Panes tab="Summary" key="1">
                          <div className="lossValue">
                            <Row span={24} style={{ paddingTop: "10px" }}>
                              <Col span={12}>
                                <div
                                  className={
                                    isParentReelCancelled
                                      ? "summaryValueCancelled"
                                      : "summaryValue"
                                  }
                                >
                                  <h5>
                                    <span className="trimCut"></span> Trim Loss
                                  </h5>
                                  <span>
                                    {acceptedSolution?.solution
                                      ? acceptedSolution.solution.data.summary.match_trim_loss_percentage.toFixed(
                                        3
                                      )
                                      : ""}{" "}
                                    %
                                  </span>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div
                                  className={
                                    isParentReelCancelled
                                      ? "summaryValueCancelled"
                                      : "summaryValue"
                                  }
                                >
                                  <h5>
                                    <span className="trimBox"></span> Fulfilment
                                  </h5>
                                  <span>
                                    {acceptedSolution &&
                                      acceptedSolution.solution
                                      ? acceptedSolution.solution?.data.summary?.weight_requirement_fulfilled_percentage.toFixed(
                                        3
                                      )
                                      : ""}{" "}
                                    %
                                  </span>
                                </div>
                              </Col>
                            </Row>
                            <Row span={24}>
                              <Col span={12}>
                                <div
                                  className={
                                    isParentReelCancelled
                                      ? "summaryValueCancelled"
                                      : "summaryValue"
                                  }
                                >
                                  <h5>
                                    <span className="trimCut"></span> Net Trim
                                    Loss:{" "}
                                    {acceptedSolution.solution?.data.summary?.net_trim_loss_percentage.toFixed(
                                      3
                                    )}{" "}
                                    %<p>Loss including edge trim</p>
                                  </h5>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div
                                  className={
                                    isParentReelCancelled
                                      ? "summaryValueCancelled"
                                      : "summaryValue"
                                  }
                                >
                                  <h5>
                                    <span className="trimBox"></span> Weight:{" "}
                                    {acceptedSolution.solution?.data.summary?.job_card_weight.toFixed(
                                      3
                                    )}{" "}
                                    {acceptedSolution.solution?.data.summary
                                      .units &&
                                      acceptedSolution.solution?.data.summary
                                        .units.job_card_weight
                                      ? capitalize(
                                        weightUnit[
                                          acceptedSolution.solution?.data
                                            .summary.units.job_card_weight
                                        ]?.displayName
                                      )
                                      : "T"}
                                    <p className="lesserSolution">
                                      Total weight of Job Card
                                    </p>
                                  </h5>
                                </div>
                              </Col>
                            </Row>

                            {isParentReelCancelled && (
                              <>
                                <Row span={24} style={{ paddingTop: "10px" }}>
                                  <Col span={12}>
                                    <div className={"summaryValue"}>
                                      <h5>
                                        <span className="trimCut"></span>Updated
                                        Trim Loss
                                      </h5>
                                      <span>
                                        {acceptedSolution?.solution
                                          ? acceptedSolution.solution.data.summary.new_match_trim_loss_percentage.toFixed(
                                            3
                                          )
                                          : ""}{" "}
                                        %
                                      </span>
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <div className={"summaryValue"}>
                                      <h5>
                                        <span className="trimBox"></span>Updated
                                        Fulfilment
                                      </h5>
                                      <span>
                                        {acceptedSolution &&
                                          acceptedSolution.solution
                                          ? acceptedSolution.solution?.data.summary?.new_weight_requirement_fulfilled_percentage.toFixed(
                                            3
                                          )
                                          : ""}{" "}
                                        {acceptedSolution &&
                                          acceptedSolution.solution &&
                                          acceptedSolution.solution?.data.summary
                                            ?.units?.fulfilled_requirement_weight
                                          ? capitalize(
                                            weightUnit[
                                              acceptedSolution.solution?.data
                                                .summary?.units
                                                ?.fulfilled_requirement_weight
                                            ].displayName
                                          )
                                          : "T"}
                                      </span>
                                    </div>
                                  </Col>
                                </Row>

                                <Row span={24}>
                                  <Col span={12}>
                                    <div className={"summaryValue"}>
                                      <h5>
                                        <span className="trimCut"></span>Updated
                                        Net Trim Loss:{" "}
                                        {acceptedSolution.solution?.data.summary?.new_net_trim_loss_percentage?.toFixed(
                                          3
                                        )}{" "}
                                        %<p>Loss including edge trim</p>
                                      </h5>
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <div className={"summaryValue"}>
                                      <h5>
                                        <span className="trimBox"></span>Updated
                                        Weight:{" "}
                                        {acceptedSolution.solution?.data.summary?.new_job_card_weight?.toFixed(
                                          3
                                        )}{" "}
                                        {acceptedSolution.solution?.data.summary
                                          .units &&
                                          acceptedSolution.solution?.data.summary
                                            .units.job_card_weight
                                          ? capitalize(
                                            weightUnit[
                                              acceptedSolution.solution?.data
                                                .summary.units.job_card_weight
                                            ]?.displayName
                                          )
                                          : "T"}
                                        <p className="lesserSolution">
                                          Total weight of Job Card
                                        </p>
                                      </h5>
                                    </div>
                                  </Col>
                                </Row>
                              </>
                            )}
                            <Collapse
                              className="sub-category"
                              expandIconPosition="right"
                              defaultActiveKey={["1", "2", "3", "4"]}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <CollapsePanel
                                key="1"
                                header="General Information"
                              >
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Col span={11}>
                                    {" "}
                                    <span>Product Specifications</span>
                                    <p
                                      style={{
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      {jobCard?.jobcard.product.product_spec}
                                    </p>
                                  </Col>

                                  <Col span={11}>
                                    <span>Priority Quantity</span>
                                    <p>
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.forced_weight_requirement
                                        ? jobCard?.jobcard[
                                          `solution_${acceptedSolution.key}`
                                        ].data.summary.forced_weight_requirement.toFixed(
                                          3
                                        )
                                        : 0}{" "}
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.units
                                        ?.forced_weight_requirement
                                        ? capitalize(
                                          weightUnit[
                                            jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary?.units
                                              .forced_weight_requirement
                                          ]?.displayName
                                        )
                                        : "T"}
                                    </p>
                                  </Col>
                                </Row>
                                {isParentReelCancelled && (
                                  <Row
                                    span={24}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      padding: "10px 0px 0 0",
                                    }}
                                  >
                                    <Col span={11}>
                                      <span
                                        className="updatedText"
                                        style={{
                                          display: "flex",
                                          gap: "5px",
                                          alignItems: "center",
                                        }}
                                      >
                                        Updated Priority Qty{" "}
                                        <Styled>
                                          <Tooltip
                                            placement="bottom"
                                            title={`This is the updated priority quantity after a few sets were cancelled`}
                                            className="edit-tooltip"
                                          >
                                            <Iconmoon
                                              icon="info_new"
                                              size={14}
                                              color="black"
                                              style={{
                                                // opacity: 0.7,
                                                // marginTop: "2px",
                                                float: "right",
                                              }}
                                            />
                                          </Tooltip>
                                        </Styled>
                                      </span>
                                      <p>
                                        {jobCard?.jobcard[
                                          `solution_${acceptedSolution.key}`
                                        ].data.summary
                                          ?.new_forced_weight_requirement
                                          ? jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary.new_forced_weight_requirement.toFixed(
                                            3
                                          )
                                          : 0}{" "}
                                        {jobCard?.jobcard[
                                          `solution_${acceptedSolution.key}`
                                        ].data.summary?.units
                                          ?.new_forced_weight_requirement
                                          ? capitalize(
                                            weightUnit[
                                              jobCard?.jobcard[
                                                `solution_${acceptedSolution.key}`
                                              ].data.summary?.units
                                                .new_forced_weight_requirement
                                            ]?.displayName
                                          )
                                          : "T"}
                                      </p>
                                    </Col>
                                  </Row>
                                )}
                              </CollapsePanel>

                              <CollapsePanel key="2" header="Paper Machine">
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Paper Machine</span>
                                    <p>
                                      {jobCard?.jobcard.group.machines[0].name}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Deckle Width</span>
                                    <p>{calculateDeckleSize(jobCard)}</p>
                                  </Col>{" "}
                                </Row>{" "}
                              </CollapsePanel>
                              {isParentReelCancelled ? (
                                <>
                                  <CollapsePanel key="3" header="Rewinding">
                                    <Row
                                      span={24}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10px 0px",
                                      }}
                                    >
                                      {" "}
                                      <Col span={11}>
                                        <span
                                          className="updatedText"
                                          style={{
                                            display: "flex",
                                            gap: "5px",
                                            alignItems: "center",
                                          }}
                                        >
                                          Updated Rewinding Qty
                                          <Styled>
                                            <Tooltip
                                              placement="bottom"
                                              title={`This is the updated quantity that needs to be processed on the rewinder after a few sets were cancelled`}
                                              className="edit-tooltip"
                                            >
                                              <Iconmoon
                                                icon="info_new"
                                                size={14}
                                                color="black"
                                                style={{
                                                  // opacity: 0.7,
                                                  // marginTop: "2px",
                                                  float: "right",
                                                }}
                                              />
                                            </Tooltip>
                                          </Styled>
                                        </span>{" "}
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.new_net_rewinding_quantity
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary.new_net_rewinding_quantity.toFixed(
                                              3
                                            )
                                            : 0}{" "}
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            ?.new_net_rewinding_quantity
                                            ? capitalize(
                                              weightUnit[
                                                jobCard?.jobcard[
                                                  `solution_${acceptedSolution.key}`
                                                ].data.summary?.units
                                                  .new_net_rewinding_quantity
                                              ]?.displayName
                                            )
                                            : "T"}
                                        </p>
                                      </Col>
                                      <Col span={11}>
                                        <span
                                          className="updatedText"
                                          style={{
                                            display: "flex",
                                            gap: "5px",
                                            alignItems: "center",
                                          }}
                                        >
                                          Updated Trim Loss
                                          <Styled>
                                            <Tooltip
                                              placement="bottom"
                                              title={`This is the updated trim loss of rewinding after a few sets were cancelled`}
                                              className="edit-tooltip"
                                            >
                                              <Iconmoon
                                                icon="info_new"
                                                size={14}
                                                color="black"
                                                style={{
                                                  // opacity: 0.7,
                                                  // marginTop: "2px",
                                                  float: "right",
                                                }}
                                              />
                                            </Tooltip>
                                          </Styled>
                                        </span>
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.new_rewinding_net_trim_loss
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary.new_rewinding_net_trim_loss.toFixed(
                                              3
                                            )
                                            : 0}{" "}
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            ?.new_rewinding_net_trim_loss
                                            ? capitalize(
                                              weightUnit[
                                                jobCard?.jobcard[
                                                  `solution_${acceptedSolution.key}`
                                                ].data.summary?.units
                                                  .new_rewinding_net_trim_loss
                                              ]?.displayName
                                            )
                                            : "T"}
                                        </p>
                                      </Col>{" "}
                                    </Row>{" "}
                                    <Row
                                      span={24}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10px 0px",
                                      }}
                                    >
                                      {" "}
                                      <Col span={11}>
                                        <span>Rewinder</span>{" "}
                                        <p>
                                          {
                                            jobCard?.jobcard?.group.machines?.filter(
                                              (item) =>
                                                item.machine_type === "rewinder"
                                            )[0]?.rewinder_name
                                          }
                                        </p>
                                      </Col>
                                      <Col span={11}>
                                        <span
                                          className="updatedText"
                                          style={{
                                            display: "flex",
                                            gap: "5px",
                                            alignItems: "center",
                                          }}
                                        >
                                          Updated Processed Order
                                          <Styled>
                                            <Tooltip
                                              placement="bottom"
                                              title={`This is the updated order quantity fulfilled on the rewinder after a few sets were cancelled`}
                                              className="edit-tooltip"
                                            >
                                              <Iconmoon
                                                icon="info_new"
                                                size={14}
                                                color="black"
                                                style={{
                                                  // opacity: 0.7,
                                                  // marginTop: "2px",
                                                  float: "right",
                                                }}
                                              />
                                            </Tooltip>
                                          </Styled>
                                        </span>
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.new_rewinder_processed_order_quantity
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary.new_rewinder_processed_order_quantity.toFixed(
                                              3
                                            )
                                            : 0}{" "}
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            ?.new_rewinder_processed_order_quantity
                                            ? capitalize(
                                              weightUnit[
                                                jobCard?.jobcard[
                                                  `solution_${acceptedSolution.key}`
                                                ].data.summary?.units
                                                  .new_rewinder_processed_order_quantity
                                              ]?.displayName
                                            )
                                            : "T"}
                                        </p>
                                      </Col>{" "}
                                    </Row>{" "}
                                    <Row
                                      span={24}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10px 0px",
                                      }}
                                    >
                                      {" "}
                                      <Col span={11}>
                                        <span
                                          className="updatedText"
                                          style={{
                                            display: "flex",
                                            gap: "5px",
                                            alignItems: "center",
                                          }}
                                        >
                                          Updated Unique Sets
                                          <Styled>
                                            <Tooltip
                                              placement="bottom"
                                              className="edit-tooltip"
                                              title="This is the updated number of unique sets after a few sets were cancelled"
                                            >
                                              <Iconmoon
                                                icon="info_new"
                                                size={14}
                                                color="black"
                                                style={{
                                                  // opacity: 0.7,
                                                  // marginTop: "2px",
                                                  float: "right",
                                                }}
                                              />
                                            </Tooltip>
                                          </Styled>
                                        </span>{" "}
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.new_unique_rewinding_partitions
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary
                                              .new_unique_rewinding_partitions
                                            : 0}{" "}
                                        </p>
                                      </Col>
                                      <Col span={11}>
                                        <span
                                          className="updatedText"
                                          style={{
                                            display: "flex",
                                            gap: "5px",
                                            alignItems: "center",
                                          }}
                                        >
                                          Updated Total Sets
                                          <Styled>
                                            <Tooltip
                                              placement="bottom"
                                              title={`This is the updated number of total sets to be processed on this rewinder after a few sets were cancelled`}
                                              className="edit-tooltip"
                                            >
                                              <Iconmoon
                                                icon="info_new"
                                                size={14}
                                                color="black"
                                                style={{
                                                  // opacity: 0.7,
                                                  // marginTop: "2px",
                                                  float: "right",
                                                }}
                                              />
                                            </Tooltip>
                                          </Styled>
                                        </span>
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.new_total_rewinding_partitions
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary
                                              .new_total_rewinding_partitions
                                            : 0}{" "}
                                        </p>
                                      </Col>{" "}
                                    </Row>{" "}
                                  </CollapsePanel>
                                  <CollapsePanel key="4" header="Cutting">
                                    <Row
                                      span={24}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10px 0px",
                                      }}
                                    >
                                      {" "}
                                      <Col span={11}>
                                        <span
                                          className="updatedText"
                                          style={{
                                            display: "flex",
                                            gap: "5px",
                                            alignItems: "center",
                                          }}
                                        >
                                          Updated Cutting Qty
                                          <Styled>
                                            <Tooltip
                                              placement="bottom"
                                              title={`This is the updated quantity that needs to be processed on the cutter after a few sets were cancelled`}
                                              className="edit-tooltip"
                                            >
                                              <Iconmoon
                                                icon="info_new"
                                                size={14}
                                                color="black"
                                                style={{
                                                  // opacity: 0.7,
                                                  // marginTop: "2px",
                                                  float: "right",
                                                }}
                                              />
                                            </Tooltip>
                                          </Styled>
                                        </span>{" "}
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.new_net_cutting_quantity
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary.new_net_cutting_quantity.toFixed(
                                              3
                                            )
                                            : 0}{" "}
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            ?.new_net_cutting_quantity
                                            ? capitalize(
                                              weightUnit[
                                                jobCard?.jobcard[
                                                  `solution_${acceptedSolution.key}`
                                                ].data.summary?.units
                                                  .new_net_cutting_quantity
                                              ]?.displayName
                                            )
                                            : "T"}
                                        </p>
                                      </Col>
                                      <Col span={11}>
                                        <span
                                          className="updatedText"
                                          style={{
                                            display: "flex",
                                            gap: "5px",
                                            alignItems: "center",
                                          }}
                                        >
                                          Updated Trim Loss
                                          <Styled>
                                            <Tooltip
                                              placement="bottom"
                                              title={`This is the updated trim loss of cutting after a few sets were cancelled`}
                                              className="edit-tooltip"
                                            >
                                              <Iconmoon
                                                icon="info_new"
                                                size={14}
                                                color="black"
                                                style={{
                                                  // opacity: 0.7,
                                                  // marginTop: "2px",
                                                  float: "right",
                                                }}
                                              />
                                            </Tooltip>
                                          </Styled>
                                        </span>
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.new_cutting_net_trim_loss
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary.new_cutting_net_trim_loss.toFixed(
                                              3
                                            )
                                            : 0}{" "}
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            ?.new_cutting_net_trim_loss
                                            ? capitalize(
                                              weightUnit[
                                                jobCard?.jobcard[
                                                  `solution_${acceptedSolution.key}`
                                                ].data.summary?.units
                                                  .new_cutting_net_trim_loss
                                              ]?.displayName
                                            )
                                            : "T"}
                                        </p>
                                      </Col>{" "}
                                    </Row>{" "}
                                    <Row
                                      span={24}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10px 0px",
                                      }}
                                    >
                                      {" "}
                                      <Col span={11}>
                                        <span>Cutter</span>{" "}
                                        <p>
                                          {
                                            jobCard?.jobcard?.group.machines?.filter(
                                              (item) =>
                                                item.machine_type === "cutter"
                                            )[0]?.cutter_name
                                          }
                                        </p>
                                      </Col>
                                      <Col span={11}>
                                        <span
                                          className="updatedText"
                                          style={{
                                            display: "flex",
                                            gap: "5px",
                                            alignItems: "center",
                                          }}
                                        >
                                          Updated Processed Order
                                          <Styled>
                                            <Tooltip
                                              placement="bottom"
                                              title={`This is the updated order quantity fulfilled on the cutter after a few sets were cancelled`}
                                              className="edit-tooltip"
                                            >
                                              <Iconmoon
                                                icon="info_new"
                                                size={14}
                                                color="black"
                                                style={{
                                                  // opacity: 0.7,
                                                  // marginTop: "2px",
                                                  float: "right",
                                                }}
                                              />
                                            </Tooltip>
                                          </Styled>
                                        </span>
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.new_cutting_processed_order_quantity
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary.new_cutting_processed_order_quantity.toFixed(
                                              3
                                            )
                                            : 0}{" "}
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            ?.new_cutting_processed_order_quantity
                                            ? capitalize(
                                              weightUnit[
                                                jobCard?.jobcard[
                                                  `solution_${acceptedSolution.key}`
                                                ].data.summary?.units
                                                  .new_cutting_processed_order_quantity
                                              ]?.displayName
                                            )
                                            : "T"}
                                        </p>
                                      </Col>{" "}
                                    </Row>{" "}
                                    <Row
                                      span={24}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10px 0px",
                                      }}
                                    >
                                      {" "}
                                      <Col span={11}>
                                        <span
                                          className="updatedText"
                                          style={{
                                            display: "flex",
                                            gap: "5px",
                                            alignItems: "center",
                                          }}
                                        >
                                          Updated Unique Sets
                                          <Styled>
                                            <Tooltip
                                              placement="bottom"
                                              title={`This is the updated number of unique sets after a few sets were cancelled`}
                                              className="edit-tooltip"
                                            >
                                              <Iconmoon
                                                icon="info_new"
                                                size={14}
                                                color="black"
                                                style={{
                                                  // opacity: 0.7,
                                                  // marginTop: "2px",
                                                  float: "right",
                                                }}
                                              />
                                            </Tooltip>
                                          </Styled>
                                        </span>{" "}
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.new_unique_cutting_patterns
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary
                                              .new_unique_cutting_patterns
                                            : 0}{" "}
                                        </p>
                                      </Col>
                                      <Col span={11}>
                                        <span
                                          className="updatedText"
                                          style={{
                                            display: "flex",
                                            gap: "5px",
                                            alignItems: "center",
                                          }}
                                        >
                                          Updated Sets
                                          <Styled>
                                            <Tooltip
                                              placement="bottom"
                                              title={`This is the updated number of total sets to be processed on this cutter after a few sets were cancelled`}
                                              className="edit-tooltip"
                                            >
                                              <Iconmoon
                                                icon="info_new"
                                                size={14}
                                                color="black"
                                                style={{
                                                  // opacity: 0.7,
                                                  // marginTop: "2px",
                                                  float: "right",
                                                }}
                                              />
                                            </Tooltip>
                                          </Styled>
                                        </span>
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.new_total_cutting_partitions
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary
                                              .new_total_cutting_partitions
                                            : 0}{" "}
                                        </p>
                                      </Col>{" "}
                                    </Row>{" "}
                                  </CollapsePanel>
                                </>
                              ) : (
                                <>
                                  <CollapsePanel key="3" header="Rewinding">
                                    <Row
                                      span={24}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10px 0px",
                                      }}
                                    >
                                      {" "}
                                      <Col span={11}>
                                        <span>Net Rewinding Qty</span>{" "}
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.net_rewinding_quantity
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary.net_rewinding_quantity.toFixed(
                                              3
                                            )
                                            : 0}{" "}
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            ?.net_rewinding_quantity
                                            ? capitalize(
                                              weightUnit[
                                                jobCard?.jobcard[
                                                  `solution_${acceptedSolution.key}`
                                                ].data.summary?.units
                                                  .net_rewinding_quantity
                                              ]?.displayName
                                            )
                                            : "T"}
                                        </p>
                                      </Col>
                                      <Col span={11}>
                                        <span>Trim Loss</span>
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.rewinding_net_trim_loss
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary.rewinding_net_trim_loss.toFixed(
                                              3
                                            )
                                            : 0}{" "}
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            ?.rewinding_net_trim_loss
                                            ? capitalize(
                                              weightUnit[
                                                jobCard?.jobcard[
                                                  `solution_${acceptedSolution.key}`
                                                ].data.summary?.units
                                                  .rewinding_net_trim_loss
                                              ]?.displayName
                                            )
                                            : "T"}
                                        </p>
                                      </Col>{" "}
                                    </Row>{" "}
                                    <Row
                                      span={24}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10px 0px",
                                      }}
                                    >
                                      {" "}
                                      <Col span={11}>
                                        <span>Rewinder</span>{" "}
                                        <p>
                                          {
                                            jobCard?.jobcard?.group.machines?.filter(
                                              (item) =>
                                                item.machine_type === "rewinder"
                                            )[0]?.rewinder_name
                                          }
                                        </p>
                                      </Col>
                                      <Col span={11}>
                                        <span>Processed Order Qty</span>
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.rewinder_processed_order_quantity
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary.rewinder_processed_order_quantity.toFixed(
                                              3
                                            )
                                            : 0}{" "}
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            ?.rewinder_processed_order_quantity
                                            ? capitalize(
                                              weightUnit[
                                                jobCard?.jobcard[
                                                  `solution_${acceptedSolution.key}`
                                                ].data.summary?.units
                                                  .rewinder_processed_order_quantity
                                              ]?.displayName
                                            )
                                            : "T"}
                                        </p>
                                      </Col>{" "}
                                    </Row>{" "}
                                    <Row
                                      span={24}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10px 0px",
                                      }}
                                    >
                                      {" "}
                                      <Col span={11}>
                                        <span>Number of Unique Sets</span>{" "}
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.unique_rewinding_partitions
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary
                                              .unique_rewinding_partitions
                                            : 0}{" "}
                                        </p>
                                      </Col>
                                      <Col span={11}>
                                        <span>Total Number of Sets</span>
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.total_rewinding_partitions
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary
                                              .total_rewinding_partitions
                                            : 0}{" "}
                                        </p>
                                      </Col>{" "}
                                    </Row>{" "}
                                  </CollapsePanel>
                                  <CollapsePanel key="4" header="Cutting">
                                    <Row
                                      span={24}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10px 0px",
                                      }}
                                    >
                                      {" "}
                                      <Col span={11}>
                                        <span>Net Cutting Qty</span>{" "}
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.net_cutting_quantity
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary.net_cutting_quantity.toFixed(
                                              3
                                            )
                                            : 0}{" "}
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            ?.net_cutting_quantity
                                            ? capitalize(
                                              weightUnit[
                                                jobCard?.jobcard[
                                                  `solution_${acceptedSolution.key}`
                                                ].data.summary?.units
                                                  .net_cutting_quantity
                                              ]?.displayName
                                            )
                                            : "T"}
                                        </p>
                                      </Col>
                                      <Col span={11}>
                                        <span>Trim Loss</span>
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.cutting_net_trim_loss
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary.cutting_net_trim_loss.toFixed(
                                              3
                                            )
                                            : 0}{" "}
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            ?.cutting_net_trim_loss
                                            ? capitalize(
                                              weightUnit[
                                                jobCard?.jobcard[
                                                  `solution_${acceptedSolution.key}`
                                                ].data.summary?.units
                                                  .cutting_net_trim_loss
                                              ]?.displayName
                                            )
                                            : "T"}
                                        </p>
                                      </Col>{" "}
                                    </Row>{" "}
                                    <Row
                                      span={24}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10px 0px",
                                      }}
                                    >
                                      {" "}
                                      <Col span={11}>
                                        <span>Cutter</span>{" "}
                                        <p>
                                          {
                                            jobCard?.jobcard?.group.machines?.filter(
                                              (item) =>
                                                item.machine_type === "cutter"
                                            )[0]?.cutter_name
                                          }
                                        </p>
                                      </Col>
                                      <Col span={11}>
                                        <span>Processed Order Qty</span>
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.cutting_processed_order_quantity
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary.cutting_processed_order_quantity.toFixed(
                                              3
                                            )
                                            : 0}{" "}
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            ?.cutting_processed_order_quantity
                                            ? capitalize(
                                              weightUnit[
                                                jobCard?.jobcard[
                                                  `solution_${acceptedSolution.key}`
                                                ].data.summary?.units
                                                  .cutting_processed_order_quantity
                                              ]?.displayName
                                            )
                                            : "T"}
                                        </p>
                                      </Col>{" "}
                                    </Row>{" "}
                                    <Row
                                      span={24}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10px 0px",
                                      }}
                                    >
                                      {" "}
                                      <Col span={11}>
                                        <span>Number of Unique Sets</span>{" "}
                                        <p>
                                          {jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary
                                            ?.unique_cutting_patterns
                                            ? jobCard?.jobcard[
                                              `solution_${acceptedSolution.key}`
                                            ].data.summary
                                              .unique_cutting_patterns
                                            : 0}{" "}
                                        </p>
                                      </Col>
                                      {/* <Col span={11}>
                                    <span>Total Number of Sets</span>
                                    <p>
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.total_cutting_partitions
                                        ? jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary.total_cutting_partitions
                                        : 0}{" "}
                                    </p>
                                  </Col>{" "} */}
                                    </Row>{" "}
                                  </CollapsePanel>
                                </>
                              )}
                            </Collapse>

                            {jobCard.jobcard.group.merged && (
                              <div className="alertmsd">
                                <h4>Merge Orders</h4>
                                <AlertContainer
                                  color="blue"
                                  icon={alertBlue}
                                  msg="This Jobcard has merged orders"
                                />
                              </div>
                            )}
                            {jobCard.state == "rejected" && (
                              <div className="alertmsd">
                                <h4>Approver Remarks</h4>
                                <AlertContainer
                                  color="red"
                                  icon={alertRed}
                                  msg={
                                    jobCard.comments.length
                                      ? jobCard.comments
                                      : `Approver remarks does not have any data`
                                  }
                                />
                              </div>
                            )}
                          </div>
                        </Panes>
                        <Panes
                          tab={
                            <span>
                              Size Fulfilment
                              {activeTab == "2" && (
                                <Button
                                  key="1"
                                  style={{ border: "none" }}
                                  onClick={(e) =>
                                    setSizeExpanded(!sizeExpanded)
                                  }
                                >
                                  <Iconmoon
                                    icon={
                                      sizeExpanded
                                        ? "contract_arrow"
                                        : "expand_arrow"
                                    }
                                    size={14}
                                    color="#EA4E2C"
                                  />
                                </Button>
                              )}
                            </span>
                          }
                          key="2"
                        >
                          {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
                      color="blue"
                      icon={warningjob}
                      msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
                      removeBottomMargin={true}
                      jobCard = {true}
                    /> : ''} */}
                          <TableLayoutData>
                            <div
                              className="tableDataFormat  "
                              style={{ marginTop: "25px" }}
                            >
                              <Table
                                columns={sizeFulfillmentColumnsHead}
                                // dataSource={sizeFulfillmentDetailsList?.filter(
                                //   (order) => order.fulflilledWeight.split(" ")[0] > 0
                                // )}
                                dataSource={sizeFulfillmentDetailsList}
                                onChange={onChange}
                                scroll={{ x: 1200 }}
                                rowClassName={(record) =>
                                  record.priority && "true"
                                }
                                pagination={{
                                  total: sizeFulfillmentDetailsList?.length,
                                  showTitle: false,
                                  showSizeChanger: true,
                                  showTotal: (total, range) =>
                                    `Showing ${range[0]}-${range[1]} of ${total} results`,
                                  pageSizeOptions: [10, 20, 50, 100],
                                  current: currentPage,
                                  pageSize: pageSize,
                                  // showSizeChanger: true,
                                }}
                              />
                            </div>
                          </TableLayoutData>
                        </Panes>
                        <Panes
                          tab={
                            <span>
                              Order Fulfillment
                              {activeTab == "3" && (
                                <Button
                                  key="1"
                                  style={{ border: "none" }}
                                  onClick={(e) =>
                                    setSizeExpanded(!sizeExpanded)
                                  }
                                >
                                  <Iconmoon
                                    icon={
                                      sizeExpanded
                                        ? "contract_arrow"
                                        : "expand_arrow"
                                    }
                                    size={14}
                                    color="#EA4E2C"
                                  />
                                </Button>
                              )}
                            </span>
                          }
                          key="3"
                        >
                          <TableLayoutData>
                            <div
                              className="tableDataFormat  "
                              style={{ marginTop: "25px" }}
                            >
                              {" "}
                              {isFetchingData ? (
                                <TableShimmer
                                  header={orderFulfillmentColumnsHead}
                                  scroll={1600}
                                />
                              ) : (
                                <Table
                                  columns={orderFulfillmentColumnsHead}
                                  dataSource={orderDetailsList}
                                  onChange={onChange}
                                  scroll={{ x: 1900 }}
                                  rowClassName={(record) =>
                                    record.priority && "true"
                                  }
                                  pagination={{
                                    current: currentPage,
                                    pageSize: pageSize,
                                    total: orderDetailsList?.length,
                                    onChange: onPaginationChange,
                                    showSizeChanger: true,
                                    // showQuickJumper: true,
                                    // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                    showTotal: (total, range) =>
                                      `Showing ${range[0]}-${range[1]} of ${total} results`,
                                    pageSizeOptions: [10, 20, 50, 100],
                                  }}
                                />
                              )}
                            </div>
                          </TableLayoutData>
                        </Panes>
                        <Panes
                          tab={
                            <span>
                              Intermediate Reels
                              {activeTab == "5" && (
                                <Button
                                  key="1"
                                  style={{ border: "none" }}
                                  onClick={(e) =>
                                    setSizeExpanded(!sizeExpanded)
                                  }
                                >
                                  <Iconmoon
                                    icon={
                                      sizeExpanded
                                        ? "contract_arrow"
                                        : "expand_arrow"
                                    }
                                    size={14}
                                    color="#EA4E2C"
                                  />
                                </Button>
                              )}
                            </span>
                          }
                          key="5"
                        // disabled={solutionSummary?.solution1.exception}
                        >
                          {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
                      color="blue"
                      icon={warningjob}
                      msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
                      removeBottomMargin={true}
                      jobCard = {true}
                    /> : ''} */}
                          <TableLayoutData>
                            <div
                              className="tableDataFormat"
                              style={{ marginTop: "25px" }}
                            >
                              <Table
                                columns={intermediateColumnsHead}
                                dataSource={intermediateData}
                                onChange={onChange}
                                scroll={{ x: 1200 }}
                                rowClassName={(record) =>
                                  record.priority && "true"
                                }
                                pagination={{
                                  current: currentPage,
                                  pageSize: pageSize,
                                  total: intermediateData?.length,
                                  onChange: onPaginationChange,
                                  showSizeChanger: true,
                                  // showQuickJumper: true,
                                  // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                  showTotal: (total, range) =>
                                    `Showing ${range[0]}-${range[1]} of ${total} results`,
                                  pageSizeOptions: [10, 20, 50, 100],
                                }}
                              />
                            </div>
                          </TableLayoutData>
                        </Panes>
                        {(jobCard.state === "in_production" ||
                          jobCard.state === "complete" ||
                          jobCard.state === "hold") && (
                            <Panes tab="Map Rewinding" key="6">
                              <TableLayoutData>
                                <div
                                  className="tableDataFormat "
                                  style={{ marginTop: "25px" }}
                                >
                                  {isMapJumboLoading ? (
                                    <TableShimmer
                                      header={mapRewindingColumnsHead}
                                      scroll={2000}
                                    />
                                  ) : (
                                    <Table
                                      columns={mapRewindingColumnsHead}
                                      dataSource={jumboReelData}
                                      onChange={onChange}
                                      scroll={{
                                        x: window.screen.width < 1500 && 1350,
                                      }}
                                      pagination={{
                                        total: jumboReelData
                                          ? jumboReelData.length
                                          : 0,
                                        showTitle: false,
                                        showTotal: (total, range) =>
                                          `Showing ${range[0]}-${range[1]} of ${total} results`,
                                        pageSizeOptions: [10, 20, 50, 100],
                                        current: currentPage,
                                        pageSize: pageSize,
                                      }}
                                    />
                                  )}
                                </div>
                              </TableLayoutData>
                            </Panes>
                          )}
                        {(jobCard.state === "in_production" ||
                          jobCard.state === "complete" ||
                          jobCard.state === "hold") && (
                            <Panes tab="Map Cutting" key="7">
                              <TableLayoutData>
                                <div
                                  className="tableDataFormat "
                                  style={{ marginTop: "25px" }}
                                >
                                  {isMapCuttingLoading ? (
                                    <TableShimmer
                                      header={mapCuttingColumnsHead}
                                      scroll={2000}
                                    />
                                  ) : (
                                    <Table
                                      columns={mapCuttingColumnsHead}
                                      dataSource={cuttingJumboReelData}
                                      onChange={onChange}
                                      scroll={{
                                        x: window.screen.width < 1500 && 1370,
                                      }}
                                      pagination={{
                                        total: cuttingJumboReelData
                                          ? cuttingJumboReelData.length
                                          : 0,
                                        showTitle: false,
                                        showTotal: (total, range) =>
                                          `Showing ${range[0]}-${range[1]} of ${total} results`,
                                        pageSizeOptions: [10, 20, 50, 100],
                                        current: currentPage,
                                        pageSize: pageSize,
                                      }}
                                    />
                                  )}
                                </div>
                              </TableLayoutData>
                            </Panes>
                          )}
                      </Tabs>
                    </Col>
                  </Row>
                </div>{" "}
              </SolutionContainer>
            </DetailFields>
            {/* approve Modal */}
            <ConfirmationModal
              visible={isVisibleApproveModal}
              icon={warning}
              cancelAction={approveModalClose}
              confirmAction={approveModalConfirm}
              param={jobId}
            >
              <span>Are you sure?</span>
              <p>
                You are about to approve this job card, once approved this job
                card can’t be altered later
              </p>
            </ConfirmationModal>

            {/* <ConfirmationModal
          visible={visibleStartProduction}
          icon={warning}
          cancelAction={closeStartProductionModal}
          confirmAction={startProductionModalConfirm}
          param={jobId}
        >
          <span>Start production ?</span>
          <p>
            The job card will move to the production. Are you sure you want to
            proceed?
          </p>
        </ConfirmationModal> */}

            {/* <ConfirmationModal
          visible={visibleCancelProduction}
          icon={warning}
          cancelAction={closeCancelProductionModal}
          confirmAction={cancelProductionModalConfirm}
          param={jobId}
        >
          <span>Are you sure?</span>
          <p>
            You are about to cancel the production for this jobcard, are you
            sure you want to continue?
          </p>
        </ConfirmationModal> */}

            {/* <ConfirmationModal
          visible={visibleMarkCompletedModal}
          icon={warning}
          cancelAction={closeMarkCompletedModal}
          confirmAction={markCompletedModalConfirm}
          param={jobId}
        >
          <span>Are you sure?</span>
          <p>
            You are about to mark this job as completed, are you sure you want
            to continue?
          </p>
        </ConfirmationModal> */}

            <JobCardRejectDrawer
              visible={visibleRejectDrawer}
              onClose={closeRejectDrawer}
              onCloseGrade={closeRejectDrawer}
              jobId={jobId}
              setReFetch={setReFetch}
              setActionResponse={setActionResponse}
              showToaster={showToaster}
              jobcardCode={jobcardCode}
            />

            {viewParentReelJobCardDrawer && (
              <ParentReelJobCardDrawer
                parentReelId={selectedParentReel}
                visible={viewParentReelJobCardDrawer}
                onCloseParentReelCancel={onCloseParentReelCancel}
                onClose={closeParentReelJobCard}
                isProduced={isProduced}
                tabNo={activeTab}
                jobcardType={jobcardType}
                pageType={"deckle"}
              />
            )}

            {toaster && actionResponse.msg && (
              <AlertContainer
                color={`${actionResponse.error ? "red" : "green"} toaster`}
                icon={actionResponse.error ? alertRed : alertGreen}
                msg={capitalize(actionResponse.msg)}
              />
            )}

            <ViewDeckleOrder
              selectedOrderNo={selectedOrderNo}
              // showButton={true}
              visible={viewOrder}
              onClose={closeViewDrawer}
              onCloseGrade={closeViewDrawer}
              category={selectedOrder?.category}
            />
          </ResultWrap>
        </>
      )}
    </RightLayoutContainer>
  ) : (
    <RightLayoutContainer>
      {/* {console.log("Jobcard", jobCard)} */}
      <PageTitleComp className="marginRightAdg" style={{ borderBottom: "0px" }}>
        <PageHeader
          ghost={false}
          onBack={() => navigate("../job-cards")}
          // onBack={() => navigate(-2)}
          title="Job Card Details"
        ></PageHeader>
      </PageTitleComp>
      <ResultWrap>
        <DetailFields
          className="jobCardView"
          style={{ justifyContent: "flex-start" }}
        >
          <PageTitleComp style={{ borderBottom: "0" }}>
            <PageHeader
              ghost={false}
              // title={`Job Card ${jobCard.id}`}
              className="jobCardList-Grid"
            ></PageHeader>

            <div
              className={`jobCardList ${"fullWidth"}`}
              style={{
                alignSelf: "center",
                display: "flex",
                marginTop:
                  isParentReelCancelled && activeTab >= 2 ? "20px" : "34px",
                // alignContent:'top'
              }}
            >
              {/* <JobCardColorStatus>
                <div className="statusVal" dataval={jobCard.state}>
                  {jobcardState(jobCard.state)}
                </div>
              </JobCardColorStatus> */}
            </div>
            {isParentReelCancelled && activeTab >= 2 && (
              <Col span={9} style={{ display: "absolute" }}>
                <div
                  className="cancelledSetMessage"
                  style={{
                    display: "flex",
                    justifyContent: "center", // Center content horizontally
                    alignItems: "center", // Center content vertically
                    marginTop: "25px",
                    borderRadius: "4px",
                    backgroundColor: "#f4f0ec",
                    padding: "4px 6px",
                    opacity: 0.95,
                  }}
                >
                  {/* <div className="centerAlignMeVertically" style={{ padding: "2px 6px 0px 3px" }}>
    <Iconmoon icon="warning_new" size={20} style={{ color: "#808080" }} />
  </div>
  <span style={{ fontSize: "14px", color: "#555555" }}>
    A few sets were cancelled in this job card. Hence, fulfilled
    quantity might not be accurate for the cancelled sets.
  </span> */}
                </div>
              </Col>
            )}
          </PageTitleComp>

          <div className="MatchResult JobResulted">
            <Row span={24}>
              <Col
                span={15}
                className="pipeBlock"
                style={{
                  paddingRight: "20px",
                  transform:
                    isParentReelCancelled && activeTab >= 2
                      ? "translateY(-14px)"
                      : "",
                }}
              >
                <div
                  style={{
                    paddingTop: "50px",
                    paddingBottom: "50px",
                  }}
                >
                  <CardShimmerStyle>
                    <div
                      style={{
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                        opacity: "70%",
                        width: "341.62px",
                        marginTop: "60px",
                      }}
                    >
                      <Skeleton.Image
                        active={true}
                        style={{
                          width: "105px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      />
                    </div>
                  </CardShimmerStyle>
                  {/* <div 
            style={{
                fontFamily: "var(--sf-pro-display-m)",
                fontWeight: "500",
                fontSize: "14px",
                height: "16px",
                color: "#A19F9D",
                paddingTop: "20px",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: "150px",
                textAlign: "center",
           }}
           >{heading}
            </div> */}
                  <div
                    style={{
                      paddingTop: "30px",
                      fontFamily: "var(--sf-pro-display-m)",
                      fontWeight: "400",
                      fontSize: "12px",
                      height: "20px",
                      color: "#A19F9D",
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto",
                      width: "311px",
                      textAlign: "center",
                    }}
                  >
                    {"Fetching jobcard details"}
                  </div>
                </div>
              </Col>
              <Col span={9} className="colLayoutBlock leftPostTab">
                <Tabs
                  defaultActiveKey="1"
                  activeKey={activeTab}
                  onChange={tabChange}
                  className="topPostTab innerPostTab"
                >
                  <Panes tab="Summary" key="1">
                    <div className="lossValue">
                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "100px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "100px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                      </Row>

                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "100px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "100px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                      </Row>

                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "60px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "100%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "60px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                      </Row>
                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px", backgroundColor: "white" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "70%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "20px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={"summaryValue"}
                            style={{ padding: "0px", backgroundColor: "white" }}
                          >
                            <CardShimmerStyle>
                              <div style={{ width: "70%", display: "flex" }}>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    width: "100%",
                                  }}
                                >
                                  <Skeleton.Button
                                    active={true}
                                    style={{ height: "20px" }}
                                  ></Skeleton.Button>
                                </div>
                              </div>
                            </CardShimmerStyle>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Panes>
                  <Panes tab="Size Fulfilment" key="2">
                    {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
                      color="blue"
                      icon={warningjob}
                      msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
                      removeBottomMargin={true}
                      jobCard = {true}
                    /> : ''} */}
                    <TableLayoutData>
                      <div
                        className="tableDataFormat  "
                        style={{ marginTop: "25px" }}
                      >
                        <TableShimmer
                          header={sizeFulfillmentColumnsHead}
                          scroll={1300}
                        />
                      </div>
                    </TableLayoutData>
                  </Panes>
                  <Panes tab="Order Fulfilment" key="3">
                    <TableLayoutData>
                      <div
                        className="tableDataFormat  "
                        style={{ marginTop: "25px" }}
                      >
                        <TableShimmer header={orderFulfillmentColumnsHead} scroll={1600} />
                      </div>
                    </TableLayoutData>
                  </Panes>
                  1
                  <Panes
                    tab="Intermediate Reels"
                    key="5"
                  // disabled={solutionSummary?.solution1.exception}
                  >
                    {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
                      color="blue"
                      icon={warningjob}
                      msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
                      removeBottomMargin={true}
                      jobCard = {true}
                    /> : ''} */}
                    <TableLayoutData>
                      <div
                        className="tableDataFormat"
                        style={{ marginTop: "25px" }}
                      >
                        <TableShimmer
                          header={intermediateColumnsHead}
                          scroll={1300}
                        />
                      </div>
                    </TableLayoutData>
                  </Panes>
                  <Panes tab="Map Rewinding" key="6">
                    <TableLayoutData>
                      <div
                        className="tableDataFormat"
                        style={{ marginTop: "25px" }}
                      >
                        <TableShimmer
                          header={mapRewindingColumnsHead}
                          scroll={1300}
                        />
                      </div>
                    </TableLayoutData>
                  </Panes>
                  <Panes tab="Map Cutting" key="7">
                    <TableLayoutData>
                      <div
                        className="tableDataFormat"
                        style={{ marginTop: "25px" }}
                      >
                        <TableShimmer
                          header={mapCuttingColumnsHead}
                          scroll={1300}
                        />
                      </div>
                    </TableLayoutData>
                  </Panes>
                </Tabs>
              </Col>
            </Row>
          </div>
        </DetailFields>
        {/* approve Modal */}
        <ConfirmationModal
          visible={isVisibleApproveModal}
          icon={warning}
          cancelAction={approveModalClose}
          confirmAction={approveModalConfirm}
          param={jobId}
        >
          <span>Are you sure?</span>
          <p>
            You are about to approve this job card, once approved this job card
            can’t be altered later
          </p>
        </ConfirmationModal>

        {/* <ConfirmationModal
          visible={visibleStartProduction}
          icon={warning}
          cancelAction={closeStartProductionModal}
          confirmAction={startProductionModalConfirm}
          param={jobId}
        >
          <span>Start production ?</span>
          <p>
            The job card will move to the production. Are you sure you want to
            proceed?
          </p>
        </ConfirmationModal> */}

        {/* <ConfirmationModal
          visible={visibleCancelProduction}
          icon={warning}
          cancelAction={closeCancelProductionModal}
          confirmAction={cancelProductionModalConfirm}
          param={jobId}
        >
          <span>Are you sure?</span>
          <p>
            You are about to cancel the production for this jobcard, are you
            sure you want to continue?
          </p>
        </ConfirmationModal> */}

        {/* <ConfirmationModal
          visible={visibleMarkCompletedModal}
          icon={warning}
          cancelAction={closeMarkCompletedModal}
          confirmAction={markCompletedModalConfirm}
          param={jobId}
        >
          <span>Are you sure?</span>
          <p>
            You are about to mark this job as completed, are you sure you want
            to continue?
          </p>
        </ConfirmationModal> */}

        <JobCardRejectDrawer
          visible={visibleRejectDrawer}
          onClose={closeRejectDrawer}
          onCloseGrade={closeRejectDrawer}
          jobId={jobId}
          setReFetch={setReFetch}
          setActionResponse={setActionResponse}
          showToaster={showToaster}
          jobcardCode={jobcardCode}
        />

        {toaster && actionResponse.msg && (
          <AlertContainer
            color={`${actionResponse.error ? "red" : "green"} toaster`}
            icon={actionResponse.error ? alertRed : alertGreen}
            msg={capitalize(actionResponse.msg)}
          />
        )}

        <ViewDeckleOrder
          selectedOrderNo={selectedOrderNo}
          // showButton={true}
          visible={viewOrder}
          onClose={closeViewDrawer}
          onCloseGrade={closeViewDrawer}
          category={selectedOrder?.category}
        />
      </ResultWrap>
    </RightLayoutContainer>
  );
};
export default JobcardDetailsMultistage;
